export const electricityGeneration2024Every6Hours = {
  BEL: [
    58304.28, 60648.130000000005, 56384.41000000001, 56556.57000000001, 57387.72,
    57574.219999999994, 61676.439999999995, 58183.17999999999, 57888.36, 61298.55,
    61670.97, 58546.399999999994, 51763.68000000001, 59138.15, 57871.659999999996,
    57889.969999999994, 59263.779999999984, 60885.95, 60328.12000000001,
    53006.799999999996, 47257.450000000004, 49475.59, 53148.16, 48712.56, 47639.31,
    49690.04, 54221.240000000005, 55373.689999999995, 56880.630000000005, 69348.06,
    71684.87999999999, 68893.38, 60559.729999999996, 81118.56, 82869.07999999999,
    69165.84, 58195.34, 74688.9, 71325.2, 63175.8, 57598.02999999999, 73517.91,
    73668.98000000001, 65616.59000000001, 58672.29999999999, 67799.96, 62356.55,
    56449.08999999999, 46544.74, 54116.58, 51080.17, 50954.880000000005, 49289.72,
    51851.55, 52803.8, 55483.799999999996, 53231.94, 68723.22, 70744.5,
    62383.119999999995, 53619.31, 73564.87, 72357.20000000001, 62701.92, 49052.48,
    58931.35, 61847.729999999996, 56537.86000000001, 49004.02, 68730.27,
    65360.92000000001, 55753.89, 50016.49, 66061.44, 66581.62, 60182.76999999999,
    50307.40999999999, 59107.39, 63757.479999999996, 60965.62999999999,
    56997.71000000001, 61058.469999999994, 62459.350000000006, 61152.090000000004,
    58640.84999999999, 65561.11, 66789.18, 62446.28999999999, 58086.39,
    60334.87999999999, 62763.17, 62243.74, 60642.54, 67628.34999999999,
    62585.07000000001, 53898.13, 42243.32, 50517.04000000001, 58221.92,
    57497.08000000001, 54643.09, 66447.72, 60069.13, 43970.71, 41102.97, 52025.04,
    50065.14000000001, 46394.200000000004, 44596.03, 55448.13, 54383.31999999999,
    52267.58, 45677.759999999995, 53311.28999999999, 53913.24999999999, 57091.58,
    53857.89, 58663.28, 52327.5, 41190.32000000001, 38882.17, 56663.11000000001,
    58918.55, 59199.600000000006, 49700.89, 51801.99999999999, 50695.83, 44847.43,
    53993.770000000004, 63005.09, 60760.810000000005, 57483.21, 52902.229999999996,
    54688.44, 55918.600000000006, 57130.350000000006, 55002.670000000006,
    59299.369999999995, 61735.94, 60209.2, 56545.11, 65367.17999999999, 63431.65,
    59876.59, 59004.35, 66007.86, 64419.37999999999, 61924.24, 49003.479999999996,
    44720.810000000005, 48835.73999999999, 45286.41999999999, 37829.31, 51683.1,
    54785.60999999999, 55351.5, 56133.030000000006, 63048.95, 56657.54,
    53247.89000000001, 49330.97, 46110.47, 43697.64, 42126.66, 43186.92999999999,
    44480.34999999999, 44098.54, 42048.740000000005, 41755.69, 53451.13,
    53116.73999999999, 46257.42, 50271.36, 62113.96, 57723.54, 63826.990000000005,
    59375.649999999994, 58515.579999999994, 54818.80999999999, 53467.56999999999,
    52178.4, 57686.97, 55039.840000000004, 54866.55, 49917.58, 48489.61,
    48067.520000000004, 45177.56, 40047.78, 47124.270000000004, 51123.1,
    50702.520000000004, 54955.47, 61384.70999999999, 58133.42, 45858.020000000004,
    40722.82, 53574.740000000005, 50906.95999999999, 42809.12, 39418.22,
    55162.130000000005, 61341.91999999999, 56540.409999999996, 48315.54, 58789.74,
    62407.640000000014, 59171.30999999999, 51729.44, 59384.24, 63547.75000000001,
    60093.42, 56986.09999999999, 65696.14, 61888.95, 51349.93, 43827.78, 53503.26,
    55262.99, 48866.05, 42665.31, 47895.979999999996, 54492.97, 57285.9,
    59216.69999999999, 65269.23000000001, 66995.87000000001, 59794.45,
    51171.21000000001, 63346.219999999994, 63835.78, 53307.229999999996, 46490.3,
    61373.049999999996, 60326.369999999995, 59986.5, 56348.53, 58423.07,
    57037.399999999994, 54750.36, 46037.380000000005, 67757.32999999999,
    64231.26000000001, 53677.61, 49554.25, 61809.25, 50621.61, 40395.83000000001,
    33495.15, 37384.340000000004, 40683.350000000006, 37597.25, 38936.86, 58999.28,
    60100.28, 45445.399999999994, 42343.83, 52601.58, 53286.16999999999, 50551.72,
    43701.01, 63457.990000000005, 59282.979999999996, 49253.29, 39080.15,
    56952.030000000006, 59911.79000000001, 49621.86, 43819.5, 64468.65, 62265.18,
    47732.67, 40355.03, 52961.08000000001, 50936.22, 42397.18000000001, 35355.64,
    37381.509999999995, 41179.78, 40203.79, 35328.509999999995, 42520.6, 45625.82,
    46277.2, 40855.29, 51358.47, 54254.87, 52796.77999999999, 45980.83000000001,
    51908.94, 52503.98000000001, 48064.13, 44209.14, 61630.98, 53030.07000000001,
    49583.73, 46869.159999999996, 57760.07, 56676.55, 48824.3, 39115.469999999994,
    41431.170000000006, 42209.55, 38452.659999999996, 39506.880000000005, 45743.21,
    47628.399999999994, 43222.380000000005, 35018.64, 46620.79, 50378.950000000004,
    46856.65000000001, 37880.66, 53784.83, 56104.26, 46869.799999999996,
    34055.479999999996, 52135.869999999995, 52321.100000000006, 41558.64,
    35527.73999999999, 43367.14, 46012.03, 43896.67, 44225.76000000001,
    48967.590000000004, 37650.44, 34981.56, 40497.11, 62372.52, 60730.02, 50107.78,
    50567.770000000004, 62095.100000000006, 50836.170000000006, 33983.28,
    32924.520000000004, 54768.33, 55379.83, 46060.38, 38921.15, 46017.3, 45989.22,
    44692.36, 42958.310000000005, 49702.84, 56680.88, 46771.130000000005,
    48263.89000000001, 66090.44, 65074.16, 57472.28, 48318.89000000001, 60040.7,
    54758.22, 41530.75, 34456.159999999996, 37590.15, 41707.159999999996,
    35346.07000000001, 37019.649999999994, 51914.69, 43727.810000000005, 38710.26,
    35996.95, 48541.7, 53646.19, 41886.5, 46957.270000000004, 58268.06, 58525.2,
    42227.600000000006, 44470.6, 52274.57, 60151.200000000004, 50266.61000000001,
    48347.57, 64109.770000000004, 64642.59, 46382.700000000004, 45814.25,
    60768.37999999999, 61824.299999999996, 39611.11, 41381.43, 66196.09,
    59944.14000000001, 43835.48, 43774.49, 62889.630000000005, 53151.66,
    38488.780000000006, 33466.81, 47579.57000000001, 53913.3, 43020.18, 46708.84,
    66500.12000000001, 63480.47, 49648.92, 39562.15, 55552.770000000004, 56954.1,
    45552.719999999994, 45264.97, 46057.079999999994, 42944.13, 41779.020000000004,
    39740.18, 59124.87999999999, 57842.3, 43436.99, 34477.270000000004, 56372,
    63657.97, 45219.240000000005, 30333.619999999995, 42881.88, 40795.67, 35338.24,
    40475.31, 60206.36, 58766.64, 50651.83, 50117.5, 62280.130000000005, 57082.91,
    40252.95, 38761.47, 51812.46, 50824.62, 39244.28, 37523.66, 53260.72, 48811.89,
    46264.030000000006, 48900.880000000005, 56878.72, 64633.369999999995,
    51841.21000000001, 44654.7, 57157.7, 60585.950000000004, 48605.2, 44990.61,
    64067.04, 59060.46, 43799.27, 41239.53, 60607.5, 56198.3, 47747.98, 43806.78,
    63882.03, 58127.21000000001, 49214.38, 46187.990000000005, 64989.93, 61608.52,
    44522.35, 39473.39, 55287.649999999994, 60090.97, 44683.13, 39492.549999999996,
    49419.44000000001, 47548.45, 42481.43, 36978.35, 49600.34, 45351.8, 41777.12,
    49484.74, 63275.100000000006, 63207.65999999999, 43647.94, 41764.909999999996,
    63548.659999999996, 55219.850000000006, 42274.23, 37738.12, 54227.35, 51115.63,
    41201.57, 34206.9, 58301.850000000006, 57448.8, 40913.51, 36154.229999999996,
    54303.15, 50199.659999999996, 45588.82, 52274.94, 61398.6, 65631.36, 44981.97,
    31488.179999999997, 45722.05, 39743.78, 32999.15, 27944.98, 49218.899999999994,
    40295.61, 32433.11, 31626.66, 43389.149999999994, 44323.28, 38673.21, 35185.92,
    52541.28999999999, 58288.83, 43794.630000000005, 38856.450000000004, 45997.11,
    43296.87000000001, 36888.340000000004, 32809.600000000006, 54608.97,
    51072.380000000005, 35491.77, 33255.18, 59363.3, 53314.54, 38418.62, 36852.78,
    61823.91, 59703.77999999999, 42095.51, 41452.01, 60191.56, 52108.23, 38261.79,
    37621.37, 54650.74, 53735.07, 38501.869999999995, 41937.12000000001, 63208,
    52180.43, 34881.42, 31952.5, 41966.020000000004, 43029.94, 37206.07, 33531.85,
    45380.81, 47639.14, 38135.59, 35657.64, 53255.6, 49334.65000000001, 41880.96,
    36594.43, 45760.78, 51485.79, 38180.149999999994, 35822.479999999996,
    50983.079999999994, 56244.48, 40095.85, 38834.87, 57566.659999999996,
    57322.880000000005, 39370.049999999996, 37351.200000000004, 48929.52,
    45334.90000000001, 38499.14, 41724.60999999999, 65057.81000000001, 67714.82,
    51912.969999999994, 50323.2, 64063.42, 61467.94, 42770.78999999999,
    37855.520000000004, 51689.04, 49428.06, 39045.939999999995, 35602.89,
    48263.850000000006, 53319.43, 37193.87, 39434.61, 49064.26, 55948.72, 47077.08,
    45029.07, 58828.09, 51903.149999999994, 45142.63999999999, 42086.049999999996,
    61378.67, 55872.76000000001, 53075.009999999995, 51183.32000000001,
    61480.19999999999, 60220.15, 37543.51, 35445.24, 52133.35, 54153.509999999995,
    44595.310000000005, 45988.630000000005, 54078.8, 62232.14, 50484.06,
    48567.65000000001, 52809.969999999994, 54276.49, 48630.590000000004, 43807.99,
    53923.91, 56886.18, 35583.48, 36434.32, 53035.04000000001, 55638.3, 46731.89,
    43041.70999999999, 62940.4, 63125.98, 51359.23, 38568.64, 57387.01, 57944.49,
    40952.17, 35861.200000000004, 59799.46, 56319.81999999999, 45846.189999999995,
    39242.9, 64334.299999999996, 59448.71000000001, 45457.64000000001, 39367.14,
    62214.830000000016, 56210.939999999995, 35479.18, 34013.850000000006, 67960.41,
    64199.740000000005, 36088.61, 38248.17, 56332.34, 68179.79000000001,
    45106.060000000005, 38389.99999999999, 57522.020000000004, 55010.520000000004,
    39218.68, 36897.950000000004, 55588.17, 50382.09, 38424.86, 37309.57, 62471.36,
    56082.9, 39277.9, 48001.259999999995, 58336.509999999995, 53378.35999999999,
    40307.96, 47312.13, 72028.34, 62207.36, 51848.850000000006, 48117.62, 60292.48,
    62793.2, 42419.49, 38807.12, 57260.939999999995, 53114.26, 38140.490000000005,
    34311.490000000005, 41498.71, 43483.88, 40559.23, 36974.78, 57574.270000000004,
    63202.350000000006, 42282.66, 38499.579999999994, 53240.22, 54625.420000000006,
    42631.34, 37119.759999999995, 44805.229999999996, 48979.619999999995,
    49461.100000000006, 46681.33, 55379.03000000001, 51585.899999999994, 38251.85,
    37616.2, 64566.84, 59630.03999999999, 38858.48, 37483.090000000004, 66573.64,
    61712.39, 41582.38, 38924.049999999996, 68233.81, 67505.92, 45712.95, 40728.17,
    70729.31000000001, 66324.22, 44046.49, 41168.61, 67157.02, 69930.62,
    51227.42999999999, 45023.770000000004, 70396.86, 66887.32, 43968.409999999996,
    35874.66, 63642.659999999996, 55239.42999999999, 38311.4, 36961.18, 56503.08,
    46304.18, 40030.11, 38077.06999999999, 55542.490000000005, 53346.36, 42343.2,
    39563.41, 49001.630000000005, 52850.9, 39350.2, 39414.380000000005, 46786.11,
    56976.87, 51739.18, 47719.09, 65305.92, 70850.12, 52912.99, 49287.119999999995,
    59143.899999999994, 60613.42000000001, 47272.87, 48881.329999999994, 70619.31,
    76359.39, 52031.53999999999, 44374.92, 64655.42, 58097.5, 48188.2,
    40932.979999999996, 59107.68999999999, 49197.71, 45908.2, 42530.47,
    61425.189999999995, 55562.47, 41767.689999999995, 40103.97, 63701.68000000001,
    70803.94, 52895.020000000004, 43066.46, 66497.66, 64494.25, 47347.05, 42864.2,
    51971.880000000005, 51953.090000000004, 42641.3, 43579.549999999996, 56211.79,
    57886.71000000001, 42642.79, 40402.479999999996, 65658.6, 55464.799999999996,
    40985.67, 36858.41, 65007.14, 52821.7, 43209.490000000005, 53148.079999999994,
    67504.98, 67869.77, 46462.619999999995, 36956.43, 58215.24, 58221.79, 42581.94,
    36799.23, 63553.11000000001, 62369.57, 45900.54, 39546.36, 58476.21000000001,
    57878.84, 43901.119999999995, 35977.95, 58854.219999999994, 57363.95, 37067.58,
    35760.020000000004, 46066.47, 49143.369999999995, 35462.689999999995, 35341.28,
    62830.03, 64755.86, 49802.51, 43656.880000000005, 58471.99, 53124.36, 39937.25,
    35764.729999999996, 56819.439999999995, 59726.060000000005, 39796.96, 38299.76,
    58428.939999999995, 53394.12, 44069.590000000004, 43298.6, 57707.11, 55115.23,
    41472.9, 35149.62, 49673.450000000004, 48906.490000000005, 38558.81999999999,
    33931.969999999994, 59945.68, 54751.119999999995, 35878.79, 39647.85, 66413.17,
    63587.10999999999, 39169.15, 35193.119999999995, 62011.37999999999,
    63086.72000000001, 44079.91, 38197.76, 51646.07, 58486.21000000001, 43303.41,
    36976.13, 44163.990000000005, 51830.75000000001, 39424.840000000004, 35212.67,
    55880.240000000005, 55162.99, 39255.51, 35572.92, 53871.939999999995, 57287.49,
    41169.969999999994, 33097.520000000004, 47824.97, 46306.73, 36023.81, 37094.16,
    66198.12, 63411.43000000001, 40637.93, 37382.729999999996, 63536.53999999999,
    63014.42, 43437.46, 36287.27, 51766.81, 63481.54, 44324.979999999996, 37596.71,
    59815.259999999995, 61208.90000000001, 49884.96000000001, 51590.380000000005,
    61340.14, 66121.65, 45192.53999999999, 38979.16, 64657.97, 65762.33, 37308.11,
    32742.39, 61380.68000000001, 60713.71000000001, 42179.81, 41443.88, 64282.65,
    60841.97, 44094.09, 38553.59, 58587.53, 57010.619999999995, 41692.76, 37400.53,
    48610.600000000006, 52387.53, 38980.490000000005, 35143.380000000005, 62815.64,
    68337.43000000001, 51138.1, 46357.57000000001, 45310.9, 43631.06,
    39119.07000000001, 35066.69, 54564.79, 51952.880000000005, 37492.35, 33582.27,
    51737.64, 53429.31, 37331.67, 34118.55, 62497.490000000005, 57867.7, 38871.19,
    41769.46, 63050.81, 54138.829999999994, 45590.38, 47944.52, 67013.37,
    65945.48999999999, 50096.46, 48520.24, 78478.92000000001, 72370.81000000001,
    51767.130000000005, 53469.02999999999, 67839.89, 61923.409999999996,
    48784.54000000001, 35500.9, 56990.159999999996, 54981.55000000001, 45353.09,
    38863.64, 58977.850000000006, 60020.37, 46244.99, 46106.32, 65447.89, 60921.29,
    46024.630000000005, 38049.020000000004, 62645.36, 61581.529999999984, 39923.68,
    36380.83, 62447.77999999999, 61542.549999999996, 41719.14, 41306.63,
    63408.67999999999, 59811.659999999996, 40492.229999999996, 32012.559999999998,
    44670.979999999996, 48405.14, 44660.520000000004, 41295.61, 65105.18000000001,
    57097.59, 39157.88999999999, 33932.37, 55301.329999999994, 51572.25, 33633.06,
    34577.14, 55510.18999999999, 52954.57, 40696.89, 38207.7, 49498.39,
    49919.229999999996, 44335.810000000005, 39656.39, 49102.46000000001,
    48149.37000000001, 38372.53999999999, 34148.23, 49337, 44141.00000000001,
    29525.100000000006, 29217.35, 35670.9, 35619.07, 30670.81, 26565.019999999997,
    46941.53999999999, 45694.53999999999, 32585.519999999997, 35170.76,
    62787.520000000004, 55615.100000000006, 34265.72, 34000.07, 49281.47, 53839.67,
    36265.78, 38100.270000000004, 62666.01, 56160.340000000004, 48318.31999999999,
    43997.869999999995, 67774.76, 61211.37, 41506.29, 34771.69, 50980.869999999995,
    49271.55, 38955.87, 33720.11000000001, 52635.87999999999, 44173.79,
    31523.159999999996, 28987.3, 52191.58, 45882.619999999995, 31752.7, 28680.37,
    53200.049999999996, 47141.19, 30710.240000000005, 28917.850000000002,
    43704.45999999999, 49302.48, 39167.25, 35577.780000000006, 57125.15,
    60166.899999999994, 42746.17, 35451.64, 52568.86, 58882.090000000004, 45918.68,
    38827.61, 61406.08000000001, 59119.48999999999, 41533.42, 36539.47, 60241.58,
    56084.94, 37198.979999999996, 28602.65, 51489.74, 47533.98999999999, 31739.16,
    29871.53, 39666.78, 35255.46000000001, 33718.619999999995, 35746.65,
    52498.87999999999, 50105.62000000001, 35749.420000000006, 34104.9,
    46004.04000000001, 41821.05, 35440.97, 33676.729999999996, 40412.27,
    42313.490000000005, 36341.229999999996, 39920.439999999995, 58048.57000000001,
    54313.59, 51788.149999999994, 51572.979999999996, 63321.07000000001,
    53337.88999999999, 45197.41, 39946.630000000005, 52459.25, 45859.27, 30618.43,
    29892.41, 46117.18000000001, 46341.54000000001, 45477.89, 44700.5,
    52195.240000000005, 55377.64000000001, 51317.630000000005, 50675.13, 56084.59,
    50353.46, 36702.67, 29261.190000000002, 51383.93999999999, 43282.439999999995,
    44243.810000000005, 39893.22, 58295.67, 48182.420000000006, 35171.62, 30734.46,
    54370.969999999994, 46397.719999999994, 34053, 30057.33, 54035.28,
    48397.29000000001, 38254.31, 37949.47, 52686.48, 51788.83, 42107.939999999995,
    45861.82, 56969.56, 43741.41, 35124.34, 40572.59, 53547.17, 45493.520000000004,
    46646.54, 46590.549999999996, 46813.32, 35992.58, 34900.170000000006, 44292.85,
    51545.68, 42638.57, 34539.24, 32900.49, 49044.93000000001, 41727.04,
    31952.799999999996, 31925.55, 38763.44, 42875.89, 47994.409999999996, 46851.49,
    49137.96, 38708.23, 29728.800000000003, 34061.44, 45547, 48830.19, 40557.18,
    36441.899999999994, 44884.06, 44286.72, 42761.13, 43673.549999999996,
    55230.99999999999, 51421.19, 46010.56, 38095.17, 44593.39, 40180.31,
    30882.980000000003, 29484.920000000006, 36929.21000000001, 34519.78,
    29589.660000000003, 30901.710000000006, 43311.05, 44964.83, 33865.049999999996,
    31856.689999999995, 53732.149999999994, 56637.43, 50394.1, 43012.53,
    40384.810000000005, 40080, 34547.079999999994, 33576.02, 53613.579999999994,
    47146.369999999995, 33879.7, 31333.61, 52860.89, 46087.32, 35448.43, 34036.27,
    55515.16, 48377.15, 36394.86, 33842.07, 51453.21, 44454.84, 32837.560000000005,
    28953.989999999998, 45603.98, 41086.619999999995, 29997.619999999995, 29205.8,
    39137.34, 37530.58, 31290.699999999997, 37567.17, 52029.29, 50232.65,
    43049.81999999999, 39736.39000000001, 46967.770000000004, 46176.36,
    38228.54000000001, 33365.979999999996, 42974.12, 45443.36, 39711.05,
    32836.619999999995, 46150.68, 45417.909999999996, 37659.09, 30559.049999999996,
    33945.83, 35126.87, 32312.980000000003, 29951.519999999997, 35792.399999999994,
    39947.18, 39995.53, 30829.57, 35009.71, 39935.340000000004, 37987.47, 36815.16,
    51017.520000000004, 55930.72, 46806.49, 39202.21, 50660.45, 53757.34999999999,
    47536.05, 41954.53999999999, 52139.54000000001, 53728.439999999995, 48636.37,
    43934.1, 52822.96, 55964.520000000004, 50633.42, 43781.560000000005, 53317.72,
    55025.23000000001, 46118.06, 39963.840000000004, 45025.94, 48415.950000000004,
    46622.32, 40405.86, 43732.48, 46655.97, 44568.77, 41706.76999999999, 57467.28,
    61946.52, 56866.44, 56056.23, 65010.18, 61703.979999999996, 56369.43, 46164.9,
    58776.55, 55062.13, 47928.049999999996, 37929.8, 54383.34, 55192.189999999995,
    48353.21999999999, 42378.31, 50329.51, 49978.00000000001, 45399.54, 35409,
    41863.53, 47919.13, 46218.799999999996, 42195.75, 47555.33, 51369.57,
    48607.640000000014, 39255.76, 46544.909999999996, 48762.04000000001, 45408.8,
    49809.25, 57544.08, 56824.8, 52513.810000000005, 50139.090000000004, 65505.88,
    65053.92, 58898.25, 47633.25, 55610.10999999999, 55139.62999999999,
    55041.240000000005, 50117.759999999995, 60811.49, 57031.26, 42304.95, 42202.75,
    55130.72000000001, 57888.59, 54517.81, 53098.89000000001, 61253.229999999996,
    59147.95000000001, 54553.12999999999, 50395.47, 47622.630000000005, 45776.18,
    46181.58, 42041.67999999999, 58557.29000000001, 50255.2, 40778.74,
    40241.880000000005, 60953.049999999996, 58278.719999999994, 49277.420000000006,
    41454.090000000004, 53251.079999999994, 48324.979999999996, 42621.45, 40211.33,
    61658.520000000004, 54555.39, 52457.39, 41846.409999999996, 45786.98, 43256.68,
    39609.909999999996, 36247.14, 51023.020000000004, 50647.16, 47125.31, 46191.68,
    56367.73000000001, 58947.57000000001, 52903.08, 44926.26, 56759.05,
    53698.380000000005, 48773.18, 42158.9, 54638.73, 51266.29, 50660.67,
    50338.619999999995, 58785.82, 56395.91, 55679.60999999999, 55318.59000000001,
    60973.24999999999, 49748.76, 50057.350000000006, 53750.48, 56715.75, 56453.27,
    51765.69, 46290.37, 46434.94, 46554.11, 46965.11, 49977.5, 56079.48000000001,
    58878.18000000001, 54356.37999999999, 53093.23, 72066.29, 73137.13, 64499.14,
    52716.880000000005, 63318.54, 64655.630000000005, 59050.40999999999,
    52201.799999999996, 61894.259999999995, 63062.25, 60142.5, 54340.42, 61836.95,
    63103.369999999995, 57697.76, 46207.05, 53446.990000000005, 58982.369999999995,
    51860.86999999999, 47222.17, 51854.36, 54612.549999999996, 56628.170000000006,
    55917.18, 65944.40000000001, 64970.60999999999, 60926.46000000001, 44072.55,
    54118.880000000005, 58383.81, 59751.94, 57847.72, 64836.1, 63142.4,
    61583.28999999999, 59347.119999999995, 60409.32000000001, 59101.07, 55364.53,
    48675.92999999999, 56747.11000000001, 58463.08, 56873.62, 46249.5,
    56986.53999999999, 62576.28, 60306.33, 57609.01, 64079.41, 61335.09, 57813.38,
    58548.45999999999, 59891.59, 52314.57000000001, 42619.3, 39842.48, 44944.91,
    44707.28, 39317.6, 36327.12, 37808.71, 38823.08, 37427.72, 35357.41,
    37858.259999999995, 42696, 41684.399999999994, 37651, 47896.02, 52458.2,
    47388.58, 39898.01, 50891.83, 52434.770000000004, 46351.8, 35668.219999999994,
    37451.29, 40366.58, 43565.65, 45664.54, 50556.48, 53340.17999999999,
    49277.899999999994, 49522.740000000005, 56806.369999999995, 59823.05,
    59520.450000000004,
  ],
  CHE: [
    21682.83, 23095.85, 24716.67, 23339.420000000002, 21989.5, 26225.48,
    30567.620000000003, 23083.129999999997, 21509.45, 25203.15, 27084.22,
    24597.989999999998, 21582.25, 29826.36, 43903.799999999996, 36449.7,
    22657.260000000002, 32001.28, 40743.03, 29779.47, 22153.79, 31067.14, 43779.55,
    30497.13, 22447.760000000002, 28750.229999999996, 40407.67, 29586.06, 24663.12,
    47305.49, 48001.880000000005, 32598.14, 26145.059999999998, 52676.159999999996,
    53871.939999999995, 47334.78, 32267.480000000003, 62983.04, 61270.78, 51980.67,
    30806.510000000002, 55354.04000000001, 55490.11, 50407.12, 34032.71, 58750.64,
    55758.41, 47578.95, 30247.120000000003, 42572.32000000001, 46554.67,
    43403.409999999996, 27454.67, 31103.700000000004, 37111.18, 34066.91,
    29245.050000000003, 50204.520000000004, 48914.65, 40102, 30116.99,
    57650.89000000001, 51343.69, 39008.75, 28843.869999999995, 53584.77999999999,
    55580.82000000001, 40653.630000000005, 26527.19, 56811.95, 51646.35,
    38487.630000000005, 25886.48, 57832.61, 50315.38, 45005.770000000004, 27376.01,
    43150.03, 42751.39, 37052.59, 23304.339999999997, 26286.12, 32430.74,
    31448.600000000002, 26957.699999999997, 45696.619999999995, 44367.7, 34333.06,
    26748.77, 47006.53999999999, 41751.97, 32196.160000000003, 13117.29, 30755.17,
    35710.740000000005, 28003.620000000003, 23791.54, 40320.420000000006,
    47792.770000000004, 33689.88999999999, 24920.960000000003, 33793.80000000001,
    36238.74, 32063.54, 22037.84, 26384.549999999996, 38197.52, 30955.530000000002,
    21044.960000000003, 24104.48, 31405.59, 27202.73, 23445.24, 45959.119999999995,
    50713.479999999996, 38003.5, 26615.39, 44169.09, 46764.53, 39873.259999999995,
    27528.8, 54989.34000000001, 50417.58, 34824.2, 26457.72, 43357.03999999999,
    44707.79000000001, 36100.700000000004, 23774.760000000002, 37181.850000000006,
    36304.450000000004, 27309.22, 21492.08, 25558.55, 28985.71, 26058.480000000003,
    20952.289999999997, 24681.59, 30227.59, 26931.600000000002, 23183.64,
    37354.590000000004, 34845.51, 29100.03, 22048.4, 32984.1, 32952.23, 26179.18,
    23039.42, 35746.14, 45271.20999999999, 38179.08, 26396.95, 51948.600000000006,
    50379.21000000001, 31442.45, 23082.54, 35645.13, 40513.130000000005, 19715.29,
    15061.150000000001, 23589.29, 24105.64, 17565.46, 20720.87, 24221.73, 32209.42,
    29790.74, 24908.43, 53067.79, 47302.69, 36484.46, 25114.560000000005,
    40959.409999999996, 41090.7, 30775.630000000005, 24204.59, 43411.53,
    44956.86000000001, 32297.309999999998, 25526.660000000003, 42851.030000000006,
    43750.28999999999, 27461.53, 23914.5, 34121.369999999995, 40204.95, 36420.12,
    23026.72, 28040.25, 40532.65, 38370.5, 20456.89, 24205.140000000003,
    27911.700000000004, 24359.659999999996, 22610.7, 44148.37000000001,
    47148.68000000001, 35804.22, 27571.82, 50032.33, 41364.560000000005, 33062.31,
    24972.32, 43511.409999999996, 44126.47, 30817.68, 25036.43, 51144, 41566.46,
    26997.16, 22701.07, 39926.19, 49148.81, 44101.64, 26536.19, 33899.240000000005,
    36469.21, 30863.329999999998, 21406.980000000003, 26951.99, 35586.72, 30610.27,
    24661.649999999998, 42663.96, 42740.740000000005, 33252.1, 27109.89,
    45119.630000000005, 47513.82, 43688.509999999995, 29863.54, 55587.50000000001,
    49563.54, 36698.740000000005, 23548.989999999998, 42796.14, 43945.76, 35583.46,
    24594.9, 43807.05, 48199.92, 35031.18, 21843.44, 29821.120000000003, 36352.33,
    32930.7, 20655.48, 26570.199999999997, 33322.04, 34409.22, 26490.34,
    48396.700000000004, 47916.85, 39750.89, 25653.079999999998, 51044.98,
    47320.759999999995, 44922.48, 30636.03, 50993.450000000004, 47288.990000000005,
    42326.00000000001, 29701.219999999998, 43863.95, 45890.479999999996, 38811.51,
    25237.52, 36431.36, 34628.31, 28901.05, 29370.43, 33326.520000000004, 35085.99,
    33582.17999999999, 21405.58, 30314.519999999997, 32314.14, 34916.61, 27541.25,
    42636.51, 44825.12000000001, 38175.009999999995, 28819.78, 43354.700000000004,
    43639.200000000004, 36570.68, 27685.349999999995, 43722.47, 42268.81999999999,
    38220.08, 26991.02, 38630.149999999994, 41602.58, 36799.420000000006,
    27528.670000000006, 40551.11, 40563.2, 31912.91, 24564.66, 29838.130000000005,
    33301.6, 31533.640000000003, 22010.22, 25514.47, 32647.39, 33023.67,
    26000.129999999997, 44803.99, 43248.03, 39709.5, 28322.82, 36991.99,
    42536.740000000005, 42475.87, 33172.780000000006, 40666.81, 42534.770000000004,
    41195.69, 28302.75, 42832.43, 41757.75, 35046.33, 23686.97, 40269.200000000004,
    40170.18, 41167.74, 26500.13, 31521.729999999996, 32613.81, 28568.359999999997,
    21438.04, 30926.54, 28399.15, 27441.889999999996, 27198.079999999998, 42672.29,
    42690.520000000004, 37931.21, 26244.59, 44110.62, 43422.41, 36003.409999999996,
    29269.67, 41915.79, 43038.92999999999, 39734.52, 27198.8, 40721.57, 40652.92,
    32631.1, 24922.4, 30562.17, 37758.03, 39586.46000000001, 25811.230000000003,
    26910.09, 34823.909999999996, 37845.01, 23371.05, 29029.139999999996, 32957.81,
    25100.95, 24621.93, 31827.89, 32922.32, 25311.79, 24683.82, 35981.07, 40049.01,
    37912.6, 31783.120000000003, 42149.67, 40032.46, 31481.71, 30541.92, 35346.46,
    33890.630000000005, 30609.589999999993, 30794.67, 40635.33, 32994.73,
    26744.550000000003, 24119.300000000003, 34006.880000000005, 34492.94,
    24897.299999999996, 22653.129999999997, 31514.099999999995, 34478.58, 35769.85,
    33833.63, 40867.759999999995, 43589.36, 37845.12000000001, 30651.52,
    34181.219999999994, 34652.979999999996, 30162.039999999997, 30768.58,
    40025.81999999999, 39908.1, 36045.28, 27089.18, 36774, 42261.899999999994,
    39167.31, 36824.909999999996, 39667.89, 41436.61, 35646.90000000001, 23854.26,
    32829.75, 33525.229999999996, 27548.86, 24091.71, 33211.03, 35121.810000000005,
    37290.43, 38696.66, 45531.33000000001, 41052.53, 33406.64, 32631.34, 41699.84,
    41175.05, 38800.57, 37900.590000000004, 44782.34999999999, 42369.7, 45287.22,
    38336.38, 43196.12, 37552.100000000006, 33392.020000000004, 28151.29, 31183.34,
    32430.789999999997, 29591.9, 24612.71, 35061.78, 33610.33, 32540.52, 22967.32,
    29847.41, 32132.13, 35469.229999999996, 38295.57, 42124.16, 42832.659999999996,
    44976.09999999999, 42452.06999999999, 40696.02, 39087.96, 36907.66,
    33867.770000000004, 42904.72, 40020.51, 44105.18, 33789.990000000005, 41472.03,
    40129, 35882, 34375.84, 35563.57, 39123.1, 46668.07000000001, 34456.86, 32084.55,
    34070.18, 29932.749999999996, 19504.48, 23484.65, 25486.1, 24908.370000000003,
    27287.2, 29909.42, 35639.55, 31075.440000000002, 29700.42, 33718.43,
    35333.79000000001, 31691.119999999995, 18581.14, 24451.4, 22949.309999999998,
    15898.17, 22103.6, 26317.03, 32309.43, 26973.91, 25996.32, 43078.52, 40470.17,
    38645.030000000006, 28548.03, 25768.309999999998, 32725.449999999997, 35887.92,
    16762.989999999998, 22995.399999999998, 28050.170000000002, 32555.3, 27528.83,
    27202.009999999995, 34656.97, 30854.44, 24995.960000000003, 34049.450000000004,
    32816.27, 32985.509999999995, 31446.929999999997, 37740.38, 38745.92,
    33651.32000000001, 23841.76, 21951.85, 31264.289999999997, 33302.68, 26145.75,
    30397.409999999996, 34865.35, 35001.86, 24136.59, 29526.82, 29148.219999999998,
    27075.910000000003, 16735.42, 28235.749999999996, 27701.32, 21477.76, 23392.55,
    33973.98, 34819.54, 27202.32, 24000.13, 32776.74, 31327.530000000002, 26792.97,
    25340.2, 31376.170000000002, 34136.22, 30447.510000000002, 26292.1, 30497.68,
    36384.94, 35267.060000000005, 28888.079999999998, 31412.850000000006, 36786.48,
    34439.76, 25685.02, 30788.420000000002, 30716.9, 33665.7, 22524.05, 27130.62,
    27798.489999999998, 35446.130000000005, 26729.18, 29493.239999999998,
    31852.760000000002, 31079.530000000002, 26131.87, 28362.07, 38015.94, 25579.9,
    21217.76, 32443.22, 33047.420000000006, 29291.559999999998, 23330.42,
    27821.719999999998, 27769.059999999998, 30424.739999999998, 25688.739999999998,
    33657.17, 31259.539999999997, 35242.68000000001, 19144.09, 25022.2, 26656.3,
    22331.81, 12741.09, 20217.07, 18687.64, 19742.809999999998, 18269.93, 20186.84,
    24204.78, 23410.18, 22012.579999999998, 28718.29, 28694.600000000002, 20542.35,
    16099.130000000001, 20776.58, 22713.93, 23362.61, 22298.340000000004, 25440.06,
    29610.89, 25436.730000000003, 20384.36, 31657.21, 28043.6, 26027.359999999997,
    22197, 25460.1, 22889.66, 22414.19, 17755.22, 19592.08, 24985.019999999997,
    27060.69, 24403.89, 41241.409999999996, 40222.17, 30854.08, 31096.980000000003,
    37694.46, 36699.42, 26799.68, 25807.93, 31970.1, 34012.18, 35613.61,
    28419.280000000002, 37750.69, 35768.01, 41002.42, 31650.14, 38353.64, 38597.44,
    38142.95, 26705.670000000002, 31028.31, 26773.57, 29948.47, 24802.7,
    29057.239999999998, 28323.899999999994, 31412.709999999995, 30020.08,
    45640.369999999995, 40302.04, 31997.64, 25424.46, 30404.299999999996,
    31498.980000000003, 32038.339999999997, 31949.549999999996, 36390.53,
    36330.880000000005, 38522.009999999995, 29958, 39443.08, 38119.72, 32832.9,
    31551.01, 36899.36, 40621.259999999995, 29272.729999999996, 16957.899999999998,
    27407.86, 32913.880000000005, 28952.09, 22953.86, 31554.949999999997,
    30256.829999999998, 28907.28, 28770.520000000004, 36318.39, 36666.71, 41538.22,
    33359.93, 49692.59, 51279.23, 44550.8, 30469.51, 44817.73, 44079.840000000004,
    43504.68, 37547.58, 47237.23, 46390.759999999995, 45828.52999999999, 41829.72,
    48783.659999999996, 41272.23999999999, 37323.98, 30675.43, 30688.76, 32058.68,
    41171.22, 29270.829999999998, 31533.559999999998, 31229.22, 40411.149999999994,
    33484.29, 38760.58, 44878.46, 43297.18, 33963.92, 44501.6, 44717.490000000005,
    46334.28, 38812.08, 44130.34, 44153.130000000005, 48614.39, 44016.27,
    46831.899999999994, 49025.58, 47180.57, 37938.87, 44630.32000000001, 45292.66,
    50704.45, 35529.829999999994, 42317.39000000001, 37549.6, 43770.59,
    35859.850000000006, 41603.46, 40866.22000000001, 47531.38, 40065.14,
    50398.399999999994, 43511.76000000001, 41868.899999999994, 38277.47, 47689.4,
    43389.48, 49161.1, 42314.44, 50279.880000000005, 44745.7, 40335.8, 34486.96,
    40134.13, 41225.630000000005, 44276.54, 35614.19, 48063.700000000004,
    48003.670000000006, 51973.520000000004, 36812.61, 37301.76, 34426.2, 38602.96,
    35963.869999999995, 40344.090000000004, 44979.14, 51432.32, 49228.37, 56239.7,
    56687.95, 47207.1, 43139.14, 55865.40000000001, 54970.95, 54489.83, 49851.31,
    58468.32, 52992.69, 50724.380000000005, 46679.57, 55804.15000000001, 54580.44,
    51698.43, 46776.009999999995, 62678.229999999996, 57895.85, 50031.52, 39053.94,
    46484.740000000005, 49744.11000000001, 54827.520000000004, 36091.01, 43861.97,
    41680.770000000004, 52040.119999999995, 45045.229999999996, 50955.91, 50039.93,
    47165.61, 36691.03, 46383.45, 41459.61, 51872.060000000005, 50456.64, 57821.56,
    51975.810000000005, 53333.56, 53079.990000000005, 59720.8, 59352.28999999999,
    54354.07, 53004.67, 58750.31999999999, 59743.49, 55660.79999999999, 47026.96,
    50129.34, 48347.25, 49697.450000000004, 38060.85, 40858.4, 44613.520000000004,
    51894.24, 45554.060000000005, 47233.47, 43070.649999999994, 49099.12000000001,
    40184.909999999996, 52476.12, 50174.81999999999, 52206.89, 52609.33,
    55457.729999999996, 53750.149999999994, 54623.71000000001, 44167.08, 53876.95,
    53407.9, 49699.63, 45568.94, 59474.93000000001, 57046.59, 53433.58, 45495.43,
    50689.69000000001, 49325.43, 49865.87000000001, 35404.93, 35578.56, 39333.68,
    47752.57, 38826.979999999996, 45401.50000000001, 53024.34, 56272.59, 47423.3,
    51221.58, 56022.57, 53814.170000000006, 48990.64, 59125.16, 55274.469999999994,
    49694.85, 42765.5, 54496.71, 48092.17, 44734.53, 41432.420000000006, 54566.93,
    50237.17, 45883.04, 37763.42, 41864.61, 47116.399999999994, 46767.07, 39452.16,
    40813.03, 46079.72, 48641.88, 40891.78, 56452.06, 54020.10999999999,
    52982.12000000001, 40779.17999999999, 50837.61, 49145.630000000005, 48982.43,
    44319.71000000001, 50773.34, 50262.50000000001, 51648.1, 45724.95999999999,
    48925.619999999995, 51086.07, 51718.41, 39042.18, 42746.670000000006,
    42544.00000000001, 46511.29, 33231.26, 37606.95, 41363.08, 46039.32000000001,
    33455.340000000004, 35781.44, 39285.74, 39473.74, 35915.600000000006, 40825.15,
    48659.14, 45742.94, 45292.84, 52930.450000000004, 51286.26999999999, 47117.97,
    39620.36, 49851.63, 44759.880000000005, 43110.98, 36502.299999999996, 43366.14,
    43748.18, 45454.670000000006, 37221.21000000001, 48871.18, 45857.79000000001,
    45588.85, 40048.26, 40002.95, 39518.21, 44958.58, 33871.07, 35889.6, 38406.09,
    46872.399999999994, 39886.08, 52982.89, 51247.69, 44633.619999999995, 35328.45,
    43258.48, 47629.42, 44264.52, 31922.120000000003, 37114.49, 41211.159999999996,
    41468.94, 36378.939999999995, 42708.86, 42467.27, 37156.79, 31269.35, 40096.53,
    41451.2, 44957.25, 37386.75, 38485.19, 30032.179999999997, 22799.93, 25371.33,
    27010.480000000003, 35131.990000000005, 40240.630000000005, 36096.899999999994,
    40624.08, 43749.19, 44369.020000000004, 38636.62, 41511.21000000001, 47015.92,
    46351.96000000001, 42203.69, 46723.48, 47610.61, 44534.3, 40612.59,
    51041.369999999995, 52063.51, 49557.26, 42463.76, 51704.15, 48974.97, 43220.61,
    38449.100000000006, 41396.28, 44155.72, 40692.92, 32402.400000000005, 38390.38,
    41891.39, 40819.66, 40172.66, 51474.030000000006, 53186.26, 43776.39,
    39815.729999999996, 46908.17, 54175.32, 43608.36, 37131.729999999996,
    42156.340000000004, 46367.56, 39528.72, 32602, 40735.97, 44467.57, 38041,
    32466.06, 42827.49, 48575.66, 40468.64, 34138.04, 38812.030000000006, 43057.14,
    37219.4, 25789.120000000003, 27658.129999999997, 35709.45, 36638.770000000004,
    34118.9, 42506.76, 38071.450000000004, 32346.61, 30664.14, 35804.85, 35298.56,
    26916.41, 27128.510000000002, 32080.72, 38630.01, 34120.38999999999, 32366.59,
    42219.659999999996, 43766.899999999994, 33519.84, 31507.329999999998, 42266.03,
    36750.880000000005, 27058.159999999996, 21879.5, 27675.67, 27165.21, 30244.85,
    22111.92, 34855.06, 38525.59, 35591.88, 36002.78, 47332.86, 44007.80999999999,
    36020.69, 32472.56, 35862.340000000004, 41371.81, 33275.07, 32464.85, 42210.92,
    43293.42, 31851, 32663.12, 33719.17, 40429.9, 29824.679999999997,
    30934.199999999997, 36755.15, 40473.96000000001, 31330.809999999998,
    29592.880000000005, 31382.92, 39645.25, 36514.3, 26909.199999999997, 32957.44,
    40357.979999999996, 36335.76, 34377.13, 34083.58, 44174.840000000004, 36526.92,
    38323.39000000001, 42897.46000000001, 44100.94, 26760.1, 28683.280000000002,
    38190.01, 43797.84, 32495.95, 28119.899999999998, 37312.84, 39066.67, 29887.42,
    28150.339999999997, 33102.3, 31667.95, 24953.299999999996, 22328.629999999997,
    23426.48, 29574.440000000002, 31064.609999999997, 22353.689999999995, 28137.49,
    35449.75, 26115.94, 22951.989999999998, 31112.21, 30545.829999999994, 22371.86,
    24151.160000000003, 36027.13, 39675.219999999994, 33753.950000000004, 30428.91,
    45434.31, 41296.58, 28535.29, 24084.61, 30356.409999999996, 37823.55,
    30745.240000000005, 30312.48, 40226.11, 43159.57, 35595.02, 27155.340000000004,
    36896.53, 39776.979999999996, 27578.059999999998, 22603.54, 26564.72, 32925.21,
    24821.81, 27582.3, 43147.03, 46774.009999999995, 37834.62, 32979.47,
    36694.259999999995, 45189.45, 35872.67, 34167.37, 40811.130000000005,
    48199.369999999995, 35888.57, 31335.18, 41059.469999999994, 47683.51,
    41497.240000000005, 37381.17, 45901.780000000006, 45185.299999999996, 40554.75,
    31009.940000000002, 30702.83, 35375.36, 27056.510000000002, 22767.95,
    30566.979999999996, 31733.31, 28773.760000000002, 34549.2, 51836.57000000001,
    50482.42999999999, 43292.009999999995, 37630.350000000006, 44892.25, 49435.54,
    32833.39, 29592.04, 33374.51, 43360.19, 32556.789999999997, 30526.129999999997,
    42847.83, 47666.03, 37468.29, 34998.58, 46216.36, 47515.270000000004, 42461.06,
    29978.590000000004, 34762.14, 42802.11, 29211.97, 25285.569999999996, 27744.84,
    30524.22, 23194.5, 28707.9, 40938.30999999999, 52220.950000000004, 39469.17,
    31506.43, 36673.1, 41636.049999999996, 32751.109999999997, 35272.94, 44827.22,
    46704.01000000001, 36973.21, 32930.2, 42578.76, 46014.64, 31330.960000000003,
    32530.970000000005, 38769.520000000004, 45266.55, 41132.600000000006, 29797.21,
    27736.239999999998, 36008.94, 26095.619999999995, 21922.210000000003,
    26339.399999999998, 40605.600000000006, 37816.950000000004, 24971.33,
    32039.569999999996, 41554.780000000006, 31303.83, 29923.64, 39354.27, 45402.84,
    38864.99, 28603.43, 38543.82, 44288.45999999999, 38452.59, 27377.62,
    43887.200000000004, 44072.42, 32995.17, 23100.28, 25231.68, 34876.1, 32030.24,
    24013.47, 29916.660000000003, 42600.73, 35418.15, 23839.79, 25354.32,
    34528.009999999995, 31542.860000000008, 27927.27, 40418, 46794.07, 37995.92,
    30196.04, 40988.47, 48329.55, 42060.81, 30483.82, 45697.9, 50131.58, 41677.01,
    30673.309999999998, 48725.59, 51579.93, 39932.19, 29996.15, 46659.92999999999,
    50102.53999999999, 36991.06999999999, 26061.929999999997, 26416.989999999998,
    25857.71, 24093.83, 25030.31, 29998.489999999998, 38239.88, 33236.19, 26683.14,
    46068.770000000004, 51948.840000000004, 36506.76, 28978.260000000002, 51988.76,
    54203.08, 40678.55, 30958.88, 52269.590000000004, 53216.28, 39323.64,
    30578.949999999997, 47700.200000000004, 46340.3, 36595.59, 29442.339999999997,
    44510.159999999996, 45826.33, 37338.4, 28060.78, 32208.52, 36010.79,
    36059.469999999994, 27185.48, 31339.34, 37428.3, 34187.38, 26237.58, 43819.75,
    46272.8, 34737.67, 27096, 39281.05, 39380.770000000004, 30549.13, 28805.8,
    46598.53, 45652.490000000005, 34069.85, 26809.309999999998, 42891.60999999999,
    52177.259999999995, 37274.11, 25868.49, 46019, 42094.64000000001, 36200.75,
    25723.87, 30936.65, 36070.729999999996, 30650.3, 24432.35, 29563.03, 30292.29,
    28399.02, 27310.770000000004, 36746.829999999994, 41246.18, 32560.309999999998,
    26096.190000000002, 36145.01, 39308.78, 32872.87, 26821.05, 42156.14, 36554.02,
    30685.4, 25408.11, 38195.99, 38984.6, 34582.170000000006, 28015.86,
    44876.38999999999, 40293.51, 27343.33, 24334.51, 26478.6, 35010.159999999996,
    26558.23, 22868.38, 25344.57, 31676.25, 29196.960000000003, 26669.53,
    38267.060000000005, 43697.68, 33442.13, 25766.82, 44310.91, 50067.58,
    39785.560000000005, 29413.839999999997, 53491.66, 50313.719999999994, 35296.8,
    26552.600000000002, 42845.65, 37807.24, 32372.25, 25126.609999999997, 39813.55,
    39721.36, 33101.409999999996, 25397.420000000002, 30128.1, 31129.82,
    26953.160000000003, 24137.73, 27172.59, 31624.12, 27471.19, 25031.5, 42331.56,
    43452.41, 34655.3, 28560.609999999997, 45682.56, 50936.450000000004, 40257.84,
    28432.14, 49377.88, 53728.9, 44427.01, 28572.14, 52472.14, 51361.39,
    43203.729999999996, 27882.2, 50773.06, 51195.329999999994, 36923.43, 25642.25,
    35574.229999999996, 38621.8, 31339.1, 23795.200000000004, 28235.48, 31728.35,
    28760.500000000004, 27408.859999999997, 43613.380000000005, 42903.939999999995,
    35625.06, 26008.54, 34698.07, 38837.77, 32341.030000000002, 26446.49, 33591.2,
    39877.55, 33278.27, 25483.21, 37986.15, 38983.4, 30435.990000000005,
    22885.350000000002, 38182.53, 32205.28, 29037.670000000002, 22283.72,
    27268.610000000004, 32305.489999999998, 31059.059999999998, 23726.11,
    24730.430000000004, 29150.98, 25618.43, 22238.94, 28946.079999999998, 32048.25,
    27633.690000000002, 21958.879999999997, 29038.960000000003, 33431.369999999995,
    24804.78, 21582.25, 24534.519999999997, 28118.370000000003, 24434.329999999998,
    21646.300000000003, 27140.83, 39009.850000000006, 34748.77, 22812.75, 34825.62,
    46193.01, 40874.44, 22672.66, 31216.29, 42019.32, 35735.42, 21782.559999999998,
    25029.78, 31286.52, 30849.649999999998, 22000.49, 28671.55, 36966.24, 33066,
    24323.229999999996, 33106.56, 33834.71, 29431.099999999995,
  ],
  DEU: [
    299324.15499999997, 324370.915, 314846.82999999996, 274166.59249999997,
    262128.67749999996, 346339.94749999995, 353879.5175000001, 368036,
    351532.08749999997, 422586.24499999994, 397864.6375, 334685.92500000005,
    329657.52999999997, 366213.675, 329730.695, 259060.885, 267553.57, 374547.615,
    373792.7975, 330122.67000000004, 258858.88500000004, 294499.7325,
    309048.08999999997, 287435.765, 256012.67750000005, 293513.46, 315902.88,
    318403.3025, 306398.67500000005, 407060.97500000003, 417447.225, 368030.63,
    315758.72000000003, 406584.93750000006, 390951.38, 351985.5725,
    322049.84750000003, 405267.65, 386623.1525000001, 335124.275, 315094.7425000001,
    407858.0525, 393063.40499999997, 324776.40249999997, 303478.8775, 392779.04,
    400303.7475, 357884.33749999997, 315233.96749999997, 384833.0475, 418089.4575,
    390577.98999999993, 359214.0875, 362247.345, 392366.93500000006,
    396937.95499999996, 398908.08249999996, 449060.125, 434548.30250000005,
    388187.16500000004, 360234.1475, 415787.745, 412851.305, 394801.26000000007,
    371513.80250000005, 422799.94499999995, 378740.34, 319011.81749999995, 284911.11,
    368941.79250000004, 370946.4175, 386699.05, 367382.93499999994, 457110.0775,
    452861.765, 420847.12500000006, 383707.19, 416848.585, 382964.42750000005,
    348341.545, 326185.52999999997, 395715.1875, 399788.84750000003,
    395132.34249999997, 385850.89749999996, 457336.4575, 443910.83999999997,
    416839.09249999997, 403861.775, 459080.8, 428997.10750000004, 415203.82000000007,
    399340.03, 466193.51249999995, 461101.37, 420392.67250000004, 384569.72750000004,
    411636.88, 343987.62500000006, 286365.89, 274924.13500000007, 418708.3375,
    444909.8775, 391463.4375, 326798.9175, 355599.465, 317373.3325,
    278783.68000000005, 215409.88999999998, 308188.19, 318935.43250000005,
    342710.67000000004, 320470.3375, 394651.29500000004, 338307.87999999995,
    295093.51749999996, 269995.07999999996, 384186.6475, 380438.84500000003,
    373969.7925, 310355.525, 357533.6950000001, 378851.9675, 403263.3125,
    372982.9425, 426565.92999999993, 410219.27999999997, 348597.85, 307050.6225,
    425623.86749999993, 428826.6725, 411079.345, 379485.9000000001,
    401252.92500000005, 391015.3125, 363619.8725, 345108.0625, 406887.99,
    415144.4575, 401047.8025, 388385.475, 479625.0325, 481636.2725000001, 431400.01,
    406379.82500000007, 479271.89, 471128.10250000004, 433851.575,
    379873.03500000003, 403667.4924999999, 367432.7075000001, 320064.73500000004,
    282133.74249999993, 351691.18249999994, 361956.75249999994, 330337.375,
    332085.59500000003, 412489.49, 365528.59249999997, 296510.6775,
    229678.94000000003, 282725.82749999996, 292651.92750000005, 277886.05750000005,
    260585.44000000003, 294131.52499999997, 280387.3025, 259481.3825,
    252267.16500000004, 332973.61, 330486.005, 309517.7775, 303699.2575, 402695.4025,
    369392.63999999996, 327631.50499999995, 304970.44, 374930.57749999996,
    354624.01999999996, 319613.04500000004, 275631.06500000006, 360529.2825,
    344468.935, 312018.72250000003, 294282.31000000006, 391775.7475, 360963.575,
    318060.265, 283654.5, 309929.43000000005, 269673.655, 223280.9624999999,
    216723.50499999995, 319696.83749999997, 322007.4575, 321692.08499999996,
    332229.79000000004, 391091.1575, 360674.57249999995, 325321.47750000004,
    291956.1375, 368873.29000000004, 366087.1700000001, 360297.70000000007,
    326779.8425, 388559.58999999997, 369254.6425, 366068.76499999996,
    322841.49250000005, 354486.635, 374207.7200000001, 410123.87, 390991.575,
    427135.0425, 376380.04000000004, 311141.25, 238253.37, 322784.28,
    319248.9550000001, 292744.0925, 267788.32500000007, 319358.74,
    280421.45749999996, 228172.65499999997, 223387.84749999997, 337263.7950000001,
    330992.57499999995, 305882.46749999997, 255338.76, 330031.29000000004,
    324250.2225, 282804.4499999999, 253791.3725, 342394.8, 332548.24499999994,
    292710.70249999996, 298201.66000000003, 409688.725, 372232.2625, 324999.9225,
    283154.36250000005, 340683.065, 307202.97500000003, 288063.0325,
    258450.45249999996, 297357.86, 305349.4675, 306965.3725, 256367.4225,
    317403.61750000005, 303155.89749999996, 269336.225, 243415.60249999998,
    342599.97750000004, 333628.7925, 311538.47, 280708.3899999999,
    386853.50750000007, 383893.2125, 341492.0525, 280405.3125, 360717.305,
    340782.8650000001, 318073.86250000005, 273622.67, 372225.21749999997,
    352899.5525, 327251.2025000001, 286147.955, 415416.025, 411977.805, 349148.135,
    281663.15750000003, 387040.78750000003, 369393.8225, 321764.74250000005,
    297817.60000000003, 365986.94250000006, 354498.2625, 316531.785,
    291465.78750000003, 397548.4224999999, 360973.4475, 282900.81499999994,
    244545.16249999995, 330778.3775, 320621.7475, 278331.9775, 248884.00749999995,
    346905.63249999995, 342012.5775000001, 308600.94999999995, 264143.63,
    356280.47750000004, 345901.6975, 323631.8375, 290501.81, 387882.16750000004,
    361837.655, 312234.26749999996, 286368.02749999997, 353293.8425,
    355406.0374999999, 257905.25, 181930.18000000002, 274902.78750000003,
    262720.87750000006, 267999.835, 267952.91500000004, 344244.3075,
    313387.33999999997, 278654.065, 252031.6925, 366921.405, 325882.25750000007,
    275752.6324999999, 236517.90249999997, 347868.9174999999, 322460.85,
    270138.26000000007, 267718.4175, 358628.86250000005, 343817.21,
    286097.3574999999, 266826.11749999993, 372075.2625, 345008.44999999995,
    257433.95999999996, 215537.3775, 329478.4, 365658.9925, 313566.3575, 298540.44,
    368336.4525, 356827.3875, 333874.1175, 283584.3125, 353031.405, 322415.435,
    282940.69999999995, 273617.0525, 401031.75, 362231.095, 301296.8125,
    241510.41250000003, 334987.3275000001, 286772.5700000001, 246595.43000000005,
    231671.90500000003, 348573.23750000005, 391882.94249999995, 327837.54,
    307150.34750000003, 343366.5875, 292390.255, 215759.2175, 179167.12499999997,
    294226.60500000004, 265858.285, 206084.155, 137039.965, 232164.965,
    226701.10499999998, 176815.54, 157234.68000000002, 213168.20500000002, 280275.87,
    287249.47250000003, 316757.56, 446536.17000000004, 402424.0525,
    271097.26499999996, 248238.0825, 327335.5324999999, 314141.64249999996,
    293571.54, 301832.195, 374220.0625, 379821.485, 307578.23000000004, 270441.3375,
    388958.97000000003, 402664.43999999994, 313241.1225, 240861.78000000003,
    331966.03750000003, 330599.5175, 283721.2, 286125.2, 327722.4224999999,
    274551.04750000004, 218541.0975, 213845.90499999994, 322515.19249999995,
    292092.81749999995, 248244.16749999998, 232973.41499999998, 354197.03750000003,
    364156.5975, 316723.50750000007, 288858.5825, 351993.09500000003,
    301770.22750000004, 243803.115, 279430.52, 397119.53, 322115.83999999997,
    220380.99000000002, 216731.88999999998, 373919.71749999997, 338989.01250000007,
    233618.49000000005, 226782.2225, 344954.3125, 301728.20499999996,
    286476.35000000003, 272670.60250000004, 358492.0025, 309944.0075,
    188686.01499999998, 194267.95500000005, 325860.71, 358792.28250000003,
    325292.90499999997, 303308.2, 376944.68500000006, 334209.0725, 255265.6675,
    236853.38999999996, 322957.7499999999, 302194.71499999997, 249931.4975,
    241146.05500000008, 345252.755, 349406.81999999995, 267740.0125,
    307595.56500000006, 405892.38750000007, 371484.475, 310913.875, 251719.5475,
    287398.64, 276761.70499999996, 216283.46499999997, 189298.74500000002,
    300587.4425, 291954.55750000005, 224637.7025, 231531.97749999998, 355718.625,
    319148.5525, 253222.41250000003, 248763.12750000003, 369425.23250000004,
    330430.5575, 267267.18500000006, 274337.135, 371647.42749999993, 349725.89,
    272998.8, 260506.85749999998, 345984.28250000003, 328213.05750000005,
    268144.73250000004, 268935.41000000003, 367270.3875, 313984.44500000007,
    224603.94, 181311.81500000003, 342557.1425, 306848.4475, 234175.27750000003,
    238421.5725, 339327.31499999994, 321646.66000000003, 250633.8625, 210202.4025,
    334712.94000000006, 292871.6025, 239654.88000000003, 227011.2975,
    354577.31000000006, 317369.48500000004, 233193.91499999998, 203104.60249999995,
    345756.77999999997, 342462.7899999999, 280310.1275, 268813.2375,
    406546.85500000004, 373410.76, 288006.2775, 257263.59749999997,
    326615.61250000005, 279941.8325, 202086.24499999997, 158435.04000000004,
    263130.9, 245921.27249999996, 200164.52, 190636.485, 308917.66,
    304150.7050000001, 205883.16999999998, 197744.715, 311120.4575,
    281799.44249999995, 228447.05750000005, 216022.04250000004, 294850.06249999994,
    279044.775, 228829.97000000003, 215404.58749999997, 308675.605, 281925.63,
    211695.98249999998, 166508.53750000003, 310870.7925, 271993.0325,
    185482.21500000003, 166007.185, 314665.36250000005, 271887.5075,
    186535.32249999998, 157636.50999999995, 296942.7175, 273943.7275,
    203249.01249999998, 183522.8, 323185.60500000004, 304289.4799999999,
    264526.02749999997, 255290.24500000005, 382089.11, 355525.5924999999,
    283107.75249999994, 266836.70499999996, 408682.9325, 398271.21249999997,
    303959.0425, 283686.235, 411998.56749999995, 382345.71, 288199.095, 276479.5125,
    408127.0800000001, 362857.07250000007, 264179.14999999997, 259446.7725,
    369323.555, 338222.24749999994, 254895.45499999996, 179742.88999999996,
    274325.2425, 253224.03999999998, 184277.06500000003, 145407.8425, 252288.2825,
    248476.37749999997, 180300.90499999997, 149859.14499999993, 292494.9375,
    271325.685, 213648.12749999994, 227058.55499999993, 350694.52999999997,
    342845.635, 285183.42, 275360.37250000006, 327837.9525, 300462.29750000004,
    219837.18750000003, 219913.86500000005, 341045.3575, 300180.09750000003,
    225489.57250000007, 213814.69249999995, 324807.8025, 304802.2724999999,
    226889.34999999998, 180101.88249999995, 280755.575, 259770.48250000004,
    178516.5575, 137331.3425, 302003.70249999996, 273668.03, 215005.84, 207410.1425,
    306826.31, 297821.77499999997, 227663.38250000004, 218765.465,
    321516.76249999995, 314494.1025, 243063.0625, 249224.38499999995, 363691.6175,
    319352.07499999995, 232131.09, 189593.71499999997, 274749.7925,
    260730.22999999998, 204851.72249999995, 185258.95749999996, 274599.18999999994,
    270945.87749999994, 208968.97249999997, 174069.93500000003, 253169.45500000002,
    282233.24499999994, 229016.36000000004, 199349.21000000002, 279444.59,
    292200.155, 227281.8075, 219078.75000000006, 323001.06249999994,
    312711.62250000006, 218566.995, 202518.435, 314699.19499999995,
    315885.65499999997, 260665.89, 272393.4325, 348625.94499999995, 323549.255,
    250762.51499999996, 242492.63249999998, 364439.2800000001, 323146.795,
    224140.495, 214776.93750000003, 351531.9475, 315383.47000000003,
    212806.23750000002, 195546.41999999998, 358431.875, 315722.59, 231757.42,
    203182.87000000002, 329544.395, 304523.4075, 230089.16, 224259.3,
    350712.14499999996, 313980.13, 277678.43000000005, 281649.8825, 384655.7875,
    360747.08499999996, 252429.58250000002, 234595.4775, 362354.40750000003,
    339959.285, 247839.59749999995, 231936.66499999998, 334692.2975, 304364.285,
    229392.3549999999, 225592.31500000006, 313176.595, 304762.3225, 232658.4675,
    233375.11, 344750.05250000005, 329104.755, 226677.28000000003,
    206564.07250000004, 329634.18500000006, 285948.4600000001, 203358.97250000003,
    209173.70999999996, 324594.35500000004, 310561.76499999996, 228127.955,
    220110.9525, 341899.07500000007, 310605.915, 238586.60749999998, 221480.47,
    314731.53750000003, 315627.30500000005, 233015.63, 212035.98750000002,
    332459.61000000004, 297892.81249999994, 238624.36750000002, 230394.14500000002,
    318950.30750000005, 309971.61750000005, 251554.72250000003, 212548.565,
    341259.995, 298038.3975, 190335.505, 149174.06000000003, 285818.78500000003,
    264906.2475, 186787.0725, 189495.76250000004, 332682.09, 313516.72000000003,
    238147.45500000005, 230260.2625, 371648.0525, 346325.69249999995, 259054.7725,
    233463.04750000004, 359893.99250000005, 327010.525, 253842.55,
    224796.05000000002, 333022.06499999994, 310656.7325, 225484.55500000002,
    228568.1775, 376805.8375, 356410.63, 198824.15000000002, 158708.85499999998,
    305921.1875, 264336.79750000004, 212383.72499999998, 176548.85499999998,
    255467.18749999997, 254223.6825, 192653.38500000007, 196682.2875,
    318624.61000000004, 323393.0925, 234129.7475, 220653.6075, 331270.17250000004,
    315088.6400000001, 243622.43499999997, 225882.3625, 327354.9325,
    291893.3374999999, 224380.5825, 244533.85500000004, 386417.6575,
    367806.9499999999, 249652.92250000002, 242493.53, 406239.46499999997,
    350670.1475, 207532.88749999998, 220749.59499999997, 369404.685, 344278.14,
    285524.7575, 227343.75250000003, 320105.1675, 269884.3525, 185073.32999999996,
    197956.28999999998, 356095.995, 325188.12750000006, 236198.3025000001,
    224183.9025, 377438.635, 359609.105, 275276.19750000007, 244001.55250000005,
    324189.4725000001, 301913.69250000006, 224914.485, 216837.24999999994,
    334697.585, 320910.55, 236681.005, 227548.67499999993, 337626.975, 316499.355,
    243545.56499999997, 203022.13249999995, 332970.74249999993, 301379.58749999997,
    192717.06, 168001.7875, 327740.14749999996, 286186.295, 210071.00500000006,
    207184.67250000002, 356915.47, 313293.58999999997, 245156.9325,
    239055.80749999997, 351010.56749999995, 343286.0449999999, 244306.09249999994,
    242263.32499999998, 353669.12999999995, 317650.6225, 223851.23999999993,
    208344.91749999998, 336539.29, 305673.215, 226790.97500000003,
    209186.19749999995, 343256.4225, 294813.61, 227158.78999999998,
    180622.89500000002, 309490.1475, 290555.02999999997, 221906.25250000003,
    180886.5525, 287806.50249999994, 260174.41999999998, 199501.8325,
    217891.05749999994, 344486.845, 322651.18500000006, 212182.1125,
    217158.36999999997, 329707.80000000005, 308844.4225, 238905.8725,
    225901.31250000003, 335764.70249999996, 330470.03250000003, 218896.73750000008,
    194455.975, 337505.22000000003, 303629.605, 221894.69000000003, 210469.0175,
    293011.68250000005, 282278.645, 209250.73250000007, 165490.1700000001,
    237258.95749999996, 229473.09250000003, 192396.75000000006, 173501.96750000006,
    293934.80750000005, 297121.4825, 197574.12000000002, 181104.5775,
    347059.12749999994, 310077.06, 215495.485, 200663.2475, 341186.58749999997,
    310866.88, 229449.95749999996, 209325.41499999998, 328198.9425, 300555.36,
    242028.74, 225397.2575, 327619.73000000004, 299178.1225, 244280.9475,
    219475.19249999998, 299649.3775, 281038.345, 207313.17999999996, 158914.0925,
    274841.0425, 251992.3, 175385.99, 167130.5975, 285907.1675, 280845.72,
    192199.33499999996, 184874.76749999996, 297767.14749999996, 290388.5975,
    220022.82499999998, 205420.0225, 335427.3975, 304305.96249999997,
    234005.00249999997, 207062.865, 309222.67, 290968.24000000005, 224633.9725,
    204169.02999999997, 290370.995, 289110.78250000003, 212965.45500000002,
    228620.065, 381425.62, 356439.495, 239307.89999999997, 193754.12249999997,
    327346.57999999996, 304376.04, 189168.3225, 150530.4025, 297675.0875, 266466.435,
    177662.11999999994, 178927.03000000003, 325594.04, 314945.94750000007,
    273433.09500000003, 252198.51499999998, 356902.00749999995, 318987.0275,
    261095.10499999998, 225218.5175, 325068.66, 303727.31, 229938.21, 199598.815,
    304228.87, 299606.2375, 218837.24, 211884.1225, 352609.6625, 306786.0975,
    215670.9025, 179091.15499999994, 251946.73249999998, 247372.30750000005,
    182037.08250000002, 147071.53000000003, 193532.245, 219729.23000000004,
    203522.8225, 202249.95749999996, 296294.64999999997, 270474.995,
    218568.74249999996, 219777.39999999997, 322371.36000000004, 302016.105,
    230813.70499999996, 242472.63250000004, 395397.0125, 361604.81249999994,
    225729.80750000002, 220236.56749999995, 366407.32749999996, 341737.6725,
    260476.86, 260534.76999999996, 424898.76499999996, 389618.69, 224158.48,
    178794.07, 347349.9050000001, 340087.39, 258390.20750000002, 240218.57749999998,
    319369.9875, 266141.5025, 191699.33750000002, 213894.13, 336260.4925,
    299006.9375, 210599.905, 205819.5975, 342933.1025, 308725.035,
    255412.35499999998, 230653.21999999997, 357217.96749999997, 326822.5925,
    272982.37, 237127.89499999996, 356061.4975, 330278.6475, 236590.18, 223830.0075,
    337001.50500000006, 309247.9325, 232961.69999999998, 199183.50499999998,
    304534.24000000005, 281905.17, 234498.21249999997, 204860.8175, 333871.7575,
    304559.4475, 263495.45, 239851.30500000002, 350863.15750000003,
    324837.54500000004, 256469.18999999997, 227855.40250000005, 352005.0125,
    315182.5575, 226858.33750000002, 222957.7325, 338801.7249999999, 317319.7475,
    252259.03999999998, 249898.54500000004, 404503.02999999997, 398078.01,
    323489.80250000005, 291702.91749999986, 383726.545, 345201.25749999995,
    255683.66499999998, 189932.98500000004, 307830.92250000004, 278099.775,
    222689.8725, 181723.7, 266497.72000000003, 233824.48250000004,
    209628.60249999998, 214723.15000000002, 309965.03250000003, 314133.62000000005,
    279063.08999999997, 249691.4425, 362516.1525, 364181.7775, 287907.83499999996,
    269460.0825, 334511.22250000003, 297746.4375, 255369.49999999994, 240698.5525,
    325773.735, 279970.26749999996, 202933.56, 207755.4225, 298219.76, 308590.9775,
    258935.82750000004, 226852.64250000002, 306415.79000000004, 287164.24,
    202740.68750000003, 175064.16250000003, 291630.88750000007, 263743.66000000003,
    192795.09499999997, 210566.67749999993, 304828.19499999995, 305581.97750000004,
    267609.93749999994, 250995.8025, 323954.345, 317969.82000000007, 257149.49,
    238481.82000000004, 346652.5950000001, 332789.13250000007, 266800.0175,
    237771.52500000002, 355118.0375, 338420.87250000006, 272586.85250000004,
    250019.5525, 368972.74, 334454.5725, 255416.6775, 198355.54, 311405.3325,
    267155.31250000006, 198722.01000000007, 156039.41499999998, 276728.125,
    241742.08250000008, 188395.4075, 191475.19500000004, 306969.7675000001,
    278882.39, 217253.58500000002, 208703.375, 301204.2575, 322808.4275, 297210.74,
    289151.62, 364147.75, 305553.355, 250003.16499999998, 274244.27749999997,
    366004.74999999994, 349961.32000000007, 306183.61250000005, 328725.55499999993,
    436331.985, 386744.4125, 328377.09500000003, 261575.87250000003,
    334318.99250000005, 301833.465, 234019.05750000005, 179456.7825, 270467.11,
    230094.8225, 231044.28249999997, 268923.70249999996, 376050.5225, 361943.9475,
    319498.5875, 287406.735, 337739.6425, 313389.0525, 259757.955,
    257858.94999999995, 336262.2175, 312415.9675, 248641.94249999998, 225041.595,
    286560.97, 273637.6649999999, 231249.92, 215237.45249999998, 292462.32,
    268146.03250000003, 220261.96250000002, 177830.83250000005, 242398.95750000002,
    225493.49000000002, 199371.36500000002, 180916.91, 276838.4475, 279216.345,
    268356.57, 268248.44, 338447.1625, 299694.82000000007, 242134.40499999997,
    260169.5925, 343720.7025, 291295.235, 235103.54249999995, 240080.88749999998,
    362227.2949999999, 333942.92250000004, 268253.89, 292464.1425, 400867.92,
    368213.62, 277094.5125, 265083.78500000003, 340466.06499999994,
    313522.4224999999, 235858.0549999999, 202781.98, 307983.49, 289335.7975000001,
    287219.5325, 303282.1075, 407463.55499999993, 372798.7675, 289032.4575,
    244200.38749999998, 321835.19499999995, 291302.50749999995, 231555.3575,
    221536.03499999997, 316395.4175, 314746.6675, 305398.1275, 308257.635,
    398980.8725, 364334.4600000001, 319103.7475, 296882.6225, 355018.1275,
    305499.4425, 235012.97500000003, 221665.64499999996, 304560.3550000001,
    275964.835, 222261.84250000003, 191306.81249999994, 251407.2225, 241499.5275,
    215510.57999999996, 170852.21999999997, 243444.95249999996, 274058.4175,
    291573.5025, 288020.2975, 353232.11249999993, 307983.73, 241995.3025,
    261099.9425, 349006.345, 327402.38249999995, 273684.295, 240673.195,
    314413.58249999996, 306375.10250000004, 246146.3449999999, 240690.105,
    324861.10250000004, 318876.0399999999, 284633.1825, 259173.27749999997,
    324301.84, 298521.36999999994, 235043.14500000002, 196681.1775, 272529.8725,
    269520.7025, 255048.71750000003, 200094.86, 242505.835, 247086.175, 209609.1925,
    228602.04750000002, 345109.2949999999, 348116.68999999994, 290777.2174999999,
    228172.23, 319656.3249999999, 310555.97249999986, 269085.91, 238833.33500000002,
    310062.68500000006, 310710.545, 255479.58750000002, 222745.74499999994,
    307155.81499999994, 339616.8524999999, 304775.2275, 262616.515, 296228.225,
    293546.89, 268342.4375, 213270.5575, 220282.6375, 229864.45249999996,
    208116.92749999996, 177149.5275, 248487.42249999996, 255513.83750000002,
    235711.87, 204673.8975, 298363.01749999996, 307452.0675, 277503.31249999994,
    245829.82250000007, 308258.57749999996, 299304.565, 258083.51999999987,
    231050.0199999999, 295428.455, 299164.7525, 255624.38749999995,
    238262.70500000002, 291170.74250000005, 309473.80000000005, 282854.18249999994,
    269730.3650000001, 341561.39000000013, 355776.71499999997, 311658.8725,
    251186.3625, 270419.7949999999, 282378.96499999997, 242914.8425, 195033.8475,
    229181.55750000002, 256510.5924999999, 242078.01749999996, 241864.81749999995,
    345068.9, 348851.90249999997, 307161.7575, 262800.3025000001, 323835.15249999997,
    335528.7949999999, 290096.67500000005, 267852.8874999999, 339486.64999999997,
    346104.5174999999, 324966.2725, 324328.86500000005, 385758.70000000007,
    377616.62749999994, 320691.5325, 273901.25999999995, 344370.76499999996,
    342223.91, 334052.63750000007, 306890.8225, 360121.17499999993,
    358776.02249999996, 331735.18499999994, 303021.1425, 364695.61000000004,
    378797.3275, 353224.1975, 348558.75249999994, 421376.845, 405793.07500000007,
    332212.225, 298011.4475, 408429.77, 420689.6225, 343168.5675, 300242.67000000004,
    390113.8625, 403085.8550000001, 357933.5025000001, 337464.32, 434168.9575,
    393386.83749999997, 304007.105, 313012.3825, 427601.015, 457650.5675,
    400179.1325, 317027.97000000003, 341198.81000000006, 352235.84500000003,
    369575.5775, 336111.1975, 381149.9375, 381798.95499999996, 353557.01749999996,
    320187.745, 424925.12750000006, 413462.2825, 357068.82249999995, 313746.61,
    395941.22750000004, 386807.0074999999, 349727.73000000004, 286697.3025,
    369238.86250000005, 426777.705, 420944.84249999997, 395497.18250000005,
    440327.2700000001, 430921.2975000001, 336916.77, 253476.90750000003, 332694.875,
    328876.48500000004, 319415.4625, 310961.09500000003, 378366.5875,
    326221.7700000001, 294593.02499999997, 236737.99000000005, 293503.22250000003,
    312257.20999999996, 349134.12000000005, 321823.3875, 396983.2850000001,
    374920.7075, 336552.32999999996, 325111.965, 390365.6925, 374092.56999999995,
    321567.72250000003, 281779.72500000003, 346241.00250000006, 339701.67000000004,
    291788.03250000003, 279024.455, 406937.68499999994, 435209.48750000005,
    403431.38499999995, 364923.12250000006, 410665.18999999994, 399912.39,
    313966.2775, 264373.9025, 346314.50250000006, 351949.4325, 283862.62500000006,
    215965.7525, 267920.91, 319612.3525, 316962.2175, 308356.64, 396948.0375,
    407029.3925, 386748.125, 335493.1675, 372188.605, 357840.655, 285460.93000000005,
    255000.255, 314452.78500000003, 316406.17500000005, 275160.085,
    254729.33749999997, 298879.69500000007, 314129.53250000003, 272851.0875,
    267402.01250000007, 335838.70249999996, 321017.50749999995, 282869.01250000007,
    259321.46500000005, 330996.9875, 359300.8075, 345693.0975, 303942.85250000004,
    360509.1925, 402268.06250000006, 399030.685, 387263.49, 448762.23750000005,
    447231.99249999993, 395426.15249999997, 366243.645, 419397.1075,
    363991.06999999995, 313245.8499999999, 289146.645, 410755.2725000001,
    421475.91250000003, 369914.44749999995, 339398.62, 423055.23000000004,
    399378.48250000004, 382489.8575, 357938.72500000003, 401526.2075000001,
    374488.12, 341738.98750000005, 324125.81, 371410.435, 383645.2125,
    382480.26749999996, 318628.805, 310131.39499999996, 320139.885, 305608.36,
    279622.6975, 356847.7075000001, 371537.35000000003, 316541.81000000006,
    229415.40000000002, 268361.195, 275026.37250000006, 249595.23000000007,
    220935.79499999998, 242550.55250000002, 235752.34749999997, 221195.7975,
    201132.925, 242707.13249999998, 248799.2999999999, 233182.57499999998,
    221360.61250000002, 276176.7849999999, 273429.4274999999, 230241.42249999993,
    205821.89750000002, 263682.0875, 268238.77999999997, 254748.845,
    243142.56749999995, 290077.8499999999, 322524.1625, 325426.63999999996,
    312231.6100000001, 364915.57000000007, 375831.76249999995, 342215.7575,
    289062.1650000001, 340104.98, 358184.19500000007, 332016.67250000004,
  ],
  DNK: [
    21848.440000000002, 21965.06, 22467.550000000003, 24465.699999999997, 22864.14,
    38207.75, 48143.979999999996, 45753.310000000005, 40676.52, 44050.72,
    44757.03999999999, 42619, 40110.979999999996, 39579.78, 29161.14, 24054.93,
    25118.43, 35028.01, 41093.99, 38644.68, 34846.19, 35690.96, 32633.9,
    28824.910000000003, 21850.539999999997, 23058.190000000002, 27620.88,
    30404.350000000002, 26320.21, 26000.05, 20174.3, 17146.679999999997, 16404.56,
    17890.699999999997, 18734.239999999998, 16694.29, 13923.2, 15839, 16947.81,
    18795.890000000003, 19083.15, 19490.489999999998, 20524.94, 15127.05, 18845.81,
    24717.26, 24668.39, 27799, 36091.009999999995, 45082.09, 46132.54, 38692,
    30747.45, 33617.33, 35846.79000000001, 32977.76, 35927.28, 30707.22, 21374.86,
    13600.800000000003, 11918.289999999999, 17446.879999999997, 28609.379999999997,
    36527.759999999995, 44832.73, 40307.78, 29305.87, 22053.879999999997,
    20422.300000000003, 28762.06, 34182.39, 34965.33, 36303.97, 41011.880000000005,
    37376.43, 42531.67, 43911.340000000004, 34622.409999999996, 31313.120000000003,
    37324.909999999996, 37404.25, 42992.34000000001, 42736.24, 44237.75, 40652.36,
    47320.810000000005, 46754.17, 44179.97, 41220.89, 46762.39, 39869.03,
    42058.43000000001, 39396.67, 45070.899999999994, 46325.340000000004, 45535.16,
    44683.66, 39457.979999999996, 24164.58, 19911.23, 27385.480000000003, 44012.45,
    46303.11, 43178.31, 34081.79, 33212.05, 33488.189999999995, 33204.83, 27858.89,
    31098.229999999996, 36605.76, 38272.77, 33410.28, 24048.5, 17748.7, 14374.09,
    15932.69, 28609.609999999997, 35070.51, 34935.159999999996, 34824.630000000005,
    41273.84, 47373, 44653.14, 42114.07, 49254.78999999999, 47357.57000000001,
    35612.03, 31519.690000000002, 39136.03, 41503.91, 39104.83, 35524.53, 38610.05,
    39424.549999999996, 37183.31, 31813.010000000002, 36923.509999999995, 37594.88,
    34720.69, 30483.86, 22885.389999999996, 28074.059999999998, 33220.94, 34753.05,
    39500.51, 38797.84, 36635.08, 34238.58, 35260.2, 29667.609999999997, 31378.9,
    31039.54, 25800.08, 19056.27, 18241.440000000002, 32844.030000000006,
    49090.46000000001, 51202, 47267.850000000006, 43490.63, 45453.189999999995,
    44482.9, 42698.409999999996, 39904.85, 44281.09, 43240.65, 34351.4, 24116.91,
    21583.880000000005, 20280.42, 22130.46, 24306.66, 34025.27, 33090.97,
    27359.869999999995, 17457.68, 18166.49, 16465.23, 14526.52, 13786.760000000002,
    19181.84, 21433.68, 28672.03, 28350.379999999997, 32159.699999999997, 32787.25,
    39564.67, 33080.96, 24007.960000000003, 17980.2, 14682.619999999999,
    22368.190000000002, 34609.38, 26661.78, 23113.22, 19185.91, 27611.46, 25865.27,
    26845.6, 28337.440000000002, 31438.15, 33205.119999999995, 35384.84, 39111.03,
    36948.880000000005, 30832.679999999997, 35478.96, 28035.61, 24736.979999999996,
    24679.93, 37359.35, 34742.51, 46596.09999999999, 42382.97, 30437.09,
    19132.690000000002, 18937.66, 18182.079999999998, 19693.27, 18832.94, 19941.78,
    15011.59, 11243.869999999999, 10114.86, 17123.250000000004, 18260.589999999997,
    13885.970000000001, 11487.589999999998, 15058.54, 16580.05, 21274.680000000004,
    25117.98, 25415.87, 25239.559999999998, 30634.4, 40032.15000000001,
    43786.549999999996, 38622.45, 33549.399999999994, 32009.690000000002, 35052.69,
    25957.800000000003, 21405.15, 23055.449999999997, 24311.540000000005,
    17476.489999999998, 23238.33, 22893.45, 26503.28, 28991.120000000003,
    26737.700000000004, 23975.07, 36059.52, 39461.869999999995, 36357.33,
    37004.59999999999, 42175.76, 37310.72, 33158.97, 22717.11, 21220.099999999995,
    19300.85, 18958.44, 16718.88, 22062.28, 21253.67, 16273.29, 14235.079999999998,
    21332, 24611.699999999997, 27269.81, 30967.19, 43131.2, 43788.29, 42877.35,
    41242.770000000004, 42738.3, 46554.92, 48734.84, 45541.41, 50942.79, 43291.02,
    30138.579999999998, 19058.02, 19062.61, 16344.68, 14704.72, 15441.670000000002,
    29900.230000000007, 33786.47, 36665.55, 37010.81999999999, 36367.46, 35645.3,
    33506.32000000001, 32677.64, 39110.79, 38508.58, 39295.58, 38478.92,
    50151.369999999995, 47633.240000000005, 30823.600000000002, 16650.260000000002,
    23971.600000000002, 25291.839999999997, 25879.309999999998, 28816.940000000002,
    35790.090000000004, 33873.38, 31783.480000000003, 28913.06, 33698.590000000004,
    30724.739999999998, 23121.86, 14588.63, 16100.740000000002, 15895.689999999999,
    16238.15, 16779.12, 17819.51, 22323, 34309.93, 34759.34, 40008.35,
    39100.270000000004, 31451.930000000004, 25787.320000000003, 35044.899999999994,
    33539.89, 28926.449999999997, 21245.050000000003, 18864.559999999998, 17796.93,
    12632.880000000001, 12047.23, 19101.27, 18462.82, 12555.42, 12266.550000000001,
    27285, 35367.229999999996, 27402.56, 24370.7, 27859.54, 20778.12,
    13324.689999999999, 12188.119999999999, 17953.32, 26784.059999999998, 28340.45,
    28449.1, 36721.07, 23440.58, 16490, 17713.09, 23994.129999999997, 28703.5,
    22171.2, 12208.48, 12943.589999999998, 11617.12, 8735.739999999998, 9702.65,
    17055.74, 16688.42, 17336.05, 24248.769999999997, 27316.97, 19886.9, 15769.89,
    14752.639999999998, 22287.54, 27514.33, 33045, 32999.86, 27490.640000000003,
    23424.75, 31563.95, 23139.47, 19999.76, 34840.31, 34347.86, 20484.84,
    21896.239999999998, 29868.34, 32340.039999999997, 28504.199999999997,
    31927.200000000004, 30744.01, 24984.78, 23424.449999999997, 25786.49, 14023.97,
    10030.779999999999, 19877.53, 25797.11, 22702.47, 35035.21, 40428.86,
    47111.399999999994, 37181.39, 25435.620000000003, 38343.23, 40773.04000000001,
    32337.799999999996, 21744.37, 25994.730000000003, 35864.72, 31751.149999999998,
    23288.210000000003, 22243.12, 20233.62, 20030.97, 32440.879999999997,
    37203.560000000005, 30447.45, 33605.35, 22489.289999999997, 15231.15,
    27020.410000000003, 27259.41, 23726.25, 22060.719999999998, 30573.58, 26159.76,
    15940.73, 17340.620000000003, 22778.83, 18458.33, 12100.09, 15051.970000000001,
    24306.98, 20890.059999999998, 13919.789999999997, 21268.41, 33842.23,
    31404.689999999995, 18295.66, 10460.17, 22923.120000000003, 19991.809999999998,
    13381.93, 12558.59, 25444.489999999998, 24587.210000000003, 16070.6, 17392.9,
    26962.46, 20451.73, 12781.21, 21451.79, 31547.14, 29311.25, 23047.32, 22357.68,
    23620.61, 20995.03, 13341.81, 15212.88, 24275.41, 20250.12, 15503.83, 19964.54,
    31492.020000000004, 24202.55, 13613.390000000001, 12379.26, 20632.840000000004,
    23077.340000000004, 26226.019999999997, 21270.370000000003, 29044.99,
    23832.210000000003, 30801.560000000005, 23573.92, 35805.42, 22547.789999999997,
    18400.800000000003, 25101.6, 38523.28999999999, 36585.91, 26945.18,
    23635.870000000003, 29005.29, 28909.39, 30430.68, 31486.19, 39519.32, 39687.32,
    32596.99, 31729.94, 41513.35, 27949.650000000005, 10504.309999999998,
    6711.759999999998, 13395.14, 11730.19, 5408.41, 7748.369999999999, 14564.25,
    16785.300000000003, 14376.99, 15209.890000000001, 19064.25, 15025.019999999999,
    14825.170000000002, 17537.86, 22757.94, 16747.48, 9938.91, 11751.199999999999,
    23491.120000000003, 20053.229999999996, 12253.09, 14907.849999999999,
    26198.260000000002, 22235.4, 20322.32, 18738.339999999997, 19233.99, 17958.97,
    10322.26, 10704.399999999998, 17411.809999999998, 14224.96, 7625.799999999999,
    8951.71, 15706.969999999998, 19418.25, 17335.35, 20359.9, 33792,
    32839.979999999996, 22747.28, 22259.4, 26668.51, 33181.97, 23952.789999999997,
    22327.22, 32804.23, 37168.850000000006, 27923.300000000003, 30297.1, 45566.4,
    43867.78, 31352.91, 28843.760000000002, 43173.28, 36829.700000000004, 20455.18,
    17892.719999999998, 23563.72, 18936.25, 9766.939999999999, 8139.59, 17799.88,
    16011.66, 6746.580000000001, 8514.21, 23033.56, 23421.52, 17751.85, 20702.82,
    37018.32, 33962.100000000006, 25860.989999999998, 28412.98, 41198.72, 33061.48,
    17158.629999999997, 13109.22, 13386.549999999997, 12189.2, 9045.8, 9640.48,
    18639.97, 15678.51, 10315.84, 10663.84, 18310.71, 12563.609999999999, 7607.68,
    9005.289999999999, 13952.170000000002, 12992.85, 13553.390000000001, 14317.11,
    23625.43, 20174.42, 7661.1900000000005, 9452.14, 18068.089999999997,
    18271.239999999998, 13046.59, 22837.68, 29645.77, 22661.52, 14772.16, 13479.05,
    20151.06, 13061.43, 8218.060000000001, 11656.05, 21278.08, 20750.35,
    11366.039999999999, 11162.829999999998, 22646.63, 21801.739999999998,
    12451.299999999997, 13485.279999999999, 23415.280000000002, 21826.77,
    21850.200000000004, 23182.769999999997, 28437.010000000002, 25630.57, 13620.41,
    9807.400000000001, 22755.17, 22106.08, 22932.370000000003, 29851.440000000002,
    38319.19, 26228.67, 18428.710000000003, 18833.76, 26929.239999999998,
    20740.350000000002, 10148.339999999998, 12837.620000000003, 28581.83, 24261.42,
    16421.43, 18975.14, 15069.339999999998, 21230.73, 23918.08, 26210.43, 19963.33,
    31958.5, 28462.989999999998, 28998.899999999998, 37764.18, 26524.34,
    12963.369999999999, 15032.28, 25110.28, 27368.78, 23142.66, 25973.049999999996,
    35441.28, 31957.010000000002, 23864.21, 22711.850000000002, 29492.680000000004,
    21658.47, 10220.07, 13950.67, 26079.02, 23015.54, 18883.27, 22849.38,
    22916.350000000002, 24010.41, 18534, 19289.730000000003, 20905.8, 13919.7,
    12403.12, 10366.97, 18844.88, 17563.899999999998, 11121.75, 14869.169999999998,
    23826.519999999997, 18384.07, 9522.18, 16185.09, 31483.48, 35183.31, 22562.26,
    18442.649999999998, 26070.7, 18995.79, 6812.03, 6362.990000000001,
    17518.229999999996, 14496.34, 11265.470000000001, 12118.23, 15881.630000000001,
    19447.510000000002, 13823.920000000002, 13483.65, 19979.309999999998,
    18395.899999999998, 9812.08, 11801.94, 21073.89, 14806.79, 4925.8099999999995,
    7671.84, 19329.61, 15343.270000000002, 6821.43, 8739.16, 20813.83,
    17279.739999999998, 11661.35, 14468.989999999998, 26775.899999999998, 21630.84,
    10904.3, 8506.65, 25416.27, 35642.14, 23541.83, 16613.670000000002, 20927.25,
    16198.980000000001, 8742.1, 12404.49, 13828.630000000001, 16079.52, 12376.75,
    12650.75, 24555.53, 25022.3, 18501.82, 19162.21, 31278.1, 34550.36,
    29503.420000000002, 25536.91, 31188.659999999996, 21154.22, 17138.01,
    25818.280000000006, 30197.559999999994, 31222.84, 25877.75, 28892.090000000004,
    36981.21, 37315.579999999994, 22437.14, 11178.599999999999, 17917.27, 20609.25,
    30805.55, 23696.579999999998, 21858.15, 20428.670000000002, 10440.619999999999,
    10021.039999999999, 21291.240000000005, 17245.11, 6071.14, 7684.33, 18094.56,
    28121.219999999998, 25275.65, 25042.35, 25751.35, 19673.71, 8349.79,
    9643.619999999999, 17965.79, 16614.81, 9234.12, 9896.449999999999, 17404.58,
    18587.27, 24408.649999999998, 25673.16, 17281.73, 14303.85, 11377.160000000002,
    11512.14, 14612.7, 20075.74, 21517.489999999998, 19390.93, 29796.739999999998,
    20019.620000000003, 6829.9400000000005, 9504.72, 17248.78, 15517.73, 7544.32,
    9041.52, 19471.44, 27527.09, 22520.05, 19735.480000000003, 23633.52, 17722.38,
    9686.01, 9632.529999999999, 18505.28, 13280.989999999998, 6079.9400000000005,
    8036.5199999999995, 17257.28, 15164.549999999997, 14787.21, 14967.27,
    20912.559999999998, 15539.140000000003, 9612.83, 11806.67, 22511.100000000002,
    27151.45, 12461.070000000003, 10028.13, 13286.41, 12565.04, 13805.28, 20164.8,
    31436.05, 27565.089999999997, 14228.16, 10456.91, 19197.02, 17159.43, 16273.75,
    17289.7, 16324.390000000001, 16373.98, 11084.08, 9904.34, 20134.02, 15848.3,
    8226.02, 15157.589999999998, 24213.07, 25858.490000000005, 20596.440000000002,
    17461.54, 19292.62, 14378.119999999999, 7253.699999999999, 7652.5599999999995,
    17015.56, 14140.53, 8478.08, 13147.7, 23987.73, 20850.25, 10868.81, 10401.05,
    19638.980000000003, 17555.91, 9021.33, 9243.44, 14642.55, 12107.19, 6886.74,
    7655.16, 15930.58, 11316.73, 7625.870000000001, 8686.85, 18345.8, 25399.45,
    17672.11, 12658.05, 19267.79, 13258.9, 5789.4400000000005, 10884.6,
    22158.510000000002, 16798.27, 16251.9, 15615.970000000001, 20129.47,
    14871.179999999997, 10476.06, 11800.11, 22812.31, 22655.45, 15140.95, 27457.22,
    28962.079999999998, 34075.92, 28148.67, 27016.410000000003, 25600.61,
    30033.769999999997, 26318.730000000003, 25906.59, 21533.97, 23158.239999999998,
    14514.63, 11079.300000000001, 20744.329999999998, 15020.49, 13311.59, 17758.16,
    31670.410000000003, 29906.099999999995, 24424.289999999997, 15311.410000000002,
    18300.66, 14701.480000000001, 9475.15, 8126.220000000001, 19652.68,
    24834.180000000004, 22337.96, 13118.17, 16153.04, 14396.3, 8262.35, 10230.43,
    21951.61, 15234.09, 7792.37, 8971.57, 16552.870000000003, 18254.85, 12543.1,
    10397.669999999998, 19463.35, 14963.760000000002, 14892.330000000002, 21001.65,
    28207.629999999997, 23064.879999999997, 15497.26, 14136.029999999999,
    23689.030000000002, 25275.29, 20588.78, 18173.41, 23313.010000000002,
    27299.049999999996, 25161.49, 22412.12, 25335.159999999996, 32408.11,
    24403.300000000003, 14234.940000000002, 15219.04, 14471.99, 12800.76,
    11960.439999999999, 19996.96, 25658.340000000004, 20854.08, 23842.73, 37329.4,
    25410.74, 11118.34, 9603.09, 26507.53, 24419.62, 13576.130000000001,
    12265.089999999998, 26803.149999999994, 27961.75, 24094.949999999997, 18101.87,
    25424.63, 18988.37, 11260.33, 11655.42, 23310.89, 20072.45, 13485.12, 12237.78,
    19773.01, 12676.47, 6098.21, 7123.379999999999, 14302.76, 12494.84, 10870.05,
    11204.5, 23707.3, 21721.61, 20779.32, 21145.870000000003, 23779.83,
    18088.940000000002, 10545.17, 7383.6900000000005, 15639.68, 19343.06,
    20172.170000000002, 20866.909999999996, 28017.559999999998, 27025.23, 26851.35,
    26979.71, 36651.32, 28983.989999999998, 21887.66, 16221.45, 23063.71, 17129.97,
    11973.52, 11938.09, 20684.81, 16768.52, 9412.35, 9249.45, 13007.76, 19545.35,
    27319.18, 23341.620000000003, 29605.03, 28871.82, 22223.36, 13649.090000000002,
    18716.46, 21286.67, 18535.37, 12807.08, 19821.39, 15723.030000000002,
    13466.419999999998, 15333.58, 26643.32, 25471.31, 21145.01, 16513,
    19412.640000000003, 14299.03, 9114.31, 8503.26, 9914.93, 9549.2, 10184.27,
    10293.53, 16733.72, 17075.39, 11593.630000000001, 12321.18, 20923.49, 15559.09,
    8540.52, 9325.150000000001, 18530.63, 15215.460000000001, 10177.65,
    10529.380000000001, 21793.16, 19517.91, 14875.25, 11664.579999999998,
    19147.140000000003, 17488.39, 11258.61, 8372.960000000001, 19225.52, 14378.38,
    10729.89, 8923.34, 20629.370000000003, 12948.77, 8650.470000000001, 8229.62,
    17546.45, 12018.21, 10161.76, 8630.73, 11943.7, 14365.87, 24017.97, 30968.39,
    35069.02, 21069.63, 8268.03, 12802.789999999999, 27082.4, 27774.309999999998,
    13556.560000000001, 13196.539999999999, 23807.629999999997, 19447.710000000003,
    17153.72, 29477.940000000002, 37097.99, 33644.06, 25924.25, 21023.47,
    16488.760000000002, 12941.48, 12967.72, 19720.06, 40951.340000000004, 40558.93,
    31788.86, 34019.700000000004, 43980.5, 36258.4, 29003.47, 28303.239999999998,
    35733.869999999995, 25179.020000000004, 18899.11, 16963.02, 26101.300000000003,
    15982.500000000002, 9907.35, 10836.85, 19331.87, 13103.57, 9468.57, 9561.84,
    16789.53, 13516.77, 10563.66, 11664.119999999999, 21251.9, 18357.29, 21572.42,
    26767.739999999998, 30739.33, 22859.109999999997, 14457.819999999998, 15770.59,
    24270.910000000003, 24143.120000000003, 15223.57, 11981.650000000001, 17520.15,
    18738.76, 12103.91, 12575.679999999998, 31965.37, 38104.990000000005, 35353.4,
    30302.52, 33552.299999999996, 33122.799999999996, 22878.72, 17257.53, 32140.8,
    32211.640000000003, 26608.809999999998, 13720.02, 20579, 21668.58,
    21447.659999999996, 23320.579999999998, 29666.62, 25415.73, 18052.96, 15255.7,
    21101.52, 17999.969999999998, 18465.92, 26711.379999999997, 45841.73999999999,
    41929.19, 35191.86, 31646.620000000003, 36163.47, 25944.440000000002,
    15451.960000000001, 12162.67, 12817.740000000002, 15336.249999999998, 16084.04,
    13234.220000000001, 14329.209999999997, 15610.49, 18777.62, 20084.42, 18171.43,
    29426.710000000003, 29015.949999999997, 31135.539999999997, 37370.6,
    28244.219999999998, 15978.739999999998, 15699.08, 32579.240000000005,
    38451.46000000001, 28482.06, 23502.989999999998, 31106.980000000003,
    25122.079999999998, 22336.940000000002, 21463.17, 22910.79, 23532.4, 22686.73,
    18586.53, 15026.98, 13879.65, 10516.159999999998, 9217.79, 12970.3,
    16602.010000000002, 23373.83, 18228.149999999998, 26557.57, 27856.88,
    22208.820000000003, 18626.47, 20342.06, 18392.73, 13377.199999999999,
    11554.650000000001, 14666.939999999999, 18731.07, 25276, 31145.549999999996,
    39741.71, 34545.64, 27255.67, 29611.439999999995, 39273.56, 39563.23,
    36673.060000000005, 32788.66, 37020.240000000005, 36076.16, 28159.050000000003,
    17133.059999999998, 15499.819999999998, 13332.600000000002, 19300.59, 27027.11,
    33976.880000000005, 36060.350000000006, 24826.489999999998, 12500.550000000001,
    13637.15, 13920.13, 12116.61, 9937.71, 13373.999999999998, 15698.240000000002,
    12334.699999999999, 10631.289999999999, 16170.81, 18119.13, 13798.55, 12258.8,
    15035.359999999999, 15925.500000000004, 11433.619999999999, 9668.29, 16843.03,
    18754.6, 19285.12, 18399.47, 17114.31, 16266.550000000001, 14662.15,
    13204.259999999998, 14648.64, 15370.830000000002, 16244.340000000002,
    14377.220000000001, 16569.44, 16817.52, 12851.84, 12931.45, 20703.73, 17353.54,
    15281.95, 19342.29, 26216.100000000002, 32081.57, 31052.879999999997,
    29359.799999999996, 32345.17, 24069.299999999996, 29265.940000000002, 32288.99,
    33840.31, 34329.44, 39079.91, 36006.939999999995, 34518.28, 32357.8, 31017,
    31780.03, 37286.75, 36087.05, 32359.259999999995, 29930.060000000005, 33108.25,
    33572.130000000005, 27013.129999999997, 15584.03, 15750.09, 16243.060000000001,
    17000.05, 17408.4, 23547.83, 20258.91, 19034.780000000002, 20021.300000000003,
    19271.93, 17018.14, 14734.779999999997, 15705.24, 17802.239999999998, 29950.66,
    30492.559999999998, 31498.949999999997, 27117.48, 31500.660000000003, 33917.89,
    28561.980000000003, 38607.69, 41625.36, 34124.31, 29016.879999999997, 39580.78,
    35247.5, 33901.35, 38016.22, 40347.9, 33989.51, 28820.179999999997,
    25462.789999999997, 19454.57, 18055.85, 31564.36, 31179.809999999998, 35116.06,
    25512.049999999996, 15762.48, 17204.600000000002, 26227.270000000004, 30360.5,
    32063.64, 32909.81, 35492.52, 32966.39, 27036.44, 21207.66, 24149.16,
    29594.990000000005, 29866.060000000005, 28937.739999999998, 33526.27, 31783.23,
    27576.46, 25569.72, 35041.28, 36425.369999999995, 30498.15, 26281.660000000003,
    27117.18, 24584.89, 21852, 24779.11, 39038.75, 45276.94, 39159.060000000005,
    33530.729999999996, 25177.469999999998, 16340.229999999998, 12670.339999999998,
    17662.489999999998, 29689.61, 32794.87, 27989.459999999995, 25687.14, 32123.39,
    34648.81, 35350.14, 37683.59, 39872.090000000004, 34666.909999999996, 25881.49,
    18890.26, 16664.47, 15779.280000000002, 15609.52, 17528.69, 23252.85, 24937.65,
    18479.85, 15705.210000000001, 19923.16, 19023.04, 15250.079999999998, 16658.8,
    24209.129999999997, 23087.739999999998, 24081.68, 25930.45, 31836.980000000003,
    32195.870000000003, 29620.34, 25089.39, 32368.379999999997, 40126.79000000001,
    36799.48, 32706.560000000005, 37156.09, 37702.09, 38133.18, 33251.68, 27089.53,
    26060.479999999996, 25132.499999999993, 34833.69, 40498.92999999999, 42354.56,
    35103.36, 13957.080000000002, 27380.21, 35198.27, 40203.100000000006, 37528.55,
    38350.850000000006, 27249.529999999995, 33295.729999999996, 31119.29, 33373.88,
    38872.810000000005, 31809.22, 17980.86, 23722.25, 24746.840000000004,
    28050.859999999997, 31940.75, 33177.420000000006, 30023.16, 16561.239999999998,
    10573.68, 21663.34, 29062.85, 27280.99, 22203.58, 21715.37, 23935.97,
    23626.069999999996, 18824.32, 17975.63, 15132.16, 12797.35, 10253.18, 13294.64,
    13818, 13019.81, 13005.25, 16300.77, 22054.489999999998, 24658.200000000004,
    29397.010000000002, 35994.64, 38953.39, 39573.26, 38839.61, 34077.11, 39505.09,
    28846.1, 16580.44, 30539.040000000005, 42712.21000000001, 40228.27,
  ],
  ESP: [
    125826, 141160, 170048, 153152, 140170, 178005, 205432, 192130, 160322, 179590,
    188647, 177373, 133706, 165336, 166702, 159747, 136209, 187593, 221693, 198198,
    171850, 189961, 203785, 183699, 154171, 179102, 207407, 181178, 162926, 217972,
    220957, 193496, 143818, 205172, 216402, 199706, 145861, 201477, 215201, 206127,
    167393, 208693, 222201, 205697, 153747, 203569, 206631, 190035, 141017, 170468,
    182259, 176012, 148849, 169014, 194750, 183027, 157260, 185420, 199864, 194660,
    159487, 188372, 199969, 201190, 175001, 206547, 221483, 207111, 168609, 198562,
    211277, 182954, 155824, 194274, 203500, 191688, 158263, 156912, 175534, 165528,
    140851, 164467, 183688, 163212, 152792, 201152, 215364, 189172, 155022, 199353,
    206261, 179953, 133649, 181335, 196210, 175972, 145972, 197016, 203139, 170212,
    127891, 176600, 185222, 162530, 127710, 159436, 170923, 149722, 140226, 165066,
    175985, 157617, 143156, 177055, 184076, 164682, 135960, 178434, 191554, 168972,
    135408, 189577, 199418, 168570, 139983, 198648, 217977, 189376, 156988, 206781,
    205272, 170952, 123423, 151764, 175668, 145963, 115103, 146947, 163926, 142519,
    113398, 171531, 180914, 167990, 128059, 168407, 188151, 176626, 153368, 196018,
    209029, 195704, 166607, 194228, 204966, 207796, 170936, 195517, 191339, 193378,
    174195, 200593, 208536, 192835, 170569, 168113, 176464, 176380, 169249, 212686,
    221215, 184686, 150190, 182781, 187632, 161909, 131956, 174592, 184566, 173948,
    146414, 189285, 192351, 173121, 151820, 202717, 213436, 184978, 153895, 184608,
    185665, 144575, 117013, 139666, 179724, 168002, 146855, 203109, 214714, 186328,
    157395, 204932, 208324, 169255, 138161, 191164, 202503, 184781, 155619, 201099,
    217172, 191159, 161472, 210151, 214465, 196659, 165821, 191534, 203698, 175762,
    148887, 168171, 182221, 182375, 153158, 198953, 213065, 204368, 160399, 206730,
    213324, 194287, 164947, 207146, 215355, 189821, 157259, 201060, 209158, 200633,
    163525, 214182, 216511, 193801, 155973, 174151, 186439, 175975, 150591, 180306,
    190184, 170473, 145156, 188651, 206224, 185842, 147608, 191527, 199821, 174031,
    131023, 189392, 196027, 169800, 149286, 194824, 209393, 195585, 152118, 198995,
    208405, 189265, 155312, 168235, 185936, 173968, 142018, 158673, 169123, 163817,
    141976, 198105, 206172, 179044, 136787, 187646, 195682, 163630, 131544, 181354,
    194259, 167556, 135584, 184443, 201162, 171419, 140570, 181968, 189975, 155684,
    131601, 168163, 180846, 154814, 139339, 166265, 174799, 146448, 128234, 167543,
    175192, 149583, 129828, 175023, 193570, 162078, 134627, 177881, 192800, 171424,
    147290, 178381, 195231, 166096, 135369, 171798, 182621, 169153, 153936, 168422,
    167036, 163667, 135446, 148991, 152489, 152820, 134669, 170194, 189306, 176128,
    155408, 196040, 207433, 186933, 153575, 191153, 199858, 185300, 161512, 173364,
    180372, 174264, 148571, 157973, 176509, 159516, 131243, 158929, 174284, 167543,
    144349, 152359, 171784, 164546, 142728, 173254, 174459, 171415, 141985, 181764,
    179251, 180105, 152145, 191108, 190092, 166677, 147505, 181783, 183084, 173666,
    148872, 190497, 187604, 169465, 133700, 158208, 163661, 161209, 124579, 134806,
    146426, 144139, 136472, 179148, 181518, 169913, 136670, 186640, 181696, 163978,
    142387, 186362, 186386, 169894, 142593, 185744, 181102, 152848, 127568, 175469,
    175003, 142160, 116344, 152313, 159826, 134924, 113884, 143195, 151667, 137239,
    124781, 186252, 185214, 160159, 136739, 194309, 199041, 175789, 146681, 190067,
    194211, 173009, 148803, 191891, 200606, 175057, 141246, 189693, 181926, 154446,
    135523, 177317, 180036, 167268, 133082, 160783, 167601, 170502, 151701, 190722,
    192165, 183372, 147812, 197924, 203393, 181935, 153667, 207921, 204654, 173348,
    144734, 185822, 187459, 158233, 134053, 185538, 197025, 163381, 135138, 176095,
    181133, 143867, 102938, 148535, 155903, 146081, 127250, 185380, 179185, 147578,
    124574, 188489, 191231, 160941, 141918, 166204, 159417, 157007, 145510, 207241,
    200312, 149548, 127140, 197156, 208379, 166211, 144939, 184264, 187856, 164371,
    129647, 161472, 166818, 155193, 129086, 181152, 207948, 164000, 134926, 201986,
    211670, 179226, 142797, 193999, 208434, 163292, 124841, 176516, 182196, 156545,
    134267, 180627, 188418, 160031, 123036, 158620, 166856, 137831, 107950, 137114,
    141280, 129421, 118603, 184373, 199348, 166686, 139350, 196259, 193545, 163773,
    129892, 196215, 197223, 161826, 135453, 196575, 198492, 151577, 128297, 174634,
    189653, 145909, 110184, 168951, 176546, 131143, 103817, 149362, 160243, 129021,
    113168, 172403, 184240, 139647, 117415, 178127, 191598, 151735, 125032, 183198,
    190471, 145642, 120854, 177801, 185960, 155888, 127582, 184065, 188232, 143264,
    113519, 177110, 182763, 137985, 106157, 143906, 154914, 147789, 127925, 185688,
    195995, 157848, 130552, 182411, 188466, 156439, 131194, 189430, 205202, 164795,
    133087, 202014, 207892, 187511, 160052, 202484, 210895, 182221, 145805, 184455,
    190803, 172487, 140651, 170089, 174901, 167861, 136018, 192160, 190911, 166977,
    130736, 180275, 188133, 160711, 135661, 189873, 198963, 171946, 145571, 198821,
    204910, 177274, 145447, 189236, 205448, 172486, 133556, 162731, 181421, 164255,
    145141, 167079, 172262, 160975, 141648, 181529, 188283, 162518, 136234, 186884,
    197220, 164816, 137294, 188319, 200008, 162160, 128807, 178237, 189420, 162598,
    135528, 196393, 208214, 161254, 130735, 161677, 165897, 143465, 113065, 143181,
    161338, 148901, 128407, 199872, 215003, 176200, 137778, 182897, 201583, 166096,
    136908, 178663, 186260, 164713, 141249, 191990, 207103, 165719, 133433, 201359,
    209984, 156887, 122573, 182939, 193555, 161209, 134584, 170710, 173732, 167207,
    140583, 191525, 196131, 166891, 137343, 195826, 209853, 175802, 150661, 191337,
    203617, 170958, 139023, 186510, 208062, 179610, 145700, 188836, 206959, 175591,
    141563, 168185, 179846, 143237, 116171, 156189, 173273, 150510, 138210, 205209,
    214677, 178959, 148477, 212567, 225155, 185513, 146989, 203173, 221495, 182765,
    146685, 200103, 213630, 189192, 151761, 202158, 223682, 173109, 129454, 172406,
    181960, 162900, 130258, 154858, 167312, 148492, 131158, 192541, 222920, 181739,
    146981, 200867, 220746, 176762, 142823, 200789, 218128, 181594, 147225, 210900,
    239627, 194548, 155266, 219061, 229803, 183869, 140656, 178529, 195566, 157836,
    125807, 162363, 186701, 159531, 138133, 204178, 240849, 187434, 146750, 195487,
    208931, 184095, 150036, 201928, 221269, 187215, 150078, 197473, 211140, 186961,
    152650, 199368, 222854, 183599, 136314, 188145, 223695, 185061, 145708, 187071,
    202797, 170470, 143260, 199919, 218964, 189680, 156336, 203640, 218391, 199346,
    165418, 211035, 227793, 202484, 159418, 200301, 222415, 187263, 152316, 194218,
    212767, 180877, 144771, 181080, 208002, 175845, 137449, 178176, 199794, 178290,
    148015, 200475, 217943, 193129, 157694, 208970, 241859, 206194, 162469, 204596,
    229803, 199517, 161299, 206657, 231314, 198235, 156165, 210937, 234816, 184181,
    144500, 186112, 202394, 173341, 137289, 170393, 189638, 166485, 137739, 183850,
    205991, 175404, 143159, 186936, 210023, 186686, 146032, 195482, 212546, 186386,
    144176, 190406, 213292, 185788, 144582, 191917, 214465, 183965, 136007, 179351,
    205367, 178100, 136646, 169684, 198805, 172252, 139081, 184094, 210151, 178522,
    135252, 177852, 200959, 168350, 132779, 197676, 220802, 175315, 141191, 181734,
    193521, 155815, 127906, 178726, 200343, 162060, 128072, 176959, 196955, 160019,
    122177, 176583, 209123, 173669, 143432, 188453, 203282, 170337, 132820, 178818,
    208527, 180397, 148624, 195207, 204029, 176121, 136282, 177663, 199065, 171725,
    136219, 182548, 201586, 172434, 136043, 175811, 192953, 169833, 141834, 158860,
    183941, 167542, 140851, 188931, 202412, 181801, 149011, 191414, 205886, 184006,
    148950, 193350, 218899, 186542, 152065, 194105, 205926, 190628, 155036, 193901,
    206952, 182632, 143009, 170407, 186076, 161995, 127391, 147762, 175262, 150407,
    128522, 191299, 206763, 173190, 137380, 202182, 220647, 175895, 136112, 208329,
    220380, 173541, 136242, 189422, 196370, 166598, 139134, 204207, 216831, 167540,
    127444, 178613, 181207, 149859, 121253, 163986, 183851, 158173, 138286, 200698,
    210506, 173720, 144602, 199714, 210305, 176687, 142266, 194369, 207092, 165419,
    135414, 201111, 218846, 181831, 150023, 205755, 212181, 181521, 136616, 172447,
    181167, 153484, 129554, 167974, 179850, 168975, 149765, 203721, 217085, 182522,
    150529, 197081, 205458, 176107, 140011, 184269, 196138, 172883, 142191, 181403,
    183506, 168266, 141636, 181056, 183053, 163087, 134891, 159788, 165473, 145670,
    117985, 147304, 160166, 139113, 125581, 176681, 182999, 152860, 125034, 168026,
    174561, 157912, 136984, 183473, 204215, 175115, 160733, 210155, 209908, 176033,
    151992, 190722, 202096, 152887, 122006, 168435, 171759, 139613, 123142, 164025,
    169994, 141338, 123122, 178046, 186858, 156764, 132615, 185984, 204788, 161101,
    141082, 201812, 210717, 183676, 160902, 204056, 210032, 170338, 144513, 200548,
    202604, 160482, 128899, 172463, 181537, 155504, 136647, 166911, 168945, 147514,
    137408, 191249, 197103, 171501, 157833, 198964, 191102, 162933, 139656, 184025,
    195784, 172316, 145094, 183126, 188362, 156377, 123177, 167018, 179005, 169756,
    140130, 149882, 146919, 135014, 108350, 137520, 148110, 134964, 124094, 165975,
    174197, 164093, 140300, 180187, 178973, 156105, 142798, 185459, 190838, 155513,
    131909, 196616, 197898, 176016, 149012, 203543, 200671, 157337, 128088, 153384,
    166807, 144411, 121333, 146299, 150628, 134066, 124199, 181026, 183844, 153856,
    136041, 187967, 195453, 163650, 131855, 187167, 184498, 152753, 133445, 184235,
    194721, 162286, 136387, 175223, 177985, 154118, 128552, 166926, 166450, 138640,
    92078, 140958, 159618, 153522, 133123, 181708, 196626, 173549, 139515, 179797,
    191459, 189157, 154046, 190334, 188283, 163527, 128840, 165058, 169028, 148007,
    117836, 142034, 151006, 132724, 105515, 143953, 164551, 137652, 118179, 150335,
    160921, 140279, 125823, 165110, 178666, 153396, 118909, 162104, 183857, 159965,
    112224, 173594, 191254, 154821, 118700, 173453, 186199, 156788, 125414, 167031,
    170925, 162355, 123270, 151487, 178859, 161399, 138715, 163947, 173696, 158995,
    145449, 182967, 194044, 179029, 152273, 193565, 199614, 179663, 136121, 180160,
    189556, 178699, 139793, 172036, 181203, 166731, 132312, 176303, 178734, 154374,
    126957, 146152, 149274, 128602, 105711, 131587, 143788, 140101, 124277, 174163,
    183604, 168516, 132429, 171537, 184720, 176302, 149305, 200103, 214408, 192017,
    170139, 207409, 220990, 200400, 169502, 198016, 183079, 160829, 118956, 153828,
    170761, 149536, 133453, 161242, 172548, 162128, 149349, 185245, 197914, 174499,
    135342, 176575, 186589, 181219, 133477, 178092, 181620, 172156, 125199, 173600,
    182162, 172388, 132652, 174945, 180739, 167043, 121289, 147409, 161023, 150320,
    116265, 136238, 149361, 148648, 125927, 180272, 189727, 182222, 136316, 190772,
    205834, 190106, 150514, 203934, 208183, 190164, 141846, 193326, 197379, 180519,
    141070, 174173, 188124, 159610, 134974, 174698, 197861, 178590, 159160, 179896,
    191477, 181222, 163676, 207409, 223612, 193663, 149090, 209030, 218672, 196756,
    141937, 211523, 220107, 200623, 143594, 205422, 210502, 192952, 145314, 206531,
    212708, 182996, 135712, 169748, 183900, 176877, 137944, 170171, 180043, 168251,
    124963, 183929, 194566, 186125, 140574, 189968, 197894, 190402, 137740, 186393,
    191938, 183135, 153180, 187365, 210466, 188547, 151414, 190075, 199771, 176007,
    135263, 163025, 175677, 159889, 136456, 174898, 204044, 174994, 160566, 200001,
    218802, 188237, 153608, 185771, 196244, 155430, 133220, 148423, 158798, 139464,
    108071, 153738, 173765, 168928, 126249, 169165, 189988, 175127, 122638, 153354,
    175345, 165698, 122781, 146820, 171528, 162454, 128472, 166554, 182045, 175620,
    127944, 155540, 171329, 156811,
  ],
  FRA: [
    337748, 331658, 367396, 415922, 387700, 439774, 457714, 443493, 385488, 443305,
    463015, 457826, 409266, 436071, 454332, 459119, 412378, 421959, 428450, 421646,
    377167, 404201, 427104, 423143, 390639, 407710, 430940, 449651, 425256, 482335,
    479679, 460984, 425491, 467248, 465836, 454048, 421232, 460945, 461460, 460572,
    441422, 483642, 479944, 479381, 439802, 477993, 477860, 451099, 399401, 428468,
    446411, 431535, 394289, 402920, 423684, 419636, 394336, 450522, 462072, 451375,
    416151, 463944, 456576, 452152, 419434, 478173, 485109, 464726, 429422, 472731,
    464946, 452813, 402357, 454493, 445200, 445992, 395264, 431701, 442341, 454569,
    428508, 432115, 439070, 454968, 431686, 473666, 467434, 452367, 401488, 435697,
    452190, 452841, 411343, 441764, 429957, 412434, 373623, 430162, 420841, 429534,
    393141, 434853, 409504, 402874, 365793, 389914, 398782, 426710, 391184, 403472,
    401897, 415196, 390657, 443111, 426627, 444438, 401721, 434154, 422885, 417982,
    376888, 435513, 411171, 409247, 389339, 418666, 407413, 411675, 365805, 415147,
    407035, 394483, 339902, 364860, 380253, 375795, 331377, 344039, 377608, 376520,
    334420, 400022, 405712, 407373, 373537, 427836, 433718, 437607, 415113, 455482,
    432683, 423005, 384185, 420430, 433651, 429982, 403935, 424422, 411400, 406501,
    353052, 367583, 390129, 391512, 367133, 389807, 404139, 392090, 352670, 407709,
    399173, 402826, 360676, 413477, 420332, 430607, 382616, 429556, 412478, 410746,
    377617, 407434, 394569, 405614, 378792, 395373, 392968, 388323, 347258, 366152,
    371555, 380683, 356113, 376536, 383579, 379928, 340508, 406305, 412105, 405439,
    358968, 413617, 395828, 394853, 357413, 427588, 429181, 429207, 392898, 432728,
    445711, 427570, 387277, 432677, 428480, 406203, 369310, 392171, 404228, 410777,
    356892, 372511, 388662, 411752, 370263, 421491, 439433, 444544, 417891, 448607,
    428528, 423260, 384105, 427794, 414464, 407106, 366186, 409186, 421134, 417530,
    384710, 443617, 433441, 426336, 380529, 388144, 377892, 379532, 339393, 351212,
    371220, 391793, 364228, 424049, 408406, 405804, 376517, 427123, 415150, 407753,
    365666, 412110, 404809, 401515, 383822, 437749, 422053, 422623, 390948, 419132,
    393198, 401051, 370738, 378754, 367045, 367546, 328346, 340213, 347126, 361963,
    341755, 399547, 416319, 414185, 376133, 426309, 415747, 412517, 355270, 397023,
    392217, 382371, 355767, 397579, 385253, 386904, 355106, 394986, 392601, 396491,
    353029, 357434, 348051, 361232, 340115, 349624, 350849, 359317, 333370, 375001,
    362421, 366706, 326597, 370874, 354517, 359070, 330450, 361605, 347875, 352166,
    322219, 362444, 355797, 347361, 313625, 365159, 372478, 362635, 303873, 317438,
    316938, 353190, 292399, 298539, 314841, 352883, 334441, 377732, 369204, 375392,
    342598, 372118, 376921, 383168, 355263, 398023, 403336, 399318, 378220, 414581,
    391078, 402181, 350527, 365494, 358761, 378427, 330929, 337486, 346305, 358457,
    329827, 326408, 308520, 349425, 319038, 351699, 331045, 368041, 345050, 407856,
    385856, 372569, 340752, 396174, 368893, 370200, 351335, 387498, 355674, 345788,
    309795, 368229, 324764, 328185, 293647, 285068, 265704, 290410, 231497, 227090,
    249280, 308692, 291942, 352559, 334296, 330449, 320447, 373348, 354400, 345872,
    328335, 374931, 343260, 332773, 310466, 365651, 343514, 333817, 309160, 351518,
    316617, 331777, 286943, 274718, 264480, 280017, 233368, 243631, 251869, 297073,
    269393, 337505, 327107, 330322, 313273, 362653, 334738, 332601, 313789, 368790,
    360267, 343691, 325749, 378656, 357831, 343492, 333986, 392224, 366440, 356985,
    313789, 345685, 319444, 334363, 305001, 322619, 317275, 344278, 336432, 389013,
    371251, 359892, 346093, 390743, 368215, 356334, 341465, 388471, 371875, 358404,
    336139, 379309, 360856, 353270, 334830, 357563, 350855, 348595, 310192, 312880,
    306055, 336762, 319562, 280511, 282596, 319500, 321355, 351177, 343241, 343407,
    324894, 363229, 342637, 330083, 287362, 265202, 272417, 316457, 310799, 351666,
    356512, 366035, 343443, 374830, 333316, 338333, 306332, 323650, 312455, 325585,
    288865, 290270, 287399, 316131, 312467, 367116, 351097, 348437, 331314, 363693,
    343394, 352918, 322547, 352219, 330505, 345432, 319569, 323638, 317951, 340976,
    313899, 334185, 326675, 331903, 292521, 281277, 272031, 320230, 282922, 240622,
    261606, 322020, 311636, 335145, 331206, 335661, 325573, 315243, 323332, 336291,
    320903, 346641, 342545, 335568, 321320, 344723, 342723, 338117, 321922, 365293,
    348649, 340349, 318049, 308634, 295152, 332190, 299783, 285941, 276227, 324832,
    295999, 317446, 313130, 345580, 321361, 368962, 355009, 354258, 335861, 375560,
    357319, 347370, 321632, 371779, 360477, 343763, 326975, 366672, 356818, 342726,
    315606, 326014, 308117, 335298, 297932, 289388, 296592, 323225, 310281, 352592,
    350113, 352520, 334416, 373647, 365921, 352097, 324949, 368542, 360008, 361624,
    331847, 363667, 360589, 335366, 306459, 360587, 338631, 326500, 287723, 305993,
    299851, 308070, 274262, 285385, 285659, 321635, 306415, 353337, 341395, 324777,
    308350, 353527, 336444, 324276, 295875, 349984, 335534, 327826, 306774, 354170,
    353646, 331643, 314751, 356472, 348601, 325443, 283791, 280138, 291348, 314999,
    259802, 243346, 270407, 314452, 300059, 358095, 342638, 316573, 304723, 350338,
    342704, 327687, 304983, 357858, 341926, 330661, 309200, 362558, 347277, 336320,
    302485, 352488, 350476, 347434, 304601, 288516, 294506, 320497, 285959, 277323,
    277725, 319675, 305005, 348089, 339120, 329952, 318019, 352067, 337637, 319196,
    309358, 362402, 351859, 337055, 313721, 335834, 333818, 321193, 309606, 352896,
    350077, 323039, 295053, 295173, 289605, 307191, 279303, 272651, 283727, 312795,
    304248, 359807, 352980, 330336, 310964, 359352, 349951, 328698, 309448, 355290,
    352755, 323879, 317869, 367924, 366768, 331828, 295348, 338738, 330306, 329498,
    303322, 301575, 313541, 322264, 285943, 288462, 310259, 317166, 302202, 339942,
    343022, 325473, 310821, 344907, 334871, 319505, 305839, 354023, 344843, 324163,
    293228, 338873, 332200, 321601, 293614, 344560, 337602, 325410, 287826, 269208,
    260927, 278472, 240415, 264910, 288472, 309119, 300156, 356746, 351143, 328306,
    317476, 357323, 358918, 326283, 311159, 360115, 352875, 324365, 308868, 355626,
    346786, 330714, 308954, 350654, 351980, 324483, 291938, 301815, 302177, 309819,
    285026, 262147, 285933, 312999, 307366, 350055, 355958, 343226, 320340, 375158,
    373353, 334300, 311156, 356896, 353181, 335045, 311003, 358302, 359766, 331369,
    312631, 360297, 364270, 327164, 297794, 323022, 318751, 318585, 294903, 305507,
    309484, 324625, 306363, 356613, 352715, 326664, 311906, 376578, 371073, 334716,
    308448, 358480, 358802, 328062, 306364, 361667, 359685, 331986, 311509, 358336,
    356550, 328560, 299666, 334741, 333484, 318115, 288715, 284440, 295682, 321923,
    296831, 343796, 355102, 339243, 311453, 358775, 356092, 341246, 306864, 361524,
    366804, 336883, 305064, 358996, 366768, 337301, 313091, 359955, 358761, 331578,
    305489, 334201, 332158, 317781, 289545, 304085, 303138, 317547, 295193, 357121,
    354017, 327193, 307857, 354244, 356655, 330918, 307493, 356336, 356216, 325427,
    298124, 360016, 358424, 318266, 271161, 344928, 328085, 316452, 274444, 287621,
    301137, 318903, 285621, 282064, 295521, 327059, 285831, 340760, 344222, 318586,
    289790, 325209, 330283, 314913, 292665, 326265, 323684, 309258, 283026, 293988,
    288213, 299958, 278084, 327102, 328007, 295291, 269608, 295449, 298925, 299196,
    276705, 300300, 296596, 298945, 283266, 346770, 344321, 311642, 295149, 355720,
    352335, 322800, 289899, 327880, 324061, 302269, 273040, 321401, 329336, 325231,
    298908, 326210, 314887, 314372, 292749, 301250, 301203, 302030, 242244, 251470,
    265017, 289642, 273493, 340901, 342234, 312455, 291497, 336635, 335886, 315270,
    302770, 351701, 348905, 319991, 299848, 339659, 335770, 324638, 302461, 347785,
    351257, 324563, 289839, 298034, 302809, 301384, 276120, 272227, 296709, 302004,
    295056, 346202, 346723, 317499, 301987, 335364, 333455, 315095, 298393, 337922,
    340372, 327015, 316399, 343406, 324448, 308118, 304179, 339926, 336132, 327364,
    290551, 295248, 303732, 307875, 284183, 276412, 294663, 317704, 299058, 348172,
    338690, 308361, 284921, 341137, 350029, 331180, 301189, 338008, 334927, 321552,
    304834, 347798, 338783, 323436, 312055, 354388, 337384, 317989, 296142, 319703,
    310185, 320829, 287359, 301971, 297186, 309944, 293779, 342967, 333439, 322815,
    306222, 356741, 341263, 334079, 312609, 361231, 350692, 334050, 320760, 369466,
    353508, 335802, 317924, 337007, 327364, 325332, 294200, 291106, 294921, 314369,
    285698, 275707, 296922, 312140, 291650, 347517, 341282, 329012, 313890, 365273,
    356927, 331890, 312137, 361194, 346748, 334142, 303271, 346971, 341103, 334305,
    304790, 344726, 327735, 314729, 282088, 298915, 296764, 309659, 297289, 293147,
    303060, 332751, 321308, 380649, 361523, 339674, 319309, 355553, 341224, 330820,
    314343, 346539, 333561, 325641, 315764, 363424, 348165, 336994, 326107, 371944,
    353342, 330885, 305512, 340208, 323286, 327529, 293860, 300296, 304106, 333140,
    313570, 344540, 345471, 346726, 320179, 365830, 359133, 351279, 321520, 370278,
    359557, 357085, 327837, 368253, 357595, 341349, 326704, 365842, 356837, 350507,
    327343, 345020, 339138, 303864, 223506, 257570, 286087, 318170, 326752, 370366,
    354778, 338354, 327544, 370638, 369708, 355158, 329072, 357239, 354031, 340429,
    308576, 334813, 341775, 335752, 316057, 350008, 340974, 344632, 313757, 350232,
    329908, 332556, 290921, 313252, 320265, 309339, 286542, 358576, 361253, 347996,
    317535, 351041, 347545, 341982, 327210, 373188, 365553, 361769, 344755, 375881,
    363516, 366306, 345800, 377773, 353768, 351653, 323298, 350052, 344413, 342729,
    317053, 340080, 336634, 335263, 307753, 363478, 362166, 352046, 319701, 363928,
    366225, 356099, 318531, 366553, 370463, 365191, 328220, 378546, 374052, 351330,
    319512, 353539, 360447, 349580, 311101, 350911, 358748, 357964, 316981, 338254,
    345119, 352890, 332987, 388908, 385803, 380149, 342364, 386447, 387141, 379074,
    347810, 391707, 393621, 384521, 346591, 391586, 390152, 377834, 347299, 397480,
    395984, 369795, 332410, 353012, 298701, 344245, 305378, 330089, 339047, 338847,
    302823, 345140, 356190, 359961, 337742, 409578, 415193, 403299, 362222, 423313,
    419688, 393242, 365704, 414624, 410793, 397597, 370765, 429951, 417108, 380989,
    333915, 368024, 374837, 361130, 340793, 360051, 364092, 369852, 364511, 422589,
    439344, 434011, 407735, 460985, 450446, 417352, 373154, 426888, 429938, 416343,
    377030, 446387, 458311, 428386, 397326, 473980, 461899, 433140, 405482, 453361,
    454662, 427704, 337614, 360049, 374197, 386410, 332304, 407343, 403382, 392558,
    374888, 423821, 424663, 419107, 395366, 444011, 437352, 391149, 351690, 413478,
    417172, 414052, 396259, 453376, 433942, 421113, 371520, 392929, 404967, 398189,
    375011, 405285, 406628, 388021, 371019, 431508, 440942, 417555, 381122, 425758,
    430886, 415203, 386787, 462913, 453993, 432246, 411429, 469511, 462632, 437081,
    396447, 428610, 421697, 429331, 400782, 422141, 431629, 430592, 384823, 415174,
    424983, 425139, 398578, 466818, 469701, 437550, 415831, 481932, 478720, 459367,
    422408, 485280, 490837, 466204, 428255, 488163, 480196, 458851, 430716, 483177,
    473205, 442647, 401127, 436227, 443940, 418166, 377020, 401283, 410585, 404909,
    352787, 438836, 435050, 412629, 377198, 452489, 458969, 442181, 406417, 459085,
    444516, 438075, 394302, 453230, 458230, 428630.45, 384492.83, 445495.4,
    451474.89, 437263.06999999995, 368290.5399999999, 400984.11, 425914.2799999999,
    399434.27, 347153.75000000006, 407017.74, 424979, 425945.30999999994, 392059.71,
    440667.6499999999, 422889.66, 403477.22000000003, 376481.38, 407513.74,
    402248.14, 371821.32, 353303.73, 382727.47000000003, 385741.5299999999,
    386589.99, 368486.92, 413355.95000000007, 432545.19000000006, 439468.50000000006,
    397234.18999999994, 452836.56, 453671.48, 447032.24000000005, 403573.86000000004,
    443235.2500000001, 444030.52, 426765.98, 377106.55, 401236.96,
    409844.43000000005, 393540.73, 358659.38999999996, 405794.97000000003,
    412465.79000000004, 409887.44, 373375.15, 419977.2199999999, 425777.95000000007,
    409691.7,
  ],
  ITA: [
    96766, 108988, 121516, 124538, 93800, 156983, 166125, 138505, 98664, 156941,
    162303, 136560, 99355, 155318, 159337, 130095, 87288, 152311, 158235, 129231,
    94335, 121341, 127589, 119507, 86716, 109351, 125703, 119742, 94665, 178895,
    190806, 156956, 129315, 218251, 220178, 167590, 116124, 232545, 235201, 178227,
    111546, 227553, 224706, 175332, 116412, 224649, 215993, 162137, 106371, 150093,
    153416, 140450, 101344, 134084, 139307, 131687, 107462, 199986, 199050, 162335,
    123742, 224684, 216393, 174493, 129543, 221939, 230649, 170079, 123064, 219904,
    211026, 159605, 121397, 194540, 191683, 153860, 108245, 153005, 152599, 137631,
    104799, 138174, 142555, 128223, 103820, 202325, 204182, 165785, 123512, 201418,
    198685, 162891, 116831, 200585, 197216, 162732, 119046, 199428, 195964, 159775,
    110506, 196728, 189656, 149616, 98853, 141745, 135287, 123035, 88055, 119854,
    125630, 115577, 92420, 183431, 189387, 151816, 108926, 197238, 192853, 160235,
    112240, 199014, 194658, 163664, 108877, 206491, 204709, 169302, 119998, 199305,
    191693, 157059, 100088, 147371, 137544, 125999, 90396, 129148, 126020, 117533,
    98432, 188404, 186000, 157603, 116653, 196244, 188970, 158561, 121697, 203120,
    197852, 164785, 117188, 199724, 190386, 156413, 116514, 199755, 192741, 148596,
    105054, 146097, 138900, 129180, 103424, 121183, 125667, 119138, 102031, 189226,
    186654, 153505, 108501, 186129, 181086, 151970, 114742, 194754, 188571, 153550,
    107803, 188553, 181148, 151485, 102542, 179655, 176818, 142921, 88844, 128764,
    127119, 123776, 78241, 105715, 112071, 112973, 89739, 173854, 174137, 144035,
    99362, 183057, 179395, 150855, 102093, 172449, 170773, 145975, 101454, 193418,
    190907, 149679, 111544, 187381, 182334, 147487, 97870, 131840, 127757, 115628,
    73179, 108596, 115607, 110770, 87090, 180954, 183561, 146365, 106940, 192092,
    193822, 153856, 111924, 197544, 191499, 155946, 120402, 193056, 193012, 155357,
    107200, 190594, 186758, 149585, 92305, 134652, 133762, 120748, 92406, 124829,
    121840, 118843, 102796, 195974, 182248, 152702, 107812, 183637, 186880, 154164,
    111743, 204683, 198437, 158252, 110908, 195411, 192406, 159838, 111598, 196085,
    193802, 157664, 102126, 148141, 141094, 130611, 100825, 124412, 134474, 123993,
    106040, 181397, 185251, 156635, 119239, 193760, 190312, 158108, 112636, 186415,
    181147, 155392, 111594, 180924, 179310, 151598, 107322, 180489, 174592, 144420,
    87481, 124871, 122512, 115638, 79391, 119085, 112741, 112278, 90299, 177198,
    188922, 155499, 111883, 176590, 181030, 156717, 114342, 187910, 186423, 164745,
    109285, 177317, 177967, 155480, 111950, 174445, 170912, 144149, 96192, 137257,
    137683, 124991, 103957, 141449, 135260, 116796, 95477, 167822, 172056, 157545,
    113737, 194196, 191624, 155182, 112563, 195821, 195658, 162703, 117929, 192155,
    186049, 153534, 110922, 166750, 156461, 140211, 104063, 143496, 139231, 125108,
    112557, 141492, 136325, 137079, 116320, 151528, 146196, 126670, 118998, 182350,
    175805, 139740, 121937, 187269, 186435, 144268, 119882, 183441, 173245, 139527,
    116501, 174036, 164053, 138012, 105131, 149950, 144197, 112903, 84655, 138596,
    139704, 107297, 107125, 172585, 169756, 137876, 115960, 177873, 174015, 140317,
    125947, 190487, 183668, 145269, 116545, 172081, 164902, 137356, 115918, 174294,
    165712, 130613, 101277, 155216, 147739, 108926, 87657, 142757, 146098, 111000,
    108627, 169880, 167889, 134613, 117977, 179154, 169541, 138854, 123763, 182387,
    185888, 141625, 125011, 180800, 180846, 140331, 112689, 183588, 178388, 135701,
    112169, 168170, 158271, 126837, 111325, 157274, 144596, 114303, 113684, 200709,
    202551, 158157, 136268, 213972, 207030, 155807, 129607, 195446, 189592, 153180,
    128621, 162380, 160710, 144292, 107246, 179953, 176302, 133168, 106931, 165121,
    159732, 118077, 91023, 147014, 145291, 109557, 105711, 173431, 166470, 137518,
    106735, 164493, 155933, 126639, 100609, 136121, 143612, 118498, 110887, 190036,
    183852, 142883, 126448, 190445, 182691, 136019, 99243, 159386, 147512, 113531,
    88653, 143152, 140300, 104965, 99574, 175596, 173023, 140216, 120544, 184534,
    186999, 148892, 119189, 170745, 171828, 144922, 119078, 170173, 168727, 140211,
    116711, 172455, 169237, 135615, 105550, 155790, 149974, 113432, 87114, 137619,
    136180, 108773, 102428, 167465, 173318, 142631, 122563, 176283, 184845, 150565,
    133649, 191533, 189528, 151363, 122901, 183606, 185069, 151238, 125959, 184057,
    180323, 148338, 110032, 146576, 154743, 125890, 92452, 130506, 140855, 116977,
    104739, 159935, 173210, 144801, 122460, 192646, 189606, 149952, 131159, 196262,
    185251, 148941, 122076, 181393, 177250, 149109, 119396, 179549, 170544, 144762,
    110713, 147047, 135513, 122970, 95332, 150121, 136378, 110995, 101258, 179947,
    179811, 150528, 126944, 190199, 182998, 152461, 128141, 185319, 182183, 154913,
    128353, 190649, 180391, 153780, 129255, 193941, 182900, 146655, 111050, 163785,
    154003, 124474, 102380, 136675, 139746, 118533, 114865, 189981, 188210, 159091,
    132423, 188457, 189242, 157775, 132623, 189164, 189280, 169057, 140058, 191562,
    190656, 164828, 136285, 188731, 188042, 160552, 115690, 154849, 155820, 138503,
    103410, 141301, 144537, 131106, 123490, 199595, 196632, 160418, 136625, 202411,
    200575, 167537, 137200, 204231, 200574, 166086, 133487, 197361, 199553, 161223,
    132525, 188186, 181169, 151419, 116917, 164772, 159345, 134097, 101586, 149422,
    150569, 130998, 124401, 194873, 202841, 171716, 140655, 199877, 211094, 179632,
    147533, 216341, 222242, 185103, 151960, 226961, 232388, 191008, 153597, 230144,
    232719, 181670, 132493, 183881, 189209, 156322, 123287, 160351, 159401, 141600,
    126272, 200615, 205449, 171806, 144752, 210754, 208948, 170558, 140142, 204794,
    213504, 183491, 141931, 203016, 207226, 178064, 141919, 203756, 207985, 172986,
    124018, 169866, 170628, 150623, 116469, 172670, 179429, 155800, 135386, 218640,
    233149, 182361, 145000, 216469, 221577, 177309, 144861, 215285, 209287, 173622,
    147672, 243427, 238551, 178680, 144936, 225739, 218026, 178599, 119385, 183902,
    187668, 144760, 107713, 179679, 189501, 142253, 123221, 204835, 218956, 184670,
    146725, 223560, 238460, 195478, 153062, 232425, 249634, 211045, 165261, 240225,
    260676, 215311, 168373, 246531, 251640, 199015, 142094, 180490, 197112, 174443,
    122477, 166631, 183818, 171725, 146732, 233529, 252333, 205875, 163769, 241099,
    259973, 213613, 168027, 247038, 266966, 218077, 169947, 243723, 262942, 216555,
    165936, 252976, 260600, 203816, 149078, 188965, 199803, 180065, 130089, 159269,
    178671, 172306, 145339, 237281, 247056, 198483, 160937, 236766, 252807, 205059,
    160923, 236197, 249834, 200061, 161370, 229308, 242548, 196744, 158759, 235999,
    235535, 193640, 133929, 172156, 189933, 171788, 122384, 157037, 175224, 168441,
    148017, 237820, 254592, 212877, 169870, 247954, 253716, 212707, 168913, 244705,
    259086, 215441, 168854, 243020, 260374, 210391, 166516, 232303, 248060, 201246,
    144654, 177373, 191679, 170949, 123935, 161639, 176240, 163933, 134472, 201494,
    217602, 181043, 146163, 212995, 222452, 186634, 144015, 211057, 222330, 172942,
    136504, 195933, 207962, 176009, 137196, 193210, 207973, 179447, 129973, 170645,
    189896, 173637, 126991, 161915, 178636, 170217, 133278, 186853, 211289, 185509,
    140720, 191353, 216565, 188425, 142401, 184111, 205246, 174520, 129021, 158426,
    170756, 165954, 132985, 172386, 195215, 177362, 128652, 157700, 179366, 165681,
    119896, 144203, 157781, 144156, 118876, 165085, 172315, 144819, 115108, 165524,
    177746, 153340, 122805, 173296, 189737, 159257, 126614, 169796, 190425, 160244,
    123530, 178459, 201647, 173778, 117576, 161608, 181327, 157481, 111808, 153299,
    173759, 155846, 124178, 203473, 224043, 181615, 148041, 218291, 233073, 180932,
    148682, 214357, 231506, 187160, 146857, 213154, 234105, 187559, 154398, 220068,
    235121, 185011, 129322, 167909, 183549, 157268, 109973, 146017, 162673, 154725,
    136939, 220139, 234172, 181200, 152524, 226349, 235187, 185764, 153830, 231504,
    235542, 183990, 153594, 230142, 224735, 176895, 146005, 220581, 216705, 172354,
    127289, 157757, 167395, 149708, 110161, 142308, 152938, 141110, 135939, 217625,
    214933, 169474, 140732, 212121, 212309, 164391, 139993, 202500, 211319, 166625,
    142702, 207799, 209112, 165061, 135270, 201407, 189465, 143667, 106641, 149795,
    141449, 114438, 89466, 134112, 130791, 112915, 109266, 180619, 191903, 153130,
    134555, 195718, 198483, 153950, 132408, 195363, 196355, 154853, 126625, 186761,
    186618, 145300, 125055, 187538, 189376, 149639, 108301, 146289, 148470, 125808,
    89305, 130086, 132013, 118748, 120788, 199864, 203001, 152017, 126788, 195383,
    192694, 152570, 129906, 191037, 195674, 153652, 129100, 193840, 194055, 150593,
    133693, 198304, 193986, 152485, 120542, 163309, 154791, 124295, 99605, 152807,
    143271, 113098, 106562, 175631, 178239, 138970, 119019, 183241, 188042, 142304,
    123308, 198693, 198365, 145837, 128400, 198815, 197930, 144187, 123719, 186590,
    184341, 138282, 109922, 143737, 142726, 116778, 88063, 139169, 135428, 109901,
    105946, 184129, 193383, 144096, 122963, 195624, 201172, 147576, 128112, 189575,
    191389, 143844, 124905, 184169, 185762, 144011, 124060, 191298, 186492, 137072,
    108052, 147774, 141056, 117026, 99942, 136105, 137405, 117130, 112555, 183660,
    196544, 146515, 126178, 183994, 189503, 141274, 127453, 203572, 200484, 142675,
    129994, 207908, 199584, 148407, 132853, 213717, 189092, 131979, 103739, 147155,
    139458, 119017, 117659, 146223, 143620, 120418, 117776, 183546, 189671, 144011,
    130462, 197954, 198695, 143828, 125459, 201915, 203239, 140136, 123324, 193153,
    196097, 136529, 118754, 188889, 191585, 133976, 99601, 139134, 138190, 109373,
    90147, 128754, 130316, 111535, 94100, 166173, 184612, 145639, 108408, 194369,
    204165, 155062, 110345, 192041, 200935, 156142, 103579, 171806, 181444, 136392,
    95811, 138493, 143618, 117986, 102699, 150104, 155576, 129419, 97840, 133010,
    133817, 113344, 97918, 181166, 200485, 158301, 111621, 194135, 203856, 171440,
    121326, 215750, 218339, 174657, 120232, 212313, 219776, 164364, 110482, 200603,
    201979, 151361, 88522, 137048, 146931, 127541, 94545, 130790, 143990, 126644,
    105678, 201961, 211648, 170299, 120390, 231596, 237063, 183722, 133629, 234929,
    239286, 180084, 120936, 219787, 223380, 176832, 124219, 222711, 218179, 172163,
    108466, 157806, 161638, 139877, 87339, 125610, 140951, 134420, 106123, 199302,
    219402, 176501, 126013, 224053, 230227, 170493, 120861, 209447, 216187, 166505,
    123657, 209871, 232591, 183092, 133025, 209566, 214109, 160678, 106516, 148469,
    151878, 132784, 85503, 115110, 139217, 122296, 96689, 202649, 216286, 165236,
    119401, 220064, 233751, 174326, 132862, 225367, 230835, 174468, 117927, 224790,
    227446, 170746, 121665, 211883, 215599, 151641, 93509, 151810, 154107, 132489,
    95273, 129353, 140030, 123295, 95227, 204043, 215245, 166450, 117047, 230741,
    246440, 182164, 126221, 251152, 255732, 180601, 125278, 231277, 233369, 172649,
    117121, 223197, 228659, 161066, 95342, 151251, 155726, 132005, 90135, 130684,
    142177, 119508, 92931, 205027, 212705, 154393, 109740, 218768, 233062, 171786,
    122968, 248688, 251466, 187407, 131331, 261775, 264516, 209574, 130897, 248701,
    248986, 176118, 91770, 149862, 147028, 123040, 84419, 120279, 131028, 128661,
    94965, 195751, 199886, 156504, 109916, 206636, 211246, 163111, 113204, 211781,
    210198, 159344, 101714, 191949, 196704, 147088, 104344, 174654, 171653, 132003,
    100812, 134122, 129513, 113050, 70568, 112635, 132375, 119592, 100037, 152535,
    153513, 127459, 101960, 151644, 157765, 124658, 93681, 128240, 125656, 119619,
    91845, 127697, 127915, 122635, 94521, 149213, 161816, 140398, 92831, 131492,
    142760, 126567, 85222, 117581, 130161, 122077, 85382, 146389, 159561, 136400,
    83718, 131890, 143455, 124639.25,
  ],
  NOR: [
    72870.6, 82073.19, 105847.63, 89026.84, 78135.9, 128142.17, 147611.38,
    104276.77000000002, 92152.66, 123409.17, 141600.61, 124381.40000000001, 102909.2,
    157147.9, 160618.46000000002, 153856.99000000002, 133411.1, 150482.94999999998,
    144367.07, 145145.33, 131565.24, 142071.33999999997, 149746.69, 140926.3,
    128713.45000000001, 139437.79, 142557.53000000003, 141956.31, 126242.65,
    144032.36, 139021.03, 135088.93999999997, 127580.91, 142606.94, 141887.15,
    136213.08, 126018.78, 139645.16999999998, 142975.13, 136448.24, 124764.46,
    149744.75, 152528.13, 140577.3, 121360.13, 148247.14, 155571.27000000002,
    142616.88999999998, 118139.54, 125312.65999999999, 126117.11000000002,
    117044.59999999999, 103846.59, 133924.1, 139099.2, 125078.17000000001,
    105486.96999999999, 144687.13, 144961.28999999998, 145249.32, 142275.49,
    157878.37, 154884.38999999998, 139747.52, 124292.76000000001, 155232.59999999998,
    149672.49000000002, 144383.2, 139107.45, 152166.22, 151296.61,
    141134.96999999997, 123396.56000000001, 149564.67, 148896.47, 140581.67,
    116826.72999999998, 146338.46, 154173.39, 133306.2, 91944, 102768.42,
    108114.75999999998, 95346.98999999999, 72337.68, 108509.32999999999, 107541.75,
    92664.99, 73690.39, 109437.83, 115514.54000000001, 98997.72999999998, 70015.3,
    102528.65, 109189.51, 104767.01999999999, 96148.12, 142510.84, 143231.53,
    147278.47, 116184.13999999998, 129390.13000000002, 108309.87999999999,
    108673.45999999999, 99113.53, 114686.45999999999, 121614.73000000001, 111744.09,
    97236.36000000002, 89845.55000000002, 98227.49, 96583.12000000001, 86363.56,
    129789.11000000002, 136152.1, 132483.17, 128952.45999999999, 145186.96999999997,
    142945.91, 125506.65, 112399.1, 126216.1, 112901.56, 98448.84999999999, 86387.01,
    111490.66, 117513.19, 119058.96999999999, 96430.07, 122513.70999999999,
    102927.88, 86348.83000000002, 61690.97000000001, 80131.19, 86788.72, 86103.76,
    57542.39, 63290.69, 75888.5, 77352.62999999999, 68036.73, 109961.95000000001,
    119683.87000000002, 111968.51000000001, 84488.01, 139449.66, 135109.23,
    112622.01999999999, 109747.42000000001, 150330.49, 154725.32, 154770.69,
    148234.69, 151745.34, 150324.74000000002, 144512.99000000005, 117761.64,
    151853.38, 155395.33, 144648.2, 142758.19000000003, 155377.4, 154337.12,
    138356.14, 100638.49, 131961.38, 149791.19999999998, 153772.67, 141438.49,
    163579.93, 156990.55, 145416.22, 125750.46, 139732.4, 136309.24, 139782.69,
    119518.92, 146835.88, 148159.14, 143800.66000000003, 127584.49999999999,
    150474.1, 152504.35, 140997.51, 109688.02, 131816.30000000002,
    132429.61000000002, 121277.23999999999, 108296.86, 120010.63, 121299.7, 120380.4,
    106905.60999999999, 101942.9, 121025.56999999998, 121569.34999999999,
    104572.99000000002, 147815.76, 146313.82000000004, 143264.78999999998, 132553.75,
    148080.81, 151231.80000000002, 126993.5, 101790.47, 132793.57, 142034.18,
    118557.71999999999, 92221.36, 136159.63, 135225.22, 95664.76, 74828.54000000001,
    113514.78, 114441.88, 121291.99, 106745.17, 111089.26000000001, 111210.27,
    120604.40000000001, 106139.6, 105914.73, 118521.97, 126807.46,
    114862.62000000001, 136159.91999999998, 135453.8, 136114.86, 129655.15,
    142144.88, 140806.82, 136363.12, 123012.23999999999, 132725.44, 134651.17,
    123040.51000000001, 89200.35999999999, 103224.29000000001, 111110.91,
    113725.98999999999, 105547.95999999999, 132072.18, 136181.72999999998, 130972.55,
    110460.73000000001, 127016.31999999999, 133952.69999999998, 127475.82999999999,
    110900.48999999999, 106681.16, 119474.06, 131374.75, 134115.6, 143182.04,
    143169.57, 135648.24999999997, 123959.84999999999, 135938.86000000002, 136279.01,
    142100.14, 140404.97999999998, 149111.35, 147134.66999999998, 149426.97,
    144314.51, 140830.02, 133983.5, 134781.32, 129625.00000000001, 119666.69,
    102305.42, 119247.32, 80498.46, 83238.15, 96593.54999999999, 105576.85999999999,
    75082.4, 78320.4, 92780.07000000002, 102990.89, 96091.73, 122048.33999999997,
    128228.26000000001, 140132.78999999998, 136263.33000000002, 138796.36000000002,
    138210.18, 137271.52000000002, 128444.69, 149880.54, 146176.26,
    122097.11999999998, 96871.08000000002, 106386.87000000001, 106525.58, 106658.94,
    79458.79999999999, 101984.81000000001, 108246.45000000001, 107528.34000000001,
    77075.81999999999, 88856.81, 93734.98000000001, 113158.72000000002, 109783.12,
    95296.28000000001, 123108.55999999998, 133298.73, 117252.24999999999, 142607.74,
    141883.15000000002, 127598.74, 111237.05, 137716.99000000002, 140040.53,
    135614.10000000003, 127575.29, 140796.80000000002, 140803.59, 138169.08,
    127742.60999999999, 142277.09000000003, 145288.27, 131391.15, 85949.72,
    110870.17, 113475.43, 120157.01999999999, 95372.13, 71036.45, 74057.25, 84010.25,
    63051.08, 70265.13, 96752.98999999999, 130126.45, 126090.65999999999, 133656.91,
    137178.02, 143799.97999999998, 140611.98, 131898.72999999998, 133534.83000000002,
    126275.32, 106787.2, 127304.43000000001, 128537.11, 125225.15999999997,
    104679.96000000002, 101708.65000000001, 89114.24, 84037.81999999999, 58679.7,
    66062.05, 91897.84, 116938.26999999999, 105102.11, 86669.57999999999, 99845.88,
    107354.47, 100071.49000000002, 79971.56, 89503.37000000001, 100130.59, 81816.17,
    93789.61999999998, 76568.17000000001, 75212.40999999999, 71025.89,
    91167.10999999999, 96391.44, 119994.07999999999, 113929.48000000001, 128174.19,
    131283.26, 125128.84, 118660.87, 134300.77000000002, 124286.48000000001,
    119175.52, 101140.62999999999, 109989.48999999999, 97889.57, 108585.65999999999,
    96080.97999999998, 86575.46, 87741.51999999999, 83438.56999999999,
    65081.490000000005, 68915.12, 73125.16, 88861.26, 87641.43000000001,
    111098.06999999999, 117529.01, 124838.33, 116073.4, 105611.62999999999,
    102225.92, 89164.06, 73850.79, 87814.79, 95492.79000000001, 103579.81, 81030.03,
    88671.81, 99022.13, 109094.58, 96942.46, 95726.95999999999, 90336.35, 109308.13,
    85428.40999999999, 70663.14, 76471.31999999999, 84015.57999999999, 67393.66,
    73617.79000000001, 85069.75, 106918.59, 92807.73999999999, 101103.65999999997,
    92657.76000000001, 93849.31, 84418.26999999999, 100670.12, 110031.39000000001,
    119952.71000000002, 114918.6, 118490.93, 119179.42, 120145.43,
    118258.22999999998, 124293.03999999998, 119611.57, 122286.1, 101230.31000000001,
    107766.91000000002, 92020.12, 107296.11, 97912.09, 84951.43000000001, 89585.48,
    116391.90000000002, 104900.28000000003, 77577.4, 88217.48000000001,
    124273.95999999999, 123611.47, 126327.48000000001, 122009.81, 124098.39000000001,
    121082.31000000001, 117821.70999999999, 122099.04999999999, 125704.72, 117787.04,
    122480.09999999999, 117915.79, 127803.27, 120693.1, 120967.84000000001,
    121055.69, 129071.28, 125059.08000000002, 109218.97, 114545.78, 127980.74,
    119568.56, 89011.27, 94479.03, 108182.04, 72451.42, 72411.54000000001, 81213.31,
    102255.82, 113219.28, 101945.07, 101502.31, 110005.16000000002, 105445.03,
    90125.63, 89170.57, 102147.06999999999, 91120.2, 66067.72, 71337.5,
    80588.76999999999, 74171.63999999998, 72488.49, 77762.78, 88433.81999999999,
    88974.65999999999, 96789.76, 102450.42, 96938.53, 88008.41, 88206.42, 92808.03,
    96506, 85782.34, 65076.079999999994, 83639.95, 107300.85000000002,
    104394.79999999999, 119139.40000000001, 121562.43999999999, 115787.05999999998,
    111885.14, 113912.35, 115791.62, 114994.87, 111492.76000000001, 119349,
    122517.03, 124890.14, 118145.59999999999, 84836.45000000001, 96121.52,
    101947.95999999999, 97964.37, 78398.59, 91336.40000000001, 99264.39,
    95045.15000000001, 68643.76000000001, 79435.86, 100146.23999999999, 79710.17,
    54519.5, 70863.48999999999, 100466.62, 98595.92000000001, 86362.34000000001,
    96242.58, 102137.19, 97095.43, 75676.19, 78501.95, 92929.29000000001, 93035.66,
    85555.68000000002, 81943.72, 90442.95999999999, 88086.71, 84048.23000000001,
    79809.70999999999, 83793.38, 82700.15, 87312.09, 78783.73, 87958.07999999999,
    89824.89000000001, 78450.68999999999, 87512.59, 97567, 95087.16, 73735.14,
    78864.04, 100853.27, 92114.97, 76334.77, 86552.09999999999, 102840.06999999999,
    95467.96999999999, 94162.97999999998, 89917.86, 86122.91, 79950.13,
    83722.75000000001, 90987.51, 92995.84, 84258.16, 96025.84, 98582.46, 96594.05,
    95950.69, 107825.12, 103923.35, 98964.18000000001, 93576.19, 86329.21, 87959.19,
    91682.98, 86899.13, 67280.46, 82117.32, 93584.95, 94203.26000000001,
    100878.65999999999, 103628.45000000001, 100607.65999999999, 98455.15, 100300.48,
    101404.40000000001, 97381.89, 88364.47, 92751.43, 96510.82, 102087, 97554.75,
    105784.35, 103895.9, 99426.82999999999, 94839.31999999999, 106410.6, 102751.87,
    101024.07999999999, 92809.45999999999, 84898.03, 81478.36, 87297.59999999999,
    63205.03, 63513.48, 75542.56000000001, 101942.23999999999, 96648.52000000002,
    105236.91, 102411.32, 98605.26, 100695.34, 107224.87, 104029.01,
    100980.72000000002, 85195.43, 85245.85, 88212.6, 101486.83, 101265.96, 90433,
    92598.97000000002, 102533.76, 101999.87, 95367.47, 88366.54000000001, 105464.94,
    87758.91, 65124.11, 70286.7, 84475.87999999999, 63527.49999999999,
    57195.45999999999, 68242.56, 89952.48, 88651.88, 98698.27999999998,
    104784.27000000002, 106880.96, 99850.19, 94351.91, 91228.36000000002, 108465.87,
    104190.15999999999, 98062.97999999998, 102101.28, 108243.32999999999,
    101097.81999999998, 104081.56999999999, 108963.97, 114822.34, 107671.48999999999,
    115670.27, 112222.49000000002, 107932.64, 75870.49, 61179, 68317.75, 88581.68,
    63931.22, 58044.26000000001, 76913.77, 106695.03, 107343.62, 111373.09,
    113179.04000000001, 111350.70999999999, 103553.68, 107079.45000000001, 109454.52,
    103490.08, 102011.29999999999, 99718.12000000001, 86672.5, 103068.11, 103280.22,
    102624.99999999999, 99875.43, 101443.91, 98242.69, 97576.31000000001,
    99010.51999999999, 101733.95999999999, 89066.33, 67761.72, 81104.97, 100417.87,
    92898.75, 62997.37, 81192.4, 104205.15999999999, 95534.76, 94772.95999999999,
    96552.17, 100005.45, 87216.03000000001, 78330.76999999999, 83713.98999999999,
    90735.37, 84305.86, 89764.30000000002, 96797.64, 96874.16, 88923.10999999999,
    93694.04, 91481.23000000001, 95331.98000000001, 83707.98999999999, 84359.11,
    76370.73, 95679.41999999998, 87707.04, 67431.67, 82552.09, 95472.18, 84388.83,
    64480.85, 92037.68, 107035.5, 101447.06, 114144.48000000001, 107229.86000000002,
    103476.88, 96619.43, 102596.61, 101958.08, 103032.55, 99265.75, 109652.76,
    104290.62999999999, 102113.15, 69996.75, 66990.66, 65132.07, 82576.57,
    65171.59999999999, 66959.22, 73518.47, 90012.20000000001, 73453.91,
    56059.95999999999, 55870.39, 54234.4, 53430.880000000005, 51792.11000000001,
    72295.44, 95224.18999999999, 94109.52999999998, 93230.12999999999, 97843.58,
    97938.75, 97021.94, 86244.33, 92262.94, 97456.66000000002, 90875.06, 103197.75,
    106467.76999999999, 99079.90000000001, 94390.26000000001, 107892.65000000001,
    107054.31, 103524.33, 94717.28, 98184.43, 100063.96, 96713.26000000001, 80824.21,
    68653.37, 73659.26000000001, 91993.36, 74952.21999999999, 50576.09, 67859.81,
    92365.43, 91522.25000000001, 81284.49, 93979.15000000001, 101236.66, 92540.56,
    83658.84, 86075.03, 97966.29999999999, 88683.55, 90028.25, 87577, 95722.16,
    92578.02999999998, 90769.51, 92999.28, 95305.39, 89324.23, 92263.03, 93547.67,
    96076.64000000001, 88734.60999999999, 71135.61, 77271.57, 91732.95000000001,
    86735.05, 67974.38, 86368.26000000001, 96350.55000000002, 89982.11000000002,
    91896.59, 86041.4, 95571.43999999999, 91564.76000000001, 95161.31999999999,
    98459.83, 93169.76, 83580.09, 80445.19, 81713.09, 92155.23, 91260.74,
    86067.02000000002, 88327.56000000001, 92494.51999999999, 87885,
    96556.48000000001, 97128.73, 91437.99, 85593.97, 84795.88999999998, 86091.95,
    89909.79, 79988.12000000001, 57487.04, 64604.65, 83887.37, 81524.78000000001,
    67244.62, 77415.18000000001, 92482.56, 86638.51, 73707.69, 83602.97,
    90494.56000000001, 85259.31999999999, 82857.91, 87327.06999999999, 90841.87,
    84021.20000000001, 88888.16, 92312.72, 90269.24, 85862.44, 93044.68,
    90092.68000000001, 88243.36, 81935.03, 62200.83, 73934.07999999999, 86478.01,
    80931.17000000001, 57596.1, 68432.02, 84647.06, 78869.59, 96894.27000000002,
    92465.09999999998, 96261.73000000001, 91007.37, 85264.03, 93094.37999999999,
    94949.78, 89071.31000000001, 94957.88000000002, 92748.78000000001, 91851.54,
    85749.79, 95111.08, 92599.95, 87804.70000000001, 61073.29, 62859.31,
    61598.17999999999, 68601.09, 63012.28, 59779.97, 65942.67, 83189.15, 80647.75,
    55128.259999999995, 69313.04000000001, 87559.99, 76237.15999999999, 76130.23,
    90177.5, 93948.75, 98588.68999999999, 98503.06999999999, 104912.31, 96852.5,
    92345.86, 97383.38, 101209.54000000001, 93062.98, 81405.22, 82617.68000000001,
    87588.38, 92541.18000000001, 85620.03, 91373.83, 94085.29000000001, 94847.46,
    91095.64, 92137.5, 96732.39, 98567.54000000001, 94510.83, 91624.48000000001,
    94732.01, 95958.16999999998, 97017.64, 101466.06, 102039, 95841.8,
    92376.26999999999, 98974.87, 95626.47000000002, 94294.34, 77851.67, 83033.81,
    80834.76, 86746.36, 75695.6, 80440.18000000001, 85448.94, 87231.01000000001,
    75155.06999999999, 73256.27, 70873.98, 87487.97999999998, 93158.31, 78910.93,
    79507.09000000001, 81992.27, 61730.62000000001, 60693.060000000005,
    74220.54999999999, 95072.7, 84525.45, 90878.21, 96176.13, 99348.68, 97458.81,
    98653.42, 100897.3, 96955.68, 91649.37999999998, 101156.8, 101146.73,
    98638.00000000001, 99596.6, 106284.82, 106528.85, 100896.28, 101568.28,
    107844.98, 107691.71, 100798.81, 90700.48000000001, 84388.1, 86559.56000000001,
    99447.85999999999, 93994.62, 78323.19, 87898.58, 100116.62, 96574.64000000001,
    105941.85, 109708.22, 102556.30000000002, 99626.75, 110484.95000000001,
    111097.36, 98628.87999999999, 93333.22, 102759.23000000001, 102349.71, 91946.7,
    86798.97, 88164.20999999999, 87410.76000000001, 89176.48000000001, 85881.11,
    93972.36, 92907.6, 89524.98999999999, 88998.98, 88350.72, 93512.51999999999,
    95696.12, 89496.45, 78464.48, 92502.65, 91363.54999999999, 88060.51,
    100459.12999999999, 105834.76, 87471.13999999998, 74953.94, 81347.76999999999,
    84607.55, 88190.38, 85940.49, 109921.17999999998, 112391.62000000001,
    99967.48000000001, 97085.86, 109908.41, 110665.91, 106036.92000000001, 107274.28,
    116712.88999999998, 113793.06000000001, 102750.36, 93697.07, 86438.70999999999,
    90729.85999999999, 101533.97, 94202.93000000001, 83384.12000000001,
    96941.88999999998, 100876.51, 102587.09, 112045.45000000001, 112663.26,
    104746.04000000001, 98400.36000000002, 109135.66, 109285.23000000001, 97614.54,
    91210.55, 93672.27000000002, 95473.4, 94056.48999999999, 92162, 94142.59,
    90574.94, 90668.31, 89045.81999999999, 93510.78, 93924.5, 93808.73, 86842.18,
    80801.35999999999, 96063.48000000001, 100663.32999999999, 95753.88, 88769.54,
    102792.45999999999, 103491.79999999999, 102501.91, 113141.77, 112682.64,
    95600.01999999999, 91549.28999999998, 114997.79999999999, 114750.23999999998,
    92505.12, 82793.89, 94694.82, 101969.88999999998, 95897.59, 96498.99,
    98992.92000000001, 100060.1, 90522.99, 67067.21, 81405.14, 90860.84000000001,
    85039.96, 71910.06, 74623, 86358.88, 96929.17, 91861.93, 77937.23,
    92079.73999999999, 91996.59999999999, 82899.06000000001, 98419.86000000002,
    89425.29000000001, 76486.43000000001, 75262.26999999999, 97925.19,
    111912.13999999998, 112121.41, 105767.09999999999, 115075.82, 120046.65,
    114655.76000000001, 108674.43999999999, 116193, 118480.64000000001,
    114843.04000000001, 110474.89, 121842.26000000001, 120680.47999999998, 117451.67,
    111141.28, 118848.94000000002, 121554.73, 112202.28, 102792.04999999999,
    88403.58000000002, 103755.66000000002, 106824.02, 102128.64000000001,
    118173.54000000001, 123655.19, 112587.28000000001, 103489.54, 115503.54,
    116720.28, 101150.67999999998, 96562.81999999999, 107345.89000000001,
    108414.48000000001, 100063.96, 93789.52, 107942.81999999998, 99577.97,
    87754.03000000001, 90729.78, 107568.44, 111457.67, 101954.07, 99845.81, 93956.61,
    94233.1, 75320.09000000001, 61128.52999999999, 66352.01, 83388.69,
    105442.70000000001, 105455.29, 118336.65, 115810.62999999999, 102402.43,
    104037.58, 124131.8, 120796.09, 96638.75, 77812.52, 83866.32, 82773.11000000002,
    72008.11, 72783.87, 86140.22, 98479.78999999998, 89639.77, 93949.29999999999,
    107293.03, 110993.91, 94953.35999999999, 86888.56, 94516.09999999999,
    97986.57999999999, 89500.08, 81049.87, 70163.29999999999, 78985.96, 66557.8,
    64326.130000000005, 85259.32, 95335.70000000001, 94329.87, 93284.52000000002,
    103086.05, 101967.54000000001, 94824.21999999999, 91943.9, 100874.03, 102399.32,
    94196.18, 91264.20000000001, 106746.26, 107604.54999999999, 99782.8, 99245.53,
    115819.84000000001, 115600.31, 104133.28, 101697.45, 123787.15999999999,
    124585.31, 101155.85999999999, 87975.89, 96748.45999999999, 102310.48, 104042.03,
    96214.56, 112780.59000000001, 118874.36999999998, 116882.95, 112699.76,
    127660.09999999999, 128307.51999999999, 113069.51999999999, 102794.73999999999,
    111365.69, 115262.42, 118225.78999999998, 109042.82, 122385.98999999999,
    116656.38, 105079.12, 104615.05, 110478.48, 113438.53, 108972.64,
    110532.25000000001, 120083.61, 130519.31, 124115.59, 110813.06, 108238.93,
    113011.23000000001, 107372.12000000001, 110362.11, 133131.78, 126843,
    120829.72999999998, 108404.65999999999, 116801.59, 118575.31, 115080.65999999999,
    109751.48000000001, 127926.83000000002, 124983.56, 117711.48, 111795.14,
    127237.25, 127143.65000000001, 120198.44, 112270.94, 124105.45, 128987.27,
    122058.62000000001, 111773.06, 124855.36, 131276.53999999998, 123784.41,
    118602.97, 126922.47, 131416.39, 134328.27, 123511.75000000001, 138630.85,
    144269.68000000002, 130242.37, 119049.60999999999, 131958.13, 136693.59,
    128032.34000000001, 117954.26000000001, 133689.97, 132444.47, 120838.14,
    105784.69, 133619.55000000002, 144374.51, 125217.87000000002, 116317.18,
    134580.53000000003, 124990.27, 101200.2, 89978.48, 105803.54000000001,
    110284.51000000001, 105587.8, 95806.29999999999, 98580.45, 110875.27000000002,
    109791.72, 107703.06, 139476.38999999998, 142273.74, 143363.99,
    138608.13999999998, 143358.1, 148512.09, 143798.65, 132454.3, 139904.17,
    138666.97, 133968.07000000004, 126560.22, 130799.74, 139183.4,
    140651.99000000002, 138141.25, 143010, 146410.85, 150565.91, 127063.94,
    136754.67, 134348.29, 99595.52, 69976.27, 78687.75, 88393.19, 74988.79000000001,
    64513.05, 103171.01000000001, 111074.07, 96196.87, 84265.51999999999, 108668.77,
    123275.11, 122710.93, 120813.82999999999, 142679.48, 146792.65, 136432,
    110627.34999999999, 145127.42, 149740.46999999997, 145730.22, 131890.23,
    143492.13, 142059.29, 125044.95999999999, 108824.96999999999, 112859.26999999996,
    125280.92, 114622.58, 103017.51000000001, 114955.36, 122850.51000000001,
    107730.42, 91887.57, 125578.36, 145372.25, 126819.68999999999,
    116656.51999999999, 141976.11, 144953.56, 144043.47999999998, 145393.76,
    150281.90999999997, 149517.97, 143247.99, 140174.55, 152699.99999999997,
    149366.24, 124642.98999999999, 92980.18999999999, 148016.74, 150759.46,
    138751.22, 117588.45, 129346.09000000001, 141559.46, 135280.40999999997,
    114562.01999999999, 132019.35, 140431.43, 123491.91, 99906.16, 139446.99,
    146291.08, 139921.65999999997, 138712.84999999998, 150912.1, 154043.50999999998,
    150098.75, 142646.44999999998, 151675.65, 149391.05, 147058.09999999998,
    145205.88999999998, 151241.23, 150117.19, 150687.26, 139517.05,
    146505.65000000002, 149460.24000000002, 137940.57, 121191.03999999998,
    130373.69999999998, 130947.01999999999, 114630.66, 109625.13, 135627.74,
    115218.40999999999, 93644.17000000001, 73565, 116779.78, 120448.86000000002,
    108363.92, 105363.29000000001, 145442.53000000003, 152991.5, 148483.04,
    120527.23, 135404.19, 119853.45, 98658.03, 80396.85, 136249.21, 149858.54,
    131985.38999999998, 112753.17, 138989.89, 153483.15999999997, 131761.21000000002,
    96330.32, 122778.54, 129652.40000000001, 90865.95, 74196.31, 107660.76,
    145180.63, 140028.43000000002, 100652.76, 146648.99000000002, 154611.54,
    155108.7, 145679.28, 157553.93999999997, 138374.85, 108781.94,
    100993.81999999999, 110082.31999999999, 117871.1, 110507.26000000001, 100248.78,
    109057.68, 121529.76000000001, 115545.78, 111695.87, 134648.62999999998,
    144103.31999999998, 125465.48, 107645.84000000001, 120907.17999999996, 129173.01,
    115708.01999999999, 104166.7, 106332.54000000001, 106582.74, 93741.56999999999,
    90431.06999999999, 115275.45999999999, 127105.16, 117252.58, 101450.54000000001,
    126881.47, 140722.36000000002, 100886.15,
  ],
  POL: [
    74749.9, 78166.89, 82888.95999999999, 82022.26999999999, 80540.76000000001,
    105030.22, 113110.53000000001, 103990.99, 98452.74, 125382.24999999999, 121637,
    105252.90000000001, 98668.06999999999, 118211.21, 133127.43, 119575.48999999999,
    103138.59000000001, 121336.88000000002, 124670.25, 108033.90999999999, 93216.69,
    106654.58, 112521.09, 101377.44, 93375.95000000001, 108817.87999999999, 116291,
    107081.25, 105383.42000000001, 141586.79, 137407.41, 113580.4, 103981.64,
    146675.17, 135503.50000000003, 119287.8, 111458.09, 139886.66999999998,
    136185.53999999998, 124705.96999999999, 122835.79000000001, 144861.71000000002,
    143326.22999999998, 123961.87, 105146.65000000001, 138729.21000000002, 146194.13,
    133319.4, 110500.35, 122878.06, 134126.39, 123330.04000000001,
    112980.36999999998, 123261.49, 125081.09, 115287, 113893.33, 148672.29,
    149831.87, 133908.14, 115036.18000000002, 140361.11000000002, 139195.08000000002,
    122858.07999999997, 114046.58999999997, 148446.52, 142250.35, 114887.62,
    100061.62000000001, 123492.15999999999, 125629.48999999999, 114066.32,
    113965.21000000002, 143231.75, 141325.29, 124898.52000000002, 112203.37000000002,
    131341.28999999998, 125010.94, 104506.85, 81818.62, 107990.1, 113583.57999999999,
    110175.62000000001, 111996.40000000001, 142589.88, 143785.36, 125376.29999999999,
    115708.59999999999, 141549.22, 141263.88999999998, 123796.44999999998,
    117412.95999999999, 146015.71999999997, 143663.95, 121949.16, 115842.18000000002,
    133823.01, 132879.15000000002, 114990.66, 104799.55, 129573.77, 133738.23,
    121467.22, 109800.63, 121190.69999999998, 119548.13, 99223.35999999999, 85092.16,
    89252.34, 97806.75, 98713.76, 104029.23, 132614.18, 129761.29000000001, 117064.2,
    105488.98999999999, 134498.18, 130243.86, 119114.54999999999, 108685.34,
    140643.27, 136525.72, 119452.26000000001, 111125.49, 142125.03, 141934.13,
    129166.29999999999, 110427.12999999998, 127509.04, 131195.43, 119502.01999999999,
    104409.56, 119493.62, 121108.10999999999, 108899.5, 98758.14, 107953.14000000001,
    113454.78, 106742.64999999998, 105867.02000000002, 133756.38, 130469.62000000001,
    111044.86, 105271.02, 131368.89, 134077.38, 121385.24, 111840.13999999998,
    135060.27, 135728.28, 110890.28, 99483.02999999998, 127947.98000000001,
    124005.55, 107350.81000000001, 100161.15, 124556.23999999999, 125764.30000000002,
    109716.87, 95809.91, 106691.68999999999, 105300.66, 95861.06, 87007.19,
    97447.30999999998, 98116.87999999999, 96511.61, 93517.84999999999,
    114137.54999999999, 116100.9, 112137.43999999999, 103595.13, 125955.33,
    121844.80000000002, 103231.04000000002, 97482.93, 121954.98999999999,
    116144.75999999998, 105496.00999999998, 97685.1, 112211.11, 111849.31,
    102190.76000000001, 97609.75, 129642.97, 125554.71, 113787.38, 97866.12,
    113891.73000000001, 114500.06, 99383.23000000001, 79707.61, 98201.51000000001,
    101502.84000000001, 100314.90000000001, 98053.72, 124042.36000000002,
    125169.48999999999, 111044.85, 102673.07999999999, 127159.38, 123545.00999999998,
    109660.96000000002, 101133.57, 126667.66, 127722.08, 110058.17000000001,
    102001.26999999999, 124114.7, 124660.33000000002, 115047.37, 106368.69999999998,
    120831.90999999999, 115444.54000000001, 103072.37, 92292.02000000002,
    112394.66999999998, 108501.08999999998, 97429.97, 83427.31999999999, 106156.63,
    99169.79000000001, 88196.29, 87131.21, 122572.62, 118266.46, 100629.93000000001,
    89910.57999999999, 120734.06999999999, 117191.4, 96625.68, 85672.61,
    110320.41000000002, 110834.91000000002, 97047.19, 92080.62000000001, 125140.48,
    120062.73, 108864.04999999999, 98981.03, 130558.34, 121206.07999999999,
    105791.56, 91789.25, 108727.10999999999, 102771.29999999999, 91653.10999999999,
    80615.65, 103585.98000000001, 101262.14, 104240.93000000001, 90653.22, 124400.5,
    119400.94, 105793.9, 96199.51, 115051.01, 113144.10000000002, 102471.70999999999,
    89929.79, 123714.52, 118867.83, 108890.79000000001, 94441.32999999999, 131869.09,
    126421.79999999999, 107052.28000000001, 92176.25, 132280.15, 122281.12000000002,
    106834.49, 85517.11, 115291.82, 109632.29, 98498.87999999999, 86144.74, 98618.84,
    107198.97, 111768.03, 113361.5, 131608.02, 125287.89, 112017.62999999999,
    92005.84, 112348.67, 111743.45000000001, 99704.47, 90736.17, 113331.58999999998,
    114920.52, 103876.19, 96621.86000000002, 120126.31999999999, 115117.81000000001,
    108584.25, 97804.56, 127034.32999999999, 123078.52, 106910.65, 86379.89,
    107423.65, 107879.12999999999, 105231.65, 90155.68, 105222.38,
    105469.59999999999, 97587.36, 91576.26, 120188.92000000001, 120399.83, 105319.16,
    90424.28, 123710.37, 117214.12, 103739.21999999999, 92504.64, 125540.94999999998,
    122778.1, 108421.41, 94507.47, 123660.62000000001, 116510.05999999998, 103760.74,
    91540.94, 120629.39, 122871.1, 112723.26, 87973.9, 100327.44, 107084.17000000001,
    98039.09, 81783.29000000001, 100419.25000000001, 102085.48, 94569.68000000001,
    91360.29000000001, 120113.45000000001, 117727.98000000001, 107267.40999999999,
    89967.57, 126639.57, 128832.01000000001, 120824.09999999999, 106095.83,
    139564.13, 136836.08, 118354.51, 98826.3, 125965.19, 122017.06999999999,
    106787.29000000001, 93219.3, 130139.95999999999, 117287.77, 101857.97,
    72499.70000000001, 99846.17000000001, 98317.51000000001, 91166.20000000001,
    71820.90000000001, 94601.71999999999, 82727.49000000002, 74656.87, 65241.82,
    85989.84, 85869.97, 77514.89, 81076.08, 116277.38, 117824.81000000001, 105114.93,
    106062.54, 123789.76000000001, 114080.56999999999, 92911.19, 91111.28, 116523.81,
    111448.81999999998, 102481.73999999999, 98268.16, 119066.59000000001, 112445.3,
    103030.51, 89966.79, 111566.13, 99678.10000000002, 86623.37, 78853.03,
    108902.51999999999, 96105.85, 83074.23, 89353.01, 116855.17000000001,
    114716.48999999999, 95794.09000000001, 91676.36, 120265.76999999999,
    115534.26999999999, 102161.36000000002, 95853.65, 121660.97000000002, 116606.87,
    93155.31, 88314.76, 125851.13000000002, 117135.87, 98739.37, 91942.83, 117890.61,
    111738.70000000001, 98012.68000000001, 87772.72, 116241.70000000001,
    101502.23000000001, 84009.88, 81505.93000000001, 110225.67, 107660.53, 92848.85,
    91755.62, 121586.04, 109785.79999999999, 97829.18999999999, 99316.77, 133773.61,
    121356.17000000001, 99832.32, 97540.37000000001, 126612.59, 118627.90000000002,
    98744.88, 97153.81, 128428.85999999999, 122389.68000000001, 98946.51000000001,
    101346.76000000001, 125618.34999999999, 117305.56, 100080.72, 91935.45000000001,
    111302.88, 107833.36000000002, 89071.65, 78241.46, 106239.42, 104215.83,
    95212.86000000002, 97914.54000000001, 131144.12, 120437.9, 103368.23999999999,
    100592.56, 130554.18000000002, 119347.1, 97464.12, 94657.46, 119082.80000000002,
    113862.35999999999, 97771.17000000001, 92886.94, 124250.38, 115737.18999999999,
    99756.83, 98657.59, 130723.91, 116513.59, 105419.5, 92526.13, 109855.90999999999,
    102295.41999999998, 91880.23999999999, 78579.18, 105037.31000000001,
    99460.20999999999, 88984.37999999999, 93627.11, 122178.18000000001,
    116813.24999999999, 98817.07999999999, 93919.45, 119595.96, 116216.44, 95517.24,
    79549.45999999999, 96164.85, 92542.6, 81231.74999999999, 75267.16, 102710.89,
    100954.23000000001, 83694.79, 71157.26999999999, 100547.28, 91769.36, 81057.26,
    73810.37, 97269.05000000002, 95491.87, 81094.16999999998, 67682.86,
    91569.87000000001, 91860.21999999999, 81737.15000000001, 81064.75, 115096.03,
    114485.35999999999, 90883.43, 87982.15, 122441.31000000001, 114524.41,
    93273.00999999998, 88285.02999999998, 125155.29000000002, 110525.12000000001,
    90687.65000000001, 84306.05, 119611.51999999999, 111768.95999999999, 88035.19,
    88777.14, 116020.97999999998, 106399.55999999998, 91298.1, 80335.34,
    102530.14000000001, 98067.57999999999, 84547.85, 73920.87999999999, 104775.54,
    95669.68, 85827.26, 84361.13, 117113.13, 118946.38, 100090.6, 89467.12,
    122571.08, 116666.04000000001, 102795.01, 93962.88, 127435.36999999998,
    123130.63, 105108.68, 93818.22999999998, 131158.5, 125686.70999999999,
    103754.45000000001, 95034.78, 133857.48, 125713.88, 99544.13999999998, 85777.75,
    114972.73, 102079.76, 85852.88, 73179.57999999999, 95764.99, 90802.26,
    79542.79000000001, 78657.88999999998, 117005.64, 113363.85, 88879.92,
    82327.14000000001, 124194.76999999999, 116120.39999999998, 99278.81999999999,
    92007.45, 126853.20999999999, 118970.34999999999, 96628.25, 89636.65, 120915.32,
    115550.96999999999, 95307.43, 87397.97, 120948.57, 115497.43, 90023.37000000001,
    75343.59999999999, 109026.93, 96612.69, 84929.23, 72799.53, 99111.84, 94608.91,
    84429.96, 84818.86000000002, 124077.10999999999, 117009.51999999999,
    98381.01999999999, 95027.26000000001, 128479.55999999998, 115503.94, 91106.86,
    85158.44, 117156.61000000002, 111776.48999999999, 91678.95999999999, 76313.45,
    106909.82999999999, 95715.81, 81573.45000000001, 77405.11, 113794, 99427.14,
    80050.14000000001, 69531.61, 108004.60000000002, 93749.23, 74894.26, 64542.91,
    93599.64, 92963.51000000001, 80992.23, 85967.2, 120449.72, 117146.2, 97226.15,
    89893.76000000001, 120153.21000000002, 115035.9, 97228.37, 91358.33000000002,
    124088.65999999999, 116053.08000000002, 95469.42, 88250.07999999999, 124085.21,
    114899.73999999999, 94325.06, 83870.83000000002, 119449.51000000001, 113075.47,
    89298.68999999999, 74946.22, 108717.97999999998, 98021.86, 84882.34999999999,
    73386.09, 95660.46999999999, 93673.35, 79120.12000000001, 82960.92,
    118643.34000000001, 109604.76999999999, 90321.22, 90258.20000000001, 126738.16,
    127441.70999999999, 98566.58, 91370.37, 122122.49, 114642.19, 91521.12999999999,
    84543.25, 119731.5, 109754.27, 100494.62000000001, 92077.84, 124426.37000000001,
    113551.73999999999, 94359.95000000001, 86002.11000000002, 115623.54,
    100310.73999999999, 75022.76000000001, 68909.52, 99709.58, 89559.89, 73536.39,
    81486.01, 124762.76, 117611.03, 95933.10999999999, 91552.59, 129717.66999999998,
    119103.76000000001, 96362.45000000001, 99657.07999999999, 131958.55,
    121297.56000000001, 100238.20999999999, 97028.59999999999, 132902.06,
    118889.62999999999, 88172.46999999999, 86404.74, 135357.84, 120102.16,
    96480.83000000002, 86492.51, 112255.93999999999, 111875.63, 89101.28,
    81981.62000000001, 108047.89, 100618.63, 82915.01, 86105.11000000002, 122147.75,
    112705.41, 94268.88, 93634.68, 126362.70999999999, 120433.49, 97613.36, 92367.35,
    134135.87, 123861.15, 101461.30000000002, 96038.93000000001, 134397.27000000002,
    124647.15, 100094.7, 96491.7, 133558.4, 122941.63, 96107.36, 91976.38999999998,
    124594.87, 111268.84999999999, 93727.23999999999, 93169.45999999999,
    129496.26000000001, 116333.95999999999, 88217.15, 87180.74, 121830.73999999999,
    114559.32, 95282.63, 95478.1, 123876.6, 115831.66, 94163.84, 96127.05, 123055.83,
    112126.68, 90680.8, 89625.33, 121386.84000000001, 117770.24000000002, 97116.6,
    94357.65, 123401.01000000001, 113110.95, 91052.42, 82331.53, 119597.37,
    114005.01000000001, 92668.88, 81545.45, 101194, 91422.00000000001,
    72870.65999999999, 77806.48, 117513.57999999999, 112816.6, 90198.11, 87005.72,
    128167.5, 118587.08000000002, 104505.43000000001, 100745.26999999999,
    146029.75999999998, 130413.67000000001, 107187.67999999998, 96898.72000000002,
    129723.86, 125974.19999999998, 99547.22, 93206.15, 130310.39, 124646.9,
    103721.78, 90607.75, 116399.97000000002, 110712.33000000002, 85887.35, 78175.01,
    100940.87, 96448.72, 80878.60999999999, 81153.82, 126659.87999999999, 120505.04,
    100372.42000000001, 99270.34, 135455.91, 123529.08, 99249.32, 92081.57999999999,
    129597.65000000001, 118656.2, 95471.39, 90477.7, 127573.18, 116809.33, 92270.96,
    86045.01, 126067.90999999999, 113786.27, 88182.25000000001, 77429.74000000002,
    113970.59, 100474.37999999999, 78164.39, 69755.09, 104698.26999999999, 99110.1,
    83389.89000000001, 78790.41, 117780.57, 110677.59, 91626.43000000001,
    86690.84000000001, 120124.65, 112430.57999999999, 86764.8, 80749.17,
    116019.33999999998, 110461.73000000001, 89154.93000000001, 88133.72999999998,
    118942.33000000002, 111083.22000000002, 88426.69, 79154.87999999999, 120454.08,
    106949.50000000001, 81302.77999999998, 72592.33, 103700.32, 93536.06999999999,
    75347.95999999999, 69541.81, 95263.45999999999, 100062.96999999999,
    89720.04999999999, 94625.11, 130954.49, 121256.57000000002, 91698.79000000001,
    89133.87999999999, 125984.92, 111521.22999999998, 82799.91, 81061.95,
    127540.70000000001, 113218.40000000002, 86965.54, 81357.76000000001,
    127274.30000000002, 114145.58, 89395.69, 83819.96, 119593.83000000002,
    109208.48000000001, 88614.37, 79476.81000000001, 107072.46, 99312.89,
    81280.79000000001, 73916.41, 102829.39999999998, 91533.96, 81546.08, 86970.52,
    117601.16, 115787.59000000003, 95192.39, 87195.30000000002, 117721.87, 111695.33,
    87622.14000000001, 83586.83999999998, 127630.69999999998, 113064.83, 93299.91,
    89285.40000000002, 119307.51000000001, 112998.81, 93133.28, 88975.1, 121762.14,
    119953.88, 100400.83, 85196.09000000001, 116012.12999999999, 105864.57, 87115.75,
    80616.19, 113076.39000000001, 108737.54, 84589.83, 84734.52, 126144.26999999999,
    115052.06999999999, 90064.73999999999, 82532.68, 128657.75, 117126.07, 95869.05,
    95433.16, 142885.88, 124728.34999999999, 104625.60000000002, 93240.12999999999,
    115543.23999999999, 101356.13, 81518.74, 77921.95999999999, 119749.92000000001,
    114336.25, 88818.84999999999, 80713.39, 111574.25000000001, 101344.08000000002,
    83023.78, 77012.12999999999, 104648.98, 95995.76999999999, 85111.04000000001,
    85184.63000000002, 121501.16999999998, 118803.81000000001, 97425.81,
    89589.34999999999, 124069.52000000002, 118400.54, 97586.46, 93667.24, 130892.34,
    126143.07, 102270.20999999999, 94201.15999999999, 121659.53, 117629.46,
    98959.04000000001, 95385.08, 127019.43999999999, 125885.12999999999,
    105621.79000000001, 82447.93000000001, 112038.36, 110825.51999999999, 96230.87,
    85769.66, 110627.20999999999, 102154.38999999998, 80915.87, 84509.35999999999,
    116881.79, 116298.34000000001, 98933.90000000002, 90207.22, 129554.88999999998,
    121371.61000000002, 101470.93, 96862.51000000001, 132394.59000000003, 126072.42,
    106300.39, 97431.44, 137068.12, 126887.06, 105074.02, 96467.20000000001,
    135265.13, 121568.31999999999, 99391.26, 90167.82999999999, 111970.21000000002,
    106027.19, 88060.70999999999, 73399.66, 98277.23000000001, 94074.59000000001,
    87116.54999999997, 86016.37, 125822.40000000001, 122989.43000000001,
    104299.03000000001, 97566.07999999999, 135458.18999999997, 129279.18000000001,
    114512.28000000001, 108292.49, 141951.68000000002, 130576.59, 111922.91000000002,
    101714.11000000002, 135193.59, 128938.31999999998, 103671.13, 97340.83000000002,
    136651.12, 124486.70999999999, 105915.19, 92617.83, 119216.52,
    107621.39000000001, 94171.11, 82880.3, 111734.81, 105110.07, 97374.37000000001,
    105820.20000000001, 136936.21000000002, 125914.15999999999, 101121.81000000001,
    92949.76000000001, 117341.56999999998, 114527.05999999998, 95433.75000000001,
    95360.68, 127479.77999999998, 117386.13000000002, 94548.71, 87364.6, 113646.69,
    111258.12000000001, 95648.73, 93021.54000000001, 120165.19, 121591.86,
    104673.97000000002, 92318.26000000001, 110564.78000000001, 109665.06999999998,
    103909.07999999999, 96354.11, 103866.42000000001, 97322.42, 87756.26000000001,
    90506.18, 124696.98, 121934.18, 101785.53, 95810.63, 131805.34000000003,
    119581.92, 98286.12, 88832.12999999999, 127506.58000000002, 114802, 96017.89,
    92311.55000000002, 124650.87, 116533.04999999999, 98240.44, 93831,
    127546.95999999999, 112230.62000000001, 87565.83, 74208.6, 105411.98000000001,
    94503.64, 75891.5, 70662.11, 100190.96, 88968.76, 79020.68, 84923.56999999999,
    123271.9, 115915.58, 99116.46000000002, 92526.23999999999, 133120.24000000002,
    124540.00999999998, 102489.13, 98190.91, 127873.89, 120501.99999999997,
    100440.56999999998, 94690.99, 120366.94, 122841.72, 102149.53000000001, 97936.08,
    126345.91, 120924.45, 100494.23999999999, 93567.72, 114029.04, 104070.31,
    85209.62999999999, 75185.79, 100759.94, 88978.06, 70230.25, 81434.18, 115487.67,
    113241.74000000002, 97410.21999999999, 95982.18000000001, 122427, 110444.8,
    95955.81, 90036.73000000001, 115793.66, 118957.87000000002, 99665.50000000001,
    95663.67000000001, 116641.66000000002, 114370.8, 95583.48000000001, 92623.79,
    115181.95, 112404.80000000002, 98784.17, 88659.06999999999, 102894.2, 97895.94,
    82788.91, 73738.26000000001, 89791.09, 88534.77, 78744.56999999999, 84227.59,
    119789.39, 110559.07999999999, 96102.2, 92987.54, 124462.70000000001,
    121176.93999999999, 103119.78000000001, 98013.43000000001, 119183.12999999999,
    114197.53000000003, 103619.56, 100334.99, 132771.7, 124746.91, 104270.92,
    99340.5, 128251.22999999998, 119594.43999999999, 96412.8, 83063.83,
    111559.26000000001, 101088.17, 95529.79, 85737.85, 100961.48000000001, 101876.28,
    98832.29999999999, 103828.25, 127351.76000000001, 123914.14000000001,
    102166.29999999999, 96008.07, 121738.82, 114515.09999999999, 94419.75,
    97875.43000000001, 133404.96, 127968.85, 110728.61999999998, 109513.67000000001,
    141815.05, 136517.02000000002, 114036.56, 106925.88, 136863.59,
    127143.89000000001, 113230.48000000001, 99666.2, 127794.20000000001,
    110862.11000000002, 94683.48, 81661.63, 102562.34, 96499.51999999999,
    93351.47999999998, 98307.4, 124572.99, 115230.22, 96807.25, 95464.48000000001,
    128926.44, 124028.01999999999, 105761.2, 101089.45999999999, 127406.55, 116874.4,
    97695.34000000001, 94057.29999999999, 127102.08000000002, 118084.84, 105661.47,
    101687.35, 131272.11000000002, 115653.51, 101254.09000000001, 89216.55,
    112493.09999999999, 102393.66, 86196.87000000001, 93056.23, 93505.06, 99444.38,
    100032.54000000001, 90034.7, 114733.04999999999, 117473.28000000001,
    106197.20000000001, 96461.59, 113188.54, 117807.07000000002, 108659.73999999999,
    101912.90999999999, 129758.32999999999, 132495.28000000003, 120206.69999999998,
    104383.93000000001, 131150.57, 133059.35, 116785.20000000001, 101935.03,
    113085.19, 112966.63, 108389.30999999998, 94971.32, 117386.56000000001,
    106276.06000000001, 89408.12, 86629.96, 112902.95, 117841.26000000001, 113830.72,
    102033.82999999999, 121071.11, 122204.77000000002, 107679.82, 102167.66,
    134101.03, 129900.34999999999, 113495.90999999997, 104383.96, 137845.00999999998,
    131593.53, 114139.5, 102875.62000000001, 131233.1, 130570.16999999998, 111497.45,
    98160.98999999999, 124344.06, 127732.44000000002, 115484.88, 97538.97,
    113545.34999999999, 110750.8, 104312.91, 90500.56, 109149.85999999999,
    104725.20999999999, 94914.74, 86863.7, 112245.51999999999, 113864.88999999998,
    99354.6, 96611.6, 134521.93000000002, 134241.11000000002, 116268.43000000001,
    106121.21, 137426.80999999997, 136497.77999999997, 117703.43000000001, 107876.72,
    135072.03000000003, 137346.41999999998, 121833.23, 110131.68, 129715.41999999998,
    133194.11, 117619.12999999999, 99473.43, 120724.5, 119640.49, 111829.96,
    95736.87, 108286.66, 116857.37, 110489.78999999998, 109053.53,
    143178.41999999998, 145265.41000000003, 130168.34, 116255.87999999999, 135120.47,
    146209.61000000002, 131735.95, 116248.38000000002, 141240.68, 137464.14,
    123719.79999999999, 110555.97, 147081.93, 147665.06, 129834.49000000002,
    109859.68000000001, 131472.7, 132251.36, 122077.87999999999, 107678.41, 130970.1,
    128650.02, 107974.55, 98576.36000000002, 108477.19, 116046.60999999999,
    108412.55, 105084.89, 135801.43000000002, 138788.66999999998, 124435.16,
    109125.99000000002, 127998.39000000001, 129252.26, 118526.06999999999,
    106985.52000000002, 130997.30999999998, 128433.88000000002, 119436.9,
    111079.31999999999, 137994.73, 138204.83, 127018.83000000002, 117760.26000000001,
    135604.33, 128741.35, 109584.76999999999, 87272.47, 108419.75999999998,
    105691.39000000001, 104509.83, 92913.3, 102172.56, 105714.72000000002,
    104789.66000000002, 101856.1, 139041.47999999998, 134885.32, 122727.87000000001,
    111232.58, 136350.1, 133682.47999999998, 119635.77, 108057.83000000002,
    136653.62999999998, 134623.72, 120046.78, 104884.95999999999, 134465.78,
    139101.93000000002, 125762.56000000001, 118769.05, 148996.86000000002, 141765.68,
    117869.77, 96803.98, 114721.47, 120045.02000000002, 107572.61, 92113.86,
    108762.65000000001, 110728.92, 101407.76, 101396.11, 140619.22, 147864.06,
    127031.65, 112060.56, 143753.91, 141115.88999999998, 127986.13999999998,
    114788.13, 145476.75999999998, 145534.83, 132900.04, 121167.09000000001,
    144061.07, 145953.26, 134272.69, 117859.77, 145788.96999999997, 145228.41,
    133867.92, 112702.21000000002, 132697.37, 137141.49000000002, 122333.23,
    112217.2, 122598.76999999999, 125088.72, 119272.54999999999, 116193.95999999999,
    143342.79, 145860.2, 129600.22, 121046.16999999998, 144758.13, 148367.46,
    123989.23, 104386.73, 130826.12000000001, 137192.82, 125790.28000000001,
    114631.43000000002, 135717.69, 141107.69999999998, 123506, 114234.79000000001,
    142012.88, 141680.4, 118863.62999999999, 97177.3, 117796.28, 124016.58,
    115652.92, 109850.56, 110226.45, 115745.57, 102268.83000000002, 90467.67,
    123058.06, 124617, 109261.93000000001, 87006.09, 112979.15, 110017.82, 97201.78,
    79886.89000000001, 96148.22, 105671.29000000001, 103384.86, 91395.47,
    108868.98999999999, 105777.15, 101184.9, 91619.23000000001, 112100.33000000002,
    115457.34000000001, 110237.56999999999, 103076.11000000002, 117214.21999999999,
    120481.87, 109815.07, 91901.94000000002, 103812.08, 109854.6, 103252.09,
    101843.07, 124794.69, 128818.98, 118438.78000000003, 105189.91999999998,
    116423.93, 115160.33, 106698.46000000002,
  ],
  PRT: [
    14514.1, 13676.1, 17486.4, 27624.6, 24729.6, 35273.2, 38074.5,
    37179.200000000004, 24837.1, 29003.8, 29865.1, 34865, 20752.500000000004,
    40666.5, 51302.6, 50839.9, 28294.6, 44874.799999999996, 34795.1, 35477.2,
    18298.600000000002, 20657.4, 20995.7, 35740.9, 14025.8, 17780.7,
    23019.199999999997, 33529.4, 14824.199999999999, 33992.1, 44152, 56308.3,
    39585.299999999996, 50355.799999999996, 51056.90000000001, 51634.100000000006,
    40887.70000000001, 58285.1, 57741.600000000006, 56761.700000000004, 30478.9,
    46477, 44457, 57274, 41888.7, 57675.09999999999, 58619.600000000006,
    66563.59999999999, 45939.1, 50367.899999999994, 52712.6, 53963,
    32529.800000000003, 34921.799999999996, 32588.200000000004, 42671.700000000004,
    34383.5, 55849.100000000006, 51609.100000000006, 49547.2, 42561.799999999996,
    63201.4, 59644.5, 57270.3, 43300.6, 54455.49999999999, 51456, 54014.3, 43241.5,
    51503.6, 41182.799999999996, 41672.100000000006, 37077.700000000004,
    56464.200000000004, 52414.2, 48851.40000000001, 36164.799999999996, 44263.5,
    40207.600000000006, 43946, 24021.2, 29606.3, 32134.6, 40896.6, 28391.2, 44535.9,
    43092.4, 43357.5, 25464.6, 45297.7, 40418.2, 48915.1, 28828.300000000003,
    45209.200000000004, 38012.100000000006, 45637.00000000001, 26009.9, 42190.5,
    36654.2, 44168.2, 29635.300000000003, 42437, 39100.5, 46234.20000000001, 31352.1,
    39900.4, 37972.399999999994, 44565.200000000004, 31232.700000000004,
    32016.399999999998, 28857.6, 37403.7, 26594.6, 44846.700000000004, 45752.3,
    47080, 27485.8, 47414.3, 43691.4, 48928.100000000006, 38441.50000000001, 49250.5,
    38452.5, 48054.1, 28748.500000000004, 42003.40000000001, 31133.8, 42817, 26293.2,
    43400.3, 30532.2, 40104.1, 32242.100000000002, 36840.4, 29746.799999999996,
    41140.399999999994, 20426.5, 21991.7, 20931.700000000004, 40774.00000000001,
    26641.400000000005, 42830.40000000001, 37414.7, 46535.200000000004, 24151.3,
    42017, 32338.5, 39639.399999999994, 24065.4, 43457.200000000004, 39605.8, 53051,
    39789, 50499.8, 47108.90000000001, 43794.600000000006, 27792.199999999997, 52736,
    57867.5, 56810.30000000001, 37964.600000000006, 36848.7, 40757.7, 39553.6,
    22988.399999999998, 31216.2, 35986.100000000006, 49377.600000000006, 35913.4,
    33075.6, 27214.899999999994, 50395.2, 34547.8, 43512.6, 40136.3,
    49168.500000000015, 35135.8, 51833.1, 47563.1, 57963.8, 43434.5,
    47251.90000000001, 48499.6, 52848.200000000004, 31618.5, 39986.6, 31106.5,
    47905.899999999994, 28557.1, 28817.199999999997, 29147.6, 47887.5,
    26121.300000000003, 25137.4, 22261.899999999998, 39424.600000000006,
    25977.899999999998, 36930.5, 28108, 48830.399999999994, 34653.3,
    35628.700000000004, 29455.5, 45816, 39837.40000000001, 41822.5, 36910, 50082.2,
    39764.7, 46664.399999999994, 42602.4, 45356.1, 35469.600000000006, 41874.3,
    42647.899999999994, 48064.7, 35165.2, 36035.2, 35072.2, 49923.100000000006,
    37691.4, 42810.299999999996, 44981.4, 44454.5, 38696.8, 49935.600000000006,
    47600, 47425.600000000006, 37772.3, 44925.8, 40547.4, 56898.2, 35990,
    39529.799999999996, 35971.7, 56224.9, 37347.2, 45917.2, 48131.9, 50100.5,
    39196.4, 42390.1, 43495, 52906.8, 41210.2, 49469.9, 48288.100000000006,
    55307.600000000006, 36264.9, 30882.7, 31730.4, 55415.4, 38340.7, 49983.4,
    47533.09999999999, 57711.3, 41469.90000000001, 46026.299999999996, 38873.7,
    54085.50000000001, 47673.5, 47081.8, 45969.4, 64131.899999999994,
    48270.600000000006, 52755.600000000006, 49875.3, 51872.5, 48748.6,
    53062.100000000006, 50336, 59245.7, 37880.5, 47741, 44873.5, 54796.70000000001,
    38648.5, 40408.1, 41908.8, 55519.600000000006, 38179.50000000001,
    41810.70000000001, 36464.2, 55516.7, 45901.4, 46383.399999999994,
    42268.600000000006, 59055.700000000004, 49208.399999999994, 49569.9, 46096.1,
    57793.5, 48055.30000000001, 46674.4, 44255.8, 55714.3, 39626.5, 42505.1, 39007.4,
    52269.5, 46275.700000000004, 40480.899999999994, 37000.5, 51707.70000000001,
    34738.4, 31504, 32787.4, 48006.600000000006, 40675.90000000001,
    44229.100000000006, 42327.7, 47879.7, 33892, 38282.3, 35805.200000000004,
    45179.3, 32254.9, 40453.5, 40787.3, 47462.399999999994, 44335.4,
    48574.100000000006, 41467.7, 59492.7, 47855.8, 45436.80000000001, 43590.3,
    52389.1, 38448.5, 39256.299999999996, 35233.700000000004, 46374.200000000004,
    36653.7, 31876.4, 30676.800000000003, 47593.700000000004, 36217, 51602.2,
    54231.8, 52095.9, 32197.1, 40852.2, 44339.1, 56424.8, 43516, 47636.399999999994,
    47731.7, 54640.10000000001, 33510.2, 42071.899999999994, 48329,
    52413.19999999999, 34405.9, 32458.9, 35253.299999999996, 53571.2, 39649.7, 37774,
    41782.2, 48630.8, 27742.999999999996, 35884.1, 33949.600000000006, 46876.2,
    40873.7, 43071.1, 40973.799999999996, 53394.399999999994, 44564.3, 53452.1,
    51422, 54448, 40386.5, 41575.19999999999, 35227.9, 46934.3, 40671.799999999996,
    44406.4, 43672.1, 52758.4, 43124.1, 46596.399999999994, 39368, 53381.4, 32828.5,
    29303, 25503.9, 42516.200000000004, 23017.7, 26593.2, 27593.600000000002,
    48087.700000000004, 39809.4, 45898.299999999996, 38060.2, 45173.3, 36075.3,
    34895.7, 31008.8, 47837.2, 38358.1, 34837.4, 28236.100000000002, 44156.6,
    37199.7, 37372.8, 32521, 50724.09999999999, 46745.6, 37489, 30458.9, 44829.7,
    36210.200000000004, 27891.3, 26877.4, 37004.700000000004, 30339.9, 19910.5,
    23685.299999999996, 44832.2, 30574.800000000003, 34967.2, 31478.7, 39019.8,
    26144.699999999997, 29807.599999999995, 28478.399999999998, 43081.3, 40773.4,
    36490.6, 27473.1, 44167.1, 37478.5, 36080.9, 27380.199999999997, 45039.9,
    41763.799999999996, 40422.40000000001, 31650.9, 41701.7, 29196.699999999997,
    25415.2, 19690.399999999998, 29363.3, 27165.199999999997, 24923.600000000002,
    20143.3, 27272.900000000005, 25360.1, 30082, 26057.600000000002, 34830.7, 35774,
    30513.3, 26668.200000000004, 39116.1, 32410.6, 25451.5, 24645.5, 44807.3, 36941,
    39561.299999999996, 42638.2, 46501.8, 38310.8, 32592.5, 35077.100000000006,
    47550.50000000001, 36671.3, 32208.8, 31648.199999999997, 40490.50000000001,
    26041.6, 17850.4, 26196.1, 44570.799999999996, 31855.5, 34104.200000000004,
    38114.7, 44650.7, 32476.899999999998, 30515, 37367.4, 40375, 25844.1, 25401.5,
    34918.899999999994, 30068.2, 17794.199999999997, 24482.2, 29311.699999999997,
    35875.4, 24860.2, 29177.899999999998, 33621.600000000006, 41619, 25894.6,
    31428.999999999996, 30793.7, 32434.4, 29996.2, 29764.2, 31675.199999999997,
    39590.1, 27271.800000000003, 34776.7, 30006.8, 42127.6, 33747.399999999994,
    27617.5, 21742.7, 26486.4, 31243.699999999997, 32188.899999999998, 22890.4,
    27934.2, 26286.2, 24329.100000000002, 21982.399999999998, 29113.600000000002,
    20332.6, 22110.5, 23504.100000000002, 25179.7, 19085.7, 19043.100000000002,
    26144, 28199, 18569.6, 21082.199999999997, 25737.7, 31417.1, 22953.100000000002,
    27840.1, 33210.299999999996, 37940, 27242.199999999997, 30681.999999999996,
    35039.7, 37858.899999999994, 25029.899999999998, 25583.7, 32136.100000000002,
    37916.399999999994, 23833.999999999996, 26002.9, 26789.699999999997, 45605.3,
    32866.700000000004, 27294.6, 27909.3, 40791.7, 27557.700000000004,
    21131.200000000004, 25338.899999999998, 32500.9, 19326.3, 17780.7,
    25585.600000000002, 32937.899999999994, 21694.699999999997, 21802.499999999996,
    26701, 37569.5, 25551.3, 25407.6, 28291.699999999997, 32093.1,
    21690.000000000004, 21860.800000000003, 25877.3, 34969.8, 27666, 25633.3,
    24499.699999999997, 33821.200000000004, 21510.600000000006, 22071, 23655,
    35909.9, 17924.9, 19151.399999999998, 23695.5, 26813.3, 17102.4, 17380, 24382.5,
    25346.699999999997, 22573.1, 27261.5, 28497.100000000002, 27452.899999999998,
    21622.7, 23160.1, 23394.1, 31365.799999999996, 22680.100000000002,
    22705.300000000003, 24352.4, 29868.4, 23150.100000000002, 21836.2, 22407.9,
    26845.499999999996, 26890.9, 29322.6, 26531.5, 28773.5, 28969.5,
    28198.100000000002, 23186.100000000002, 28807.9, 28661.7, 25284.9, 21061.9,
    24694.1, 24057.399999999998, 25288.6, 24513.899999999998, 32053.8, 26038.3,
    25624.300000000003, 27023.300000000003, 36075.49999999999, 27453.499999999996,
    24788.8, 26697.300000000003, 30381.4, 19524.7, 19419.2, 20515.3, 27400.4,
    24123.1, 28803.8, 21913.7, 26487.9, 21140.1, 18773.2, 19784.2,
    18391.199999999997, 11437.3, 12130.2, 14069.599999999999, 15890.800000000001,
    12196.2, 19113.2, 19922.200000000004, 23642.800000000003, 19832.700000000004,
    22348.600000000002, 23898.4, 26261.7, 20561.8, 23063.7, 25391, 26857.4,
    22120.799999999996, 21075.6, 26804.9, 27588.799999999996, 19356.3,
    21860.699999999997, 29803.800000000003, 28400.399999999998, 23152.099999999995,
    26560, 28611.9, 26579.299999999996, 19001.5, 20762.499999999996,
    25269.299999999996, 25137.2, 17729.8, 23856.8, 23564.1, 24815.399999999998,
    18735.9, 19615.4, 22801.199999999997, 24793.2, 16147, 19166.5, 23584.5,
    25435.399999999998, 17711.7, 21049.3, 25265.2, 31883.899999999994,
    19732.300000000003, 22689.5, 25298.4, 28853.100000000002, 18227.3,
    22729.999999999996, 23534.6, 26932, 20995, 21142.2, 19742.700000000004,
    19373.999999999996, 17227.6, 20596.300000000003, 23202.000000000004,
    27613.799999999996, 19485.3, 20826.9, 25455.300000000003, 28199.1, 15860.5,
    20050.5, 22049.5, 27779.2, 20994.1, 21405.6, 18717.100000000002,
    21476.799999999996, 16044, 18326.399999999998, 19822.2, 21782.3, 16117.7,
    17090.2, 22453.5, 27693.999999999996, 17197, 16073.599999999999, 19533.6,
    21364.5, 16078.400000000001, 20126.6, 21946.3, 23430.6, 18007.2, 20654.1,
    21705.399999999998, 26305.199999999997, 17020.7, 21577.2, 23939.9, 24677.4,
    18909.5, 23594.699999999997, 21421, 25904.5, 20264.8, 20341.000000000004,
    26526.1, 33976.3, 28013.5, 26986.800000000003, 32199.3, 26472.300000000003,
    21151.6, 20556.1, 25140.5, 29763.6, 21093, 19430.8, 24908.699999999997, 26133.8,
    15643.899999999998, 19565.500000000004, 24771.899999999998, 30679.8,
    21313.800000000003, 20217.499999999996, 23895.5, 30624, 24168.5, 22941.8,
    27096.5, 30425.3, 19910, 22710.1, 24312.7, 23780.600000000002,
    13461.699999999999, 17891.3, 23237.699999999997, 25606, 14129.199999999999,
    15772.8, 20434.899999999998, 25865.5, 19934.600000000002, 22872.3, 28666.6,
    26528.300000000003, 21137, 21893.699999999997, 23676.8, 24819.8,
    16727.699999999997, 22079.899999999998, 24311.6, 29023.1, 18928.1, 21104.9,
    27812.800000000003, 33567.700000000004, 24037.199999999997, 25730,
    30572.900000000005, 38579.8, 30598.3, 25113.9, 30338.9, 28980, 16827, 21540.9,
    22989.9, 23365.7, 21175.300000000003, 28026.5, 23253.399999999998,
    28062.300000000003, 20469.9, 22926.5, 23785.899999999998, 28332.500000000004,
    18935.8, 22952.2, 26012.100000000002, 29733.299999999996, 21842.800000000003,
    25253.6, 30459.699999999997, 33091.399999999994, 26653.2, 28101.2, 31170.7,
    34150.100000000006, 25064, 22797.4, 26859.699999999997, 24939.9,
    17526.399999999998, 19755.8, 21515.1, 24614.7, 19445.5, 26712, 31077.2,
    33916.799999999996, 26269.7, 24174, 24944.3, 26274.8, 18910.4, 21871.3, 27167.8,
    30527.600000000002, 20746.800000000003, 24509.9, 28617.800000000003,
    32284.399999999998, 24698.200000000004, 27794.6, 32119.1, 27730.300000000003,
    19618.899999999998, 20730.6, 23139.2, 24440.199999999997, 15668.900000000001,
    19068.9, 23858, 29368.899999999998, 21772.199999999997, 26434.700000000004,
    31153.6, 34602.5, 21577.3, 25454.499999999996, 28453.200000000004, 31111.2,
    20333.3, 22762.800000000003, 26668.6, 27307.7, 18386.699999999997,
    22750.600000000002, 25855.899999999998, 27728.5, 21185, 21709.899999999998,
    23891.5, 27121.7, 20909, 20760.9, 22453.7, 23310.5, 13371.399999999998,
    17877.399999999998, 24570.2, 24697.1, 17881.1, 24399.6, 31623.800000000003,
    33345.9, 25615.199999999997, 28248.999999999996, 32466, 32178, 21614.3, 24420.9,
    28783.6, 23826.299999999996, 18775.899999999998, 20839, 22729.4,
    23746.300000000003, 17549.700000000004, 20825.9, 24200, 29241.3, 20665.4,
    22057.300000000003, 30825.5, 29445.1, 21463.6, 23250.299999999996,
    26367.199999999997, 22007.3, 17805.5, 22220.199999999997, 28256.9, 31426.8,
    27236.7, 28931.9, 29465.3, 26469.5, 21433.899999999998, 22635.4, 23946.2,
    29890.1, 24679.1, 23229, 27431.5, 30574.099999999995, 21939.5, 22240.6, 24106.3,
    26317, 16254, 19482.3, 28008.4, 21876.5, 21797.6, 24068.499999999996, 23167.3,
    21010.199999999997, 16350.800000000003, 20397.199999999997, 22175.100000000002,
    25964.5, 16368.3, 21247.7, 25654.4, 28847.5, 19733.4, 23390.399999999998,
    27711.199999999997, 28237.899999999998, 17713.2, 22189.8, 26938.999999999996,
    23797.1, 17793.2, 21018.7, 23277.200000000004, 20400.5, 13208.9, 16999.1,
    23455.6, 26103.7, 18365.1, 19168.6, 28502.7, 31350.300000000003,
    24194.299999999996, 25188.5, 32995.3, 36603, 24427, 27865, 28266.000000000004,
    31216.800000000003, 24109.9, 27527.700000000004, 26796.500000000004,
    26528.899999999998, 22446.5, 23605.800000000003, 27099.5, 31547.9,
    23915.699999999997, 27473.899999999998, 29325, 29476.6, 23944.6,
    21473.800000000003, 22099.9, 26109.000000000004, 18458.8, 19740.7,
    24660.800000000003, 20750.9, 16488.6, 20945.5, 24576.9, 28123.5, 20411.4,
    23688.5, 26318.8, 26759.399999999998, 24006.800000000003, 28048.6,
    31157.299999999996, 34638, 30112, 30619.899999999994, 32129.9,
    31154.700000000004, 26364.6, 33440.8, 27768.2, 30737.999999999996, 28477.6,
    26031.999999999996, 20667.399999999998, 22021.300000000003, 11820.7, 17429.6,
    17361.3, 23981.6, 26369, 30276.100000000002, 25864.5, 30614.8,
    28203.899999999998, 32363.799999999996, 26760.4, 29280, 28759.5,
    29689.000000000004, 24340.6, 24627.9, 20642.7, 27788.1, 25364.5,
    28932.600000000002, 21623.199999999997, 27423.8, 25007.6, 26386.699999999997,
    11505, 17860.3, 20184.3, 22269.399999999994, 12064.2, 15049.5, 20221.4, 27086.1,
    19188, 24172.800000000003, 27893.5, 34553.1, 21975.4, 24942.9, 24396.9,
    29400.200000000004, 20142.9, 30304.8, 35564.8, 33992.6, 32371.1, 35976, 32347.5,
    27540.799999999996, 25174.799999999996, 28569.9, 29155.3, 33254.7, 22972,
    23072.4, 18292.7, 22582.399999999998, 10463.099999999999, 15631.800000000001,
    17697.8, 20083.100000000002, 14869.599999999999, 22753.2, 23735.9, 31218.3,
    19341.8, 26361.599999999995, 29194.5, 32958.6, 20153.800000000003,
    31745.900000000005, 37120.5, 29200.6, 21313, 24040.3, 24505.300000000003,
    26483.699999999997, 15287.6, 19822.9, 22515.4, 28167.1, 17607.199999999997,
    25273.7, 32155.6, 28419.9, 27426.2, 30715.6, 33531.2, 30677.7,
    23846.600000000002, 38522.8, 38999.100000000006, 35211.3, 30462.6,
    34726.299999999996, 38763.799999999996, 41668.8, 40072.7, 42096.49999999999,
    42803.3, 27483, 17665.8, 23760.7, 25168, 33041.6, 36263.9, 45781.9, 40747.3,
    41072.799999999996, 29041.1, 26112.2, 25638.7, 34608.7, 31202.9, 29253.7,
    25368.100000000002, 29952.1, 21130.3, 35621.7, 33328.9, 30009.600000000002,
    20707.3, 33460.2, 33259.4, 35996, 24224.999999999996, 29761.500000000004,
    31860.4, 34213.5, 28330.6, 36850.4, 35150.8, 29293.3, 18636.5, 26511.8, 28306.5,
    31337.2, 20356.1, 27457, 26677.200000000004, 27204.800000000003, 17336.8,
    20580.6, 22212.600000000002, 27342.999999999996, 16683.4, 26561.100000000002,
    28345.700000000004, 31583.899999999998, 22102, 36270.600000000006, 30911.9,
    33057.799999999996, 27845.100000000006, 36922.600000000006, 31156.8,
    31851.600000000002, 24164.4, 34481.7, 32649.1, 30775.999999999996, 27088.2,
    39153.5, 38045.6, 37963.7, 17964.9, 23579, 30200.7, 35851.8, 20579.7,
    25019.100000000002, 30069.5, 40882.700000000004, 28228, 40195.8, 36138.9,
    45432.600000000006, 31829.1, 43445.100000000006, 39398.3, 42228.1, 28525.9,
    34713.200000000004, 33466, 43583.1, 29913.4, 42475.5, 41696.3, 43214.7,
    25152.699999999997, 27902.5, 30186.5, 40676.6, 25203.6, 29742.1,
    27209.600000000002, 37449.5, 22847.499999999996, 28053.800000000003, 31577,
    43402.6, 26180.5, 39649.3, 38075.2, 42422.50000000001, 26443.4, 37944.2, 35941.7,
    38100.90000000001, 24216.8, 34368.6, 32782.2, 42051.299999999996, 25398.4,
    34157.7, 35180.799999999996, 41661.6, 21035.899999999998, 30599.399999999998,
    31596.9, 28245.5, 15380.7, 21622.899999999998, 25941.600000000002, 27654.5,
    18704.499999999996, 24557.9, 29118.3, 30255.3, 21674.399999999998, 32432,
    31717.699999999997, 36147.5, 30020.199999999997, 34996.299999999996, 31586.8,
    40665.4, 31006.899999999998, 43485.1, 45105.3, 47792.299999999996,
    32351.399999999998, 44887.100000000006, 49706.2, 47459.9, 26062, 41946.4,
    42143.3, 44001.9, 30646.899999999998, 36120.7, 37368.99999999999,
    46650.40000000001, 26783.300000000003, 25596.800000000003, 25301.699999999997,
    33826, 11219.3, 22901.399999999998, 27375.100000000002, 36468.700000000004,
    15493.2, 26662, 28033.5, 33165.6, 23548.9, 31961.9, 29724.4, 36171.7,
    28537.299999999996, 33715.8, 37394.5, 41413.799999999996, 27179.699999999997,
    26072.500000000004, 27297.800000000003, 37925.09999999999, 27031.899999999998,
    36883.100000000006, 41054.200000000004, 40653.899999999994, 35481.3, 37014.2,
    38641.7, 38742.3, 26994.200000000004, 28965.699999999997, 29066.399999999998,
    31943.200000000004, 14146, 27204.2, 28511.899999999998, 31113.099999999995,
    14721.4, 28075.2, 28568.399999999998, 41389.9, 30393.1, 40347.5,
    41129.600000000006, 44111.1, 26548.8, 31843.300000000003, 28764.399999999998,
    36978.1, 20456.3, 28254.9, 28051.100000000002, 31763.9, 20625.4,
    23644.899999999998, 27617.5, 32520.300000000003, 14526.9, 23237.399999999998,
    24506.2, 25530.6, 13756, 23320.5, 30592.699999999997, 35435.4, 24608.9, 24730.1,
    26125.1, 27716.600000000002, 13636.099999999999, 21546.8, 26312.2, 30381.2,
    14264.8, 19299.2, 21996.5, 28574.699999999997, 26497.4, 30614.699999999997,
    34333, 38355.399999999994, 31767.8, 35586.2, 36489.9, 37958.799999999996,
    28582.4, 34636.5, 34739.6, 31427.899999999998, 15336.7, 26907.6, 33724, 38759.5,
    21438.5, 35545.6, 37669.700000000004, 41283.9, 22923.399999999998, 44598,
    44696.600000000006, 44567.2, 21864, 42230.799999999996, 39997.3,
    41505.899999999994, 16760.8, 19689.3, 20747.299999999996, 25380,
    16305.899999999998, 27012.7, 28938.199999999997, 37123.7, 30571, 40736.6,
    38475.5, 45725.7, 28546.3, 34998.3, 35108.99999999999, 38890.600000000006,
    24864.399999999998, 37984.3, 38955.1, 43031.2, 32652.4, 35447.6,
    31003.300000000003, 33032.2, 21889.5, 32879.5, 29570.300000000003, 37448.6,
    22345.5, 28002.5, 29827.3, 37392.9, 17231.699999999997, 23725.199999999997,
    32434.8, 38449.9, 31235.800000000003, 35338.1, 36403.1, 45706.79999999999, 32140,
    40187.3, 37467.2, 38141.700000000004, 24471.499999999996, 29075.200000000004,
    24607.7, 30905.9, 17054.800000000003, 22719.699999999997, 23206.7, 27554.7,
    12565.199999999999, 24708.399999999998, 23516.5, 27581.3, 16485.5,
    21396.399999999998, 20933.9, 26814.500000000004, 12813.3, 17538.1,
    21145.600000000002, 26863.7, 11815.800000000001, 22841.5, 23768.800000000003,
    31316.600000000002, 14242.2, 25320.3, 26329.899999999998, 29980.4,
  ],
  SWE: [
    101324.09, 112052.76999999999, 131082.80000000002, 123640.95999999999,
    113507.70000000001, 142418.14, 148124.59, 133209.25, 123078.32,
    145925.03999999998, 150414.12, 145980.53999999998, 129626.64999999998,
    143357.25000000003, 144873.95, 139128.5, 124525.26999999999, 138884.85,
    134175.55000000002, 123635.71999999999, 111265.85999999999, 122846, 125489.95,
    123824.44000000002, 119454.98000000001, 130430.13, 139105.02000000002, 137777.52,
    136505.34, 144083.43000000002, 144143.63999999998, 141032.54, 137765.19999999998,
    147163.54, 148702.59, 144579.37, 139194.47, 143742.00999999998,
    146553.55000000002, 140058.06999999998, 131549, 144101.53999999998,
    134687.22999999998, 137267.12999999998, 141931.1, 153606.23, 139058.87,
    129011.40999999999, 123929.70000000001, 130013.30000000002, 135990.24,
    134357.43999999997, 120774.49999999999, 123039.69, 128578.56999999999, 131960.7,
    130782.40000000001, 152364.5, 152743.46000000002, 142097.24000000002,
    127488.28999999998, 139265.57, 145526.66, 147720.74, 141135.55000000002,
    159357.13999999998, 159166.78, 147577.97, 137307.43000000002, 148825.34,
    152733.72, 148903.29, 146497.91999999998, 145318.90999999997, 137389.41999999998,
    127354.42000000001, 121638.55999999998, 125958.29999999999, 129888.00999999998,
    141323.69999999998, 137881.99000000002, 142528.86, 151523.38999999998, 139771.53,
    125093.64000000001, 155112.84, 149990.37999999998, 134307.13999999998,
    121745.04999999999, 146826.41999999998, 153106.06, 136718.86, 114561.91,
    144190.32, 139689.30000000002, 130964.51, 121778.07999999997, 131909.86000000002,
    129540.67000000001, 123362.46999999999, 125978.44000000002, 146119.92,
    147122.41999999998, 135712.27000000002, 128221.43999999999, 136657.23, 141143.98,
    131446.36, 124127.19, 127484.77999999998, 135101.56, 131600.58, 130318.39,
    139891.21000000002, 129873.68999999999, 119917.22999999998, 112456.69999999998,
    126883.18, 129805.68, 125684.45000000001, 124653.82999999999, 148398.72000000003,
    149790.19999999998, 136329.9, 127354.09999999999, 137693.16999999998, 135573.99,
    131669.83, 126051.36000000002, 147229.46, 148910.83000000002, 129615.81000000001,
    123936.33000000002, 127683.90999999999, 135836.75999999998, 132300.90999999997,
    124738.94, 128526.42000000001, 138987.55, 136913.83, 122394.16000000002,
    151788.34, 134198.08000000002, 122718.73000000001, 111951.21999999999,
    124113.89999999998, 130976.36000000002, 129794.45000000001, 116178.56,
    126055.45999999999, 126316.4, 125546.21999999999, 123872.38, 136029.38,
    133239.19, 128248.25, 116291.80000000002, 139263.35, 143303.81000000003,
    143997.97, 131245.87, 140773.43000000002, 143154.37, 140744.48, 127779.95,
    138478.78999999998, 144847.36000000002, 144937.38999999998, 139275.66,
    150546.50999999998, 144990.18, 139303.31, 130217.38, 138548.64,
    134108.65000000002, 126123.51000000001, 114002.19999999998, 127528.21, 128321.14,
    126442.93, 119964.94, 128450.96999999999, 130325.76000000001, 131517.76,
    128172.09000000001, 140181.13, 129132.04000000001, 128590.01, 130519.35000000002,
    137461.24000000002, 132539, 130125.6, 122677.09, 132642.40000000002, 137648.1,
    133860.63, 117680.96999999999, 130217.4, 131682.41999999998, 130814.99,
    123636.53, 131367.55000000002, 131112.61, 139348.67, 128087.99, 135311.43,
    128830.48999999999, 122039.59, 125798.37000000001, 148290.55, 140280.18,
    123903.96, 120386.62, 136312.96, 134867.26, 132522.30000000002, 125488.98,
    130055.88, 130228.17000000001, 134176.29, 119997.53, 119341.84,
    116211.75000000001, 119496.63, 121206.54, 133755.43000000002, 129782.48999999999,
    129769.26000000001, 124170.12, 131476.91, 134164.54, 135386.34,
    128581.55000000002, 142641.4, 135578.84, 131102.66, 133284.61, 150251.13,
    143453.73, 129637.69, 119796.65, 131452.96, 130921.40000000001,
    116696.48000000001, 106262.09999999999, 117506.93999999999, 125576.62000000001,
    122688.11, 116076.48, 118399.58000000002, 121153.27000000002, 128064.36,
    121915.06000000001, 131340.56, 129098.88, 127336.07000000002, 120606.56999999999,
    131564.09, 133914.9, 132897.25000000003, 123845.26999999999, 131608.31,
    128657.52000000002, 127127.04000000001, 125085.20999999999, 133691.38, 132486.75,
    138982.06000000003, 130633.36, 128191.74, 121943.96000000002, 126040.30999999998,
    115737.4, 115758.68999999999, 122328.9, 132831.57, 117425.20999999999, 117194.46,
    126411.70999999999, 136712.35, 126601.09, 139791.55000000002, 138781.76,
    135809.87, 125270.52, 136103.55, 125136.21, 120823.77, 116808.94, 122139.54,
    125605.77, 135387.11, 126665.42, 133198.47, 134095.24, 126567.84000000003,
    119407.93, 125231.35, 123116.65, 123070.14, 121314.07, 132248.18000000002,
    129679.32, 127984.74999999999, 119896.17, 118647.44, 118883.89000000001,
    130915.14, 129029.43, 132801.72, 126608.84, 126729.40999999999, 125551.64,
    129873.25, 125920.63, 124433.38000000002, 114577.25, 118140.36, 119565.06,
    121297.95999999999, 118451.43000000002, 117389.46, 117569.39, 125235.79000000001,
    119845.18000000001, 127410.62999999998, 127437.45000000001, 128702.49,
    115456.02999999998, 104319.33, 101906.54, 105183.59, 84666.53, 92076.12999999999,
    102900.85, 113082.3, 106517.20999999999, 116317.31000000001, 117293.89,
    121220.22, 114917.93999999999, 116283, 119756.14, 126316.02999999998, 119834.39,
    130021.09000000001, 124208.13, 117001.6, 107683.63, 118176.06000000001, 113207.4,
    116661.54999999999, 110873.88, 106771.98000000001, 105476.90000000001,
    106385.34000000001, 99372.43000000001, 97055.36000000002, 102052.03,
    116680.65999999999, 106354.81, 96297.23000000001, 102314.87000000001,
    103897.70000000001, 106517.90999999999, 105358.77, 103208.64, 115679.32,
    122435.20999999999, 126147.82, 123133.88999999998, 126440.61000000002, 128013.19,
    133676.97, 119981.73000000001, 114442.06999999998, 115493.5, 126632.44,
    134231.94, 130307.13, 123189.22000000002, 121820.51999999999, 106217.31,
    114559.47, 111790.61, 100002.56, 96630.03, 112380.87999999999, 105143.45,
    97553.29, 105976.01000000001, 112146.31999999999, 114821.47999999998, 119793,
    111052.93000000001, 109093.61, 108414.15, 106109.24, 105720.01999999999,
    109846.12999999999, 108816.90000000001, 119448.12, 120828.89000000001,
    116881.26999999999, 110459.37, 110657.15, 112698.44, 119071.29,
    114122.76000000001, 100274.19, 109052.84000000001, 110296.81999999999,
    102009.54999999999, 97110.95000000001, 98473.23000000001, 103679.18, 102790.58,
    93390.44999999998, 104307.73, 119272.82, 113371.28, 113413.05,
    101755.29000000001, 102314.81, 104380.37999999999, 114608.59, 110872.9,
    104462.96999999999, 106578.54000000001, 116650.67000000001, 111577.81, 107114.71,
    106178.54000000001, 107694.90999999999, 107832.38, 105890.86000000002, 104292.73,
    112409.34, 112434.31, 109814.57, 107672.31000000001, 112741.95000000001,
    111280.12999999999, 113750.5, 110587.44000000002, 99830.06000000001, 102869.91,
    108313.5, 106684.98, 107829.56, 98013.59, 91643.84999999999, 98775.17, 108507.13,
    103007.12000000002, 98457.83, 98245.56000000001, 102437.49, 100072.48999999999,
    97030.18, 94380.33, 99879.81, 97469.20000000001, 96794.26000000001,
    101199.17000000001, 101874.43, 102922.81000000003, 106132.23, 97718.12999999999,
    84630.18, 87972.63999999998, 97501.99, 83210.70999999999, 82822.9, 93396.73,
    107157.04000000001, 99487.42, 103225.06999999998, 103410.84, 101806.97999999998,
    99980.75, 101727.79000000001, 100589.05, 104825.27000000002, 99433.87999999999,
    86740.20999999999, 90903.78, 106535.15, 105861.51, 101095.90000000001, 103568.82,
    107116.26000000001, 101783.25, 106038.01, 105004.34999999999, 105868.99,
    102326.99, 93569.78000000001, 89589.18000000001, 91160, 90840.98, 86708.55,
    92692.68, 101010.72, 100372.2, 106968.66, 106732.91, 100727.73000000001,
    97700.42, 103581.06, 97122.68000000001, 97037.23000000001, 99155.28, 106954.33,
    105657.50000000001, 100867.97, 99720.40999999999, 99285.55000000002, 105784.44,
    119857.99, 112548.19, 109185.63, 100378.66, 98049.20000000001, 91342.49,
    83069.01, 88284.36000000002, 100640.22000000002, 98319.87, 81277.73,
    89101.29000000001, 102640.15999999999, 100671.71999999999, 94501.66, 96737.75,
    103485.92, 101015.88, 94019.83, 96160.43000000001, 92774.32999999999,
    93890.56000000001, 96882.25, 95928.79, 94419.43000000001, 98102.62999999999,
    99700.26000000001, 102804.44999999998, 107764.79000000001, 104607.39000000001,
    103904.78, 102267.40000000001, 95976.82, 87028.77, 86428.02999999998, 89222.82,
    90188.78, 81788.94, 87337.34999999999, 93053.23, 90059.62, 96956.91,
    98681.54999999999, 98922.98, 103003.56999999998, 104050.16999999998, 111034.54,
    112108.88, 111075.63, 107329.90999999999, 114114.92000000001, 115106.36,
    107794.95, 100839.93000000001, 110602.39000000001, 106077.68, 96789.84999999999,
    88586.81, 101914.92999999998, 98233.09999999999, 92290.97, 89605.48, 96940.06,
    98264.01, 93558.81, 87358.08, 84842.38999999998, 96206.20000000001,
    95588.20999999999, 91635.03, 103779.24000000002, 100493.03, 86531.66,
    83473.55000000002, 99924.65000000001, 98202.56, 89188.9, 85775.6,
    100666.31999999999, 103577.82999999999, 94747.61000000002, 88998.17,
    103034.78000000003, 101083.88999999998, 94773.55, 93844.95999999999, 105637.43,
    101421.23, 93274.90000000001, 90250.68, 96633.47, 92671.18, 98029.77,
    92024.08000000002, 81593.82, 82136.01000000001, 87768.49, 86888.49,
    102481.90999999999, 106589.01999999999, 104871.39000000001, 97230.28, 106239.26,
    103951.93000000002, 96450.12, 94966.73, 110716.83, 110727.22999999998, 93525.5,
    86814.9, 99737.84999999999, 102537.39, 95252.35, 91045.62, 103263.05, 100459.53,
    95110.29999999999, 89042.87, 84575.54999999999, 90970.64, 102516.48,
    92849.67000000001, 92285.64, 93547.92000000001, 95450.69, 93479.28,
    109992.67000000001, 102845.4, 88923.54000000001, 85447.91, 88114.54000000001,
    89020.23999999999, 93437.65999999999, 91844.41, 95770.45999999999,
    98330.81000000001, 95553.62, 92181.78, 106535.23000000001, 102407.73999999999,
    89014.20999999999, 82963.65999999999, 95256.47, 91833.61, 87502.59, 75467.59,
    72846.90999999999, 82255.32, 90413.03, 69868.14, 70962.53, 79026.31, 86524.09,
    82609.12, 95036.34999999999, 92081.48, 82561.29000000001, 82548.85999999999,
    101195.07, 100356.32, 89246.15, 83677.42, 98568.56000000001, 102265.21999999999,
    95524.11, 86423.54000000001, 94622.97, 96752.64, 90746.44, 81665.31, 86418.8,
    82150.15, 77556.79, 74342.86, 68445.49999999999, 72705.05, 79241.71, 74092.62,
    63633.72000000001, 72219.97, 80346.22, 81832.01000000001, 91295.29,
    84690.01999999999, 78973.36999999998, 80756.49, 85547.51, 81794.89,
    79817.81000000001, 78924.07, 90891.02999999998, 85616, 78275.48999999999,
    78560.48, 94605.41, 93992.68999999999, 84428.07, 76497.51, 86097.09, 83995.54,
    80614.2, 76759.07, 89287.56000000001, 83306.53, 72358.31000000001,
    67028.07999999999, 66930.65000000001, 70502.43, 78105.04000000001, 73837.35,
    90350.82, 92324.73000000001, 82838.32, 80701, 90135.47, 84984.7,
    79984.51999999999, 79336.06, 93970.41, 94211.98, 85453.75, 72838.70999999999,
    79895.35, 81375.42000000001, 86847.59, 85370.68000000001, 92020.06999999999,
    89288.5, 88848.96, 75303.12, 69020.98999999999, 69171.90000000001, 79045.93,
    74435.46, 77199.59000000001, 83489.77, 84601.91000000002, 80713.73999999999,
    86909.5, 84427.33, 78788.3, 72553.15000000001, 81556.14000000001, 82076.59,
    79373.96999999999, 77482.77999999998, 89073.78, 85893.89, 79821.28, 73722.31,
    80923.67000000001, 78711.41, 73785.38999999998, 76451.43, 88542.89, 86939.83,
    81240.91, 76162.96, 73284.73, 74507.09, 81148.46, 77299.07, 74748.76999999999,
    82701.73, 81620.13, 77380.43, 86552.34000000001, 88489.23, 84129.09, 80062.37,
    79897.68, 82893.64, 84368.31, 78330.44, 92295.77, 91081.83, 86842.26, 80763.69,
    98689.1, 100390.86000000002, 92848.76000000001, 88725.26, 100716.97,
    97917.46999999999, 88687.34000000001, 80959.62, 76977.85, 80385.04999999999,
    80657.71, 75182.25, 75139.3, 84229.71, 85196.31999999999, 81379.16000000002,
    97027.53, 93700.14, 87403.74, 80666.06999999999, 96284.78000000001, 95937.81,
    86341.05, 85275.07, 93937.57, 91773.18, 94775.23, 86622.52, 98657.24,
    100067.43000000001, 94753.29000000001, 88976.24, 102383.02, 103180.65,
    100069.01000000001, 90569.89000000001, 99759.65, 101875.5, 95099.7, 90024.83,
    87221.20999999999, 90727.54999999999, 101164.21, 95676.51, 100447.99, 98218.5,
    92817.79999999999, 90815.70999999999, 96732.70000000001, 97291.5,
    93925.56000000001, 95023.87, 110500.97, 110657.48, 101895.27999999998, 97592.85,
    111171.76000000001, 108486.97000000002, 100205.89000000001, 95156.98999999999,
    109670.44999999998, 107290.26999999999, 98119.54999999999, 90405.65000000001,
    99146.38999999998, 98557.91, 97793.68, 91758.79, 90295.51000000001, 92838.81,
    100661.87999999999, 95847.73999999999, 102485.29999999999, 101437.32, 94910.5,
    91694.16999999998, 97686.62, 97669.59, 96159.86, 94916.51000000001, 108267.15,
    112282.46, 99394.66, 95479.32, 111961.96, 112927.93, 96095.48000000001, 92157.78,
    102995.46, 103474.87, 101799.79000000001, 86366.04999999999, 89723.74999999999,
    89202.92000000001, 95555.70999999999, 90373.57, 90090.51000000001, 95275.85,
    101835.01999999999, 102794.85, 122930.56, 117092.46, 102377.03999999998,
    91309.07999999999, 103457.85, 105285.58, 102663.1, 97802.5, 111923.29,
    114902.23000000001, 107627.92, 96523.91, 107951.32999999999, 103330.99999999999,
    95306.98999999999, 95573.90000000001, 107598.38, 103055.76, 94150.84, 88963.98,
    101120.3, 100293.97, 94663.34999999999, 89023.83, 97056.72, 103051.19, 94487.43,
    87165.37, 104520.22, 103233.09, 93931.50999999998, 91569.44, 106601.67000000001,
    105609.87999999998, 94156.16, 92444, 97627.08, 96004.78, 87818.11, 78538.21,
    93046.87, 99672.39, 102628.51999999999, 96607.06, 100016.74000000002, 106036.31,
    101848.23, 83830.5, 86664.72, 83802.83, 88317.98999999999, 81959.20000000001,
    83417.37999999999, 89666.62000000001, 87672.43, 91575.6, 107925.05000000002,
    104171.73, 90209.9, 87993.85, 103506.73999999999, 98584.06999999999,
    93586.73999999999, 89311.02, 99640.7, 97806.84, 91349.98999999999,
    89568.09999999999, 107632.63, 110035, 93731.57, 82370.32, 95622.65999999999,
    94685.03, 90461.72, 91188.51000000001, 101470.24, 100985.65, 93001.06999999999,
    84284.29000000001, 89768.15999999999, 94506.93, 90142.51000000001,
    90270.29999999999, 104696.76999999999, 100583.49, 90789.08, 92444.15, 109189.16,
    108949.75000000001, 103876.65, 98884.86, 109087.23999999999, 105905.69,
    98005.65999999999, 97451.51000000001, 97913.5, 97243.56, 102162.78,
    96044.48999999999, 105951.85, 104198.98999999999, 93873.78, 84377.48999999999,
    92993.34, 94356.77, 92837.22, 87839.12999999999, 88959.15, 98818.67, 94578.06,
    89549.19, 106373.75000000001, 102520.06, 93434.87, 91461.82999999999, 102328.87,
    101105.29000000001, 96770.37999999999, 91618.73, 101833.82999999999,
    99186.27999999998, 95180.38, 94940.43000000001, 106175.51, 102748.79, 95432.07,
    87009.94, 97442.03, 93801.24, 91073.70999999999, 88318.76000000001,
    87234.37999999999, 84852.26000000001, 89517.54999999999, 87340.6,
    84445.53000000001, 91704.98, 96996.39000000001, 91558.96, 96449.56999999999,
    93163.94, 90407.90000000001, 88837.1, 95728.01999999999, 94877.29, 95335.12,
    95971.15000000001, 105704.91, 99136.68999999999, 96357.20000000001,
    91692.38999999998, 97958.95000000001, 100107.24, 94677.26999999999,
    92818.26000000001, 98285.62000000001, 95493.62000000001, 94352.86, 86814.65,
    86711.09000000001, 87222.79000000002, 91407.10999999999, 86996.82, 87983.52,
    90204.63, 91459.31, 88738.80000000002, 98885.34999999999, 99698.61000000002,
    94977.73, 91494.36, 99209.42000000001, 96426.93999999999, 92359.49, 90246.62,
    106116.98000000001, 107020.50999999998, 97723.15, 92674.56, 103131.13999999998,
    104712.79000000001, 99150.75, 88852.13999999998, 105256.70999999999, 107465,
    97635.58, 93167.01000000001, 95665.15999999999, 99894.16, 109005.66,
    107973.26999999999, 105344.91999999998, 110402.58000000002, 109651.91999999998,
    101400.79000000001, 106277, 114640.59000000001, 108084.01, 101846.92, 113587.04,
    108383.15999999999, 103209.52, 100924.33, 105647.21, 107235.21,
    106728.26999999999, 107533.37999999999, 111923.03, 110390.98000000001, 110154,
    109529.03, 111657.68999999999, 107510.58, 104189.3, 98679.34, 104719.54,
    103417.89, 103084.51, 100420.38, 98632.95999999999, 102167.79, 101238.9,
    101271.25, 111529.24999999997, 113551.37, 108645.15, 105924.34,
    112891.49999999999, 115270.21000000002, 106140.56, 101512.19, 115231.16,
    115634.34, 102319.19, 95650.51, 105125.54, 110528.94, 106275.53000000001,
    102560.18, 114736.16, 114918.31999999999, 119441.46999999999, 112483.97,
    109563.27, 118043, 110009.21, 100910.50000000001, 98388.12999999999, 104113.97,
    104612.84999999999, 103133.8, 113417.93999999997, 117802.96, 120458.41999999998,
    116117.54000000001, 115747.31, 111181.33000000002, 111131.00999999998, 109761.44,
    118763.51999999999, 119877.98999999999, 112042.97, 109081.43, 115574.93,
    113931.37, 104908.03, 99404.27, 105921.22, 101768.84999999999, 97057.13,
    95111.06999999998, 104431.27, 105875.68, 98046.23, 89672.12000000001,
    94587.29999999999, 99166.63, 99592.19, 102154.36, 119008, 114298.21, 102130.74,
    97539.42, 108487.99999999999, 108483.18000000001, 108285.29000000001,
    113518.30999999998, 119879.33000000002, 119490.94, 111281.70999999999,
    105551.82999999999, 111588.67000000001, 110223.62000000001, 105135.63999999998,
    98946.55, 104060.67000000001, 106329.70000000001, 104361.24, 103018.27999999998,
    104712.73000000001, 104058.70000000001, 106565.76999999999, 110810.3, 108344.59,
    108243.64, 107603.48, 106424.73999999999, 119284.55, 117701.73000000001,
    110185.61, 103803.12000000001, 110381.87, 117133.1, 121646.61,
    115251.18000000001, 126945.52, 124505.23999999999, 117541.56000000001,
    116417.87999999998, 132430.11000000002, 132274.34, 119595.26000000001, 107811.13,
    136081.88999999998, 142565, 131709.62, 120442.28, 115583.73999999999,
    114075.95999999999, 119956.56, 116599.79000000001, 130433.12, 137052.53,
    118978.07, 108260.91, 121787.37, 130541.40000000001, 125360.2, 115992.11,
    126381.1, 128644.45999999999, 116905.45999999999, 109465.37, 122937.54000000001,
    127197.65, 121010.37, 110930.64, 120864.65, 123733.1, 119656.26,
    108651.53000000001, 120926.76999999999, 112376.27, 103791.58000000002,
    95272.51000000001, 108934.51000000001, 116870.94, 115223.25, 111892.04,
    115511.95, 118456.48999999999, 116118.29, 112100.44, 115219.55999999998,
    115990.79, 117954.06, 118518.70999999999, 124544.34000000001, 126607.4,
    122231.49000000002, 107270.42000000001, 121305.59, 123940.20999999999, 111090.25,
    107548.70999999999, 117909.78, 114846.39, 116225.95000000001, 111988.04999999999,
    125567.54000000001, 125187.38, 121710.45000000001, 111776.56999999999,
    116367.36000000002, 121794.11000000002, 110876.75, 107581.94, 129741.4,
    137131.11000000002, 129293.54000000001, 120666.84, 124949.71000000002, 123881.15,
    121764.96000000002, 114708.04000000001, 115725.37, 117148.92, 123624.82,
    133975.46, 137157.5, 140408.87, 137217.21, 134054.87000000002, 147523.57,
    145239.35, 137591.93, 131198.52, 136103.97999999998, 131862.15,
    127230.55999999998, 134847.06000000003, 140354.29, 137014.33999999997,
    129396.25999999998, 114683.48000000001, 122635.32, 136527.79, 130472.41999999998,
    117049.34, 135671.33000000002, 134072.67, 124029.03, 115583.07, 132561.79,
    133998.54, 133333.05, 119222.22999999998, 123850, 119471.32999999999,
    113199.56000000001, 109962.10999999999, 129942.42, 132008.86000000002, 123520.78,
    122892.21, 136024.81999999998, 139076.34, 133919.24, 130900.73, 133084.5,
    133486.96000000002, 121108.31000000001, 121284.35, 122692.12000000001, 123386.31,
    116839.19, 118932.49, 126280.98999999999, 127276.76000000001, 133353.41999999998,
    134945.52, 138842.95, 138684.45, 133288.46, 123340.70999999999, 135081.01,
    137595.21, 131458.44999999998, 123359.08000000002, 127411.67, 130108.81,
    135878.59999999998, 126466.01999999999, 133682.49, 129889.20999999999,
    124384.54999999999, 120004.12, 130280.98000000001, 132571.78999999998, 131974.63,
    126360.01, 125121.25, 131035.73999999999, 138797.87000000002, 137650.38999999998,
    139946.53, 134903.3, 127485.25, 112821.48999999999, 120354.91,
    119800.84999999999, 116933.41, 112454.89000000001, 121674.1, 125150.54000000001,
    118567.94, 110998.04, 129661.76999999999, 127295.3, 125498.45000000001,
    128665.68, 142143.84, 143949.48, 140997.86000000002, 138102.95, 141918.97,
    143456.81999999998, 136592.63, 122819.07, 127681.50999999998, 147617.34999999998,
    136305.58999999997, 122247.45999999999, 153691.49, 154304.15, 148160.17,
    134049.54, 143581.37999999998, 136274.01, 130379.85, 118376.90000000001,
    137553.63, 149484.65000000002, 139368.2, 118117.1, 132282.75999999998, 131459.54,
    132996.22999999998, 135355.82000000004, 143462.52000000002, 139457.77000000002,
    137775.74000000002, 138961.02, 135657.47, 135319.1, 126241.65000000001,
    104351.72, 124508.61, 131190.52, 123798.9, 116650.08, 127675.51999999999,
    130827.35999999999, 123075.35, 117292.73000000001, 125319.95, 139678.58000000002,
    139515.04, 124649.58, 125009.76000000001, 125822.06, 123791.66999999998,
    118528.53, 121852.22000000002, 121891.50000000001, 116095.63, 106566.80999999998,
    114146.99, 116816.06, 115737.13, 117676.31000000001, 127433.04000000001,
    136000.53, 129150.58, 116739.12000000001, 126542.51999999999, 134848.12,
    132034.32, 121273.03, 133390.09, 131333.77, 123819.62000000001,
    116601.77000000002, 127184.6, 135154.71000000002, 130570.47,
  ],
};
